var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _construct = require("/app/node_modules/@babel/runtime/helpers/construct");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.joi = t() : e.joi = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(s) {
      if (t[s]) return t[s].exports;
      var n = t[s] = {
        i: s,
        l: !1,
        exports: {}
      };
      return e[s].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, s) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: s
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var s = Object.create(null);
      if (r.r(s), Object.defineProperty(s, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        r.d(s, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return s;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 11);
  }([function (e, t, r) {
    "use strict";

    var s = r(12);

    e.exports = function (e) {
      if (!e) {
        for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          t[_key - 1] = arguments[_key];
        }

        if (1 === t.length && t[0] instanceof Error) throw t[0];
        throw new s(t);
      }
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(12),
        o = r(29);
    var a, i;
    var l = {
      isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
    };
    t.version = o.version, t.defaults = {
      abortEarly: !0,
      allowUnknown: !1,
      cache: !0,
      context: null,
      convert: !0,
      dateFormat: "iso",
      errors: {
        escapeHtml: !1,
        label: "path",
        language: null,
        render: !0,
        stack: !1,
        wrap: {
          label: '"',
          array: "[]"
        }
      },
      externals: !0,
      messages: {},
      nonEnumerables: !1,
      noDefaults: !1,
      presence: "optional",
      skipFunctions: !1,
      stripUnknown: !1,
      warnings: !1
    }, t.symbols = {
      any: Symbol.for("@hapi/joi/schema"),
      arraySingle: Symbol("arraySingle"),
      deepDefault: Symbol("deepDefault"),
      literal: Symbol("literal"),
      override: Symbol("override"),
      prefs: Symbol("prefs"),
      ref: Symbol("ref"),
      values: Symbol("values"),
      template: Symbol("template")
    }, t.assertOptions = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Options";
      s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
      var n = Object.keys(e).filter(function (e) {
        return !t.includes(e);
      });
      s(0 === n.length, "".concat(r, " contain unknown keys: ").concat(n));
    }, t.checkPreferences = function (e) {
      i = i || r(16);
      var t = i.preferences.validate(e);
      if (t.error) throw new n([t.error.details[0].message]);
    }, t.compare = function (e, t, r) {
      switch (r) {
        case "=":
          return e === t;

        case ">":
          return e > t;

        case "<":
          return e < t;

        case ">=":
          return e >= t;

        case "<=":
          return e <= t;
      }
    }, t.default = function (e, t) {
      return void 0 === e ? t : e;
    }, t.isIsoDate = function (e) {
      return l.isoDate.test(e);
    }, t.isNumber = function (e) {
      return "number" == typeof e && !isNaN(e);
    }, t.isResolvable = function (e) {
      return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
    }, t.isSchema = function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = e && e[t.symbols.any];
      return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
    }, t.isValues = function (e) {
      return e[t.symbols.values];
    }, t.limit = function (e) {
      return Number.isSafeInteger(e) && e >= 0;
    }, t.preferences = function (e, s) {
      a = a || r(9), e = e || {}, s = s || {};
      var n = Object.assign({}, e, s);
      return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = a.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
    }, t.tryWithPath = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      try {
        return e();
      } catch (e) {
        throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
      }
    }, t.validateArg = function (e, r, _ref) {
      var s = _ref.assert,
          n = _ref.message;

      if (t.isSchema(s)) {
        var _t = s.validate(e);

        if (!_t.error) return;
        return _t.error.message;
      }

      if (!s(e)) return r ? "".concat(r, " ").concat(n) : n;
    }, t.verifyFlat = function (e, t) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _r = _step.value;
          s(!Array.isArray(_r), "Method no longer accepts array arguments:", t);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(6),
        n = r(13),
        o = r(14),
        a = {
      needsProtoHack: new Set([n.set, n.map, n.weakSet, n.weakMap])
    };
    e.exports = a.clone = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if ("object" != typeof e || null === e) return e;
      var s = a.clone,
          i = r;

      if (t.shallow) {
        if (!0 !== t.shallow) return a.cloneWithShallow(e, t);

        s = function s(e) {
          return e;
        };
      } else if (i) {
        var _t2 = i.get(e);

        if (_t2) return _t2;
      } else i = new Map();

      var l = n.getInternalProto(e);
      if (l === n.buffer) return !1;
      if (l === n.date) return new Date(e.getTime());
      if (l === n.regex) return new RegExp(e);
      var c = a.base(e, l, t);
      if (c === e) return e;

      if (i && i.set(e, c), l === n.set) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = e[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _r2 = _step2.value;
            c.add(s(_r2, t, i));
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else if (l === n.map) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = e[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = _slicedToArray(_step3.value, 2),
                _r3 = _step3$value[0],
                _n = _step3$value[1];

            c.set(_r3, s(_n, t, i));
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      var u = o.keys(e, t);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = u[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _r4 = _step4.value;

          if (l === n.array && "length" === _r4) {
            c.length = e.length;
            continue;
          }

          var _o = Object.getOwnPropertyDescriptor(e, _r4);

          _o ? _o.get || _o.set ? Object.defineProperty(c, _r4, _o) : _o.enumerable ? c[_r4] = s(e[_r4], t, i) : Object.defineProperty(c, _r4, {
            enumerable: !1,
            writable: !0,
            configurable: !0,
            value: s(e[_r4], t, i)
          }) : Object.defineProperty(c, _r4, {
            enumerable: !0,
            writable: !0,
            configurable: !0,
            value: s(e[_r4], t, i)
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return c;
    }, a.cloneWithShallow = function (e, t) {
      var r = t.shallow;
      (t = Object.assign({}, t)).shallow = !1;
      var n = new Map();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = r[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _t3 = _step5.value;

          var _r5 = s(e, _t3);

          "object" != typeof _r5 && "function" != typeof _r5 || n.set(_r5, _r5);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return a.clone(e, t, n);
    }, a.base = function (e, t, r) {
      if (!1 === r.prototype) return a.needsProtoHack.has(t) ? new t.constructor() : t === n.array ? [] : {};
      var s = Object.getPrototypeOf(e);
      if (s && s.isImmutable) return e;

      if (t === n.array) {
        var _e = [];
        return s !== t && Object.setPrototypeOf(_e, s), _e;
      }

      if (a.needsProtoHack.has(t)) {
        var _e2 = new s.constructor();

        return s !== t && Object.setPrototypeOf(_e2, s), _e2;
      }

      return Object.create(s);
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(34),
        o = r(1),
        a = r(9);
    e.exports = n.extend({
      type: "any",
      flags: {
        only: {
          default: !1
        }
      },
      terms: {
        alterations: {
          init: null
        },
        examples: {
          init: null
        },
        externals: {
          init: null
        },
        metas: {
          init: []
        },
        notes: {
          init: []
        },
        shared: {
          init: null
        },
        tags: {
          init: []
        },
        whens: {
          init: null
        }
      },
      rules: {
        custom: {
          method: function method(e, t) {
            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
              name: "custom",
              args: {
                method: e,
                description: t
              }
            });
          },
          validate: function validate(e, t, _ref2) {
            var r = _ref2.method;

            try {
              return r(e, t);
            } catch (e) {
              return t.error("any.custom", {
                error: e
              });
            }
          },
          args: ["method", "description"],
          multi: !0
        },
        messages: {
          method: function method(e) {
            return this.prefs({
              messages: e
            });
          }
        },
        shared: {
          method: function method(e) {
            s(o.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
            var t = this.clone();
            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
          }
        },
        warning: {
          method: function method(e, t) {
            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
              name: "warning",
              args: {
                code: e,
                local: t
              },
              warn: !0
            });
          },
          validate: function validate(e, t, _ref3) {
            var r = _ref3.code,
                s = _ref3.local;
            return t.error(r, s);
          },
          args: ["code", "local"],
          multi: !0
        }
      },
      modifiers: {
        keep: function keep(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          e.keep = t;
        },
        message: function message(e, t) {
          e.message = a.compile(t);
        },
        warn: function warn(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          e.warn = t;
        }
      },
      manifest: {
        build: function build(e, t) {
          for (var _r6 in t) {
            var _s = t[_r6];

            if (["examples", "externals", "metas", "notes", "tags"].includes(_r6)) {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = _s[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var _t4 = _step6.value;
                  e = e[_r6.slice(0, -1)](_t4);
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            } else if ("alterations" !== _r6) {
              if ("whens" !== _r6) {
                if ("shared" === _r6) {
                  var _iteratorNormalCompletion7 = true;
                  var _didIteratorError7 = false;
                  var _iteratorError7 = undefined;

                  try {
                    for (var _iterator7 = _s[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                      var _t5 = _step7.value;
                      e = e.shared(_t5);
                    }
                  } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                        _iterator7.return();
                      }
                    } finally {
                      if (_didIteratorError7) {
                        throw _iteratorError7;
                      }
                    }
                  }
                }
              } else {
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                  for (var _iterator8 = _s[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var _t6 = _step8.value;
                    var _r7 = _t6.ref,
                        _s2 = _t6.is,
                        _n2 = _t6.not,
                        _o2 = _t6.then,
                        _a = _t6.otherwise,
                        i = _t6.concat;
                    e = i ? e.concat(i) : _r7 ? e.when(_r7, {
                      is: _s2,
                      not: _n2,
                      then: _o2,
                      otherwise: _a,
                      switch: _t6.switch,
                      break: _t6.break
                    }) : e.when(_s2, {
                      then: _o2,
                      otherwise: _a,
                      break: _t6.break
                    });
                  }
                } catch (err) {
                  _didIteratorError8 = true;
                  _iteratorError8 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                      _iterator8.return();
                    }
                  } finally {
                    if (_didIteratorError8) {
                      throw _iteratorError8;
                    }
                  }
                }
              }
            } else {
              var _t7 = {};
              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = _s[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var _step9$value = _step9.value,
                      _e3 = _step9$value.target,
                      _r8 = _step9$value.adjuster;
                  _t7[_e3] = _r8;
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }

              e = e.alter(_t7);
            }
          }

          return e;
        }
      },
      messages: {
        "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
        "any.default": "{{#label}} threw an error when running default method",
        "any.failover": "{{#label}} threw an error when running failover method",
        "any.invalid": "{{#label}} contains an invalid value",
        "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
        "any.ref": '{{#label}} {{#arg}} references "{{#ref}}" which {{#reason}}',
        "any.required": "{{#label}} is required",
        "any.unknown": "{{#label}} is not allowed"
      }
    });
  }, function (e, t, r) {
    "use strict";

    var s = r(32),
        n = r(1),
        o = r(7);
    t.Report =
    /*#__PURE__*/
    function () {
      function _class(e, r, s, n, o, a, i) {
        _classCallCheck(this, _class);

        if (this.code = e, this.flags = n, this.messages = o, this.path = a.path, this.prefs = i, this.state = a, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
          var _e4 = this.path[this.path.length - 1];
          "object" != typeof _e4 && (this.local.key = _e4);
        }
      }

      _createClass(_class, [{
        key: "_setTemplate",
        value: function _setTemplate(e) {
          if (this.template = e, !this.flags.label && 0 === this.path.length) {
            var _e5 = this._template(this.template, "root");

            _e5 && (this.local.label = _e5);
          }
        }
      }, {
        key: "toString",
        value: function toString() {
          if (this.message) return this.message;
          var e = this.code;
          if (!this.prefs.errors.render) return this.code;

          var t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);

          return void 0 === t ? 'Error code "'.concat(e, '" is not defined, your custom type is missing the correct messages definition') : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
            errors: this.prefs.errors,
            messages: [this.prefs.messages, this.messages]
          }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
        }
      }, {
        key: "_template",
        value: function _template(e, r) {
          return t.template(this.value, e, r || this.code, this.state, this.prefs);
        }
      }]);

      return _class;
    }(), t.path = function (e) {
      var t = "";
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = e[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var _r9 = _step10.value;
          "object" != typeof _r9 && ("string" == typeof _r9 ? (t && (t += "."), t += _r9) : t += "[".concat(_r9, "]"));
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return t;
    }, t.template = function (e, t, r, s, a) {
      if (!t) return;
      if (o.isTemplate(t)) return "root" !== r ? t : null;
      var i = a.errors.language;
      return n.isResolvable(i) && (i = i.resolve(e, s, a)), i && t[i] && void 0 !== t[i][r] ? t[i][r] : t[r];
    }, t.label = function (e, r, s, n) {
      if (e.label) return e.label;
      if (!s.errors.label) return "";
      var o = r.path;
      "key" === s.errors.label && r.path.length > 1 && (o = r.path.slice(-1));
      var a = t.path(o);
      return a || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
    }, t.process = function (e, r, s) {
      if (!e) return null;

      var _t$details = t.details(e),
          n = _t$details.override,
          o = _t$details.message,
          a = _t$details.details;

      if (n) return n;
      if (s.errors.stack) return new t.ValidationError(o, a, r);
      var i = Error.stackTraceLimit;
      Error.stackTraceLimit = 0;
      var l = new t.ValidationError(o, a, r);
      return Error.stackTraceLimit = i, l;
    }, t.details = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var r = [];
      var s = [];
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = e[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var _n3 = _step11.value;

          if (_n3 instanceof Error) {
            if (!1 !== t.override) return {
              override: _n3
            };

            var _e7 = _n3.toString();

            r.push(_e7), s.push({
              message: _e7,
              type: "override",
              context: {
                error: _n3
              }
            });
            continue;
          }

          var _e6 = _n3.toString();

          r.push(_e6), s.push({
            message: _e6,
            path: _n3.path.filter(function (e) {
              return "object" != typeof e;
            }),
            type: _n3.code,
            context: _n3.local
          });
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return r.length > 1 && (r = _toConsumableArray(new Set(r))), {
        message: r.join(". "),
        details: s
      };
    }, t.ValidationError =
    /*#__PURE__*/
    function (_Error) {
      _inherits(_class2, _Error);

      function _class2(e, t, r) {
        var _this;

        _classCallCheck(this, _class2);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, e)), _this._original = r, _this.details = t;
        return _this;
      }

      _createClass(_class2, null, [{
        key: "isError",
        value: function isError(e) {
          return e instanceof t.ValidationError;
        }
      }]);

      return _class2;
    }(_wrapNativeSuper(Error)), t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(6),
        a = r(1);
    var i;
    var l = {
      symbol: Symbol("ref"),
      defaults: {
        adjust: null,
        in: !1,
        iterables: null,
        map: null,
        separator: ".",
        type: "value"
      }
    };
    t.create = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      s("string" == typeof e, "Invalid reference key:", e), a.assertOptions(t, ["adjust", "ancestor", "in", "iterables", "map", "prefix", "separator"]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
      var r = Object.assign({}, l.defaults, t);
      delete r.prefix;
      var n = r.separator,
          o = l.context(e, n, t.prefix);
      if (r.type = o.type, e = o.key, "value" === r.type) if (o.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");else {
        var _l$ancestor = l.ancestor(e, n),
            _l$ancestor2 = _slicedToArray(_l$ancestor, 2),
            _t8 = _l$ancestor2[0],
            _s3 = _l$ancestor2[1];

        _s3 && "" === (e = e.slice(_s3)) && (e = null), r.ancestor = _t8;
      }
      return r.path = n ? null === e ? [] : e.split(n) : [e], new l.Ref(r);
    }, t.in = function (e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return t.create(e, Object.assign({}, r, {
        in: !0
      }));
    }, t.isRef = function (e) {
      return !!e && !!e[a.symbols.ref];
    }, l.Ref =
    /*#__PURE__*/
    function () {
      function _class3(e) {
        _classCallCheck(this, _class3);

        s("object" == typeof e, "Invalid reference construction"), a.assertOptions(e, ["adjust", "ancestor", "in", "iterables", "map", "path", "separator", "type", "depth", "key", "root", "display"]), s([!1, void 0].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
      }

      _createClass(_class3, [{
        key: "resolve",
        value: function resolve(e, t, r, n) {
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          return s(!this.in || o.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, o) : "local" === this.type ? this._resolve(n, t, o) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, o) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, o)) : this._resolve(e, t, o);
        }
      }, {
        key: "_resolve",
        value: function _resolve(e, t, r) {
          var s;

          if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = o(e, this.path, {
            iterables: this.iterables,
            functions: !0
          })), this.adjust && (s = this.adjust(s)), this.map) {
            var _e8 = this.map.get(s);

            void 0 !== _e8 && (s = _e8);
          }

          return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.display;
        }
      }, {
        key: "absolute",
        value: function absolute(e) {
          return [].concat(_toConsumableArray(e.path.slice(0, -this.ancestor)), _toConsumableArray(this.path));
        }
      }, {
        key: "clone",
        value: function clone() {
          return new l.Ref(this);
        }
      }, {
        key: "describe",
        value: function describe() {
          var e = {
            path: this.path
          };
          "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = _toConsumableArray(this.map));

          for (var _i = 0, _arr = ["adjust", "iterables"]; _i < _arr.length; _i++) {
            var _t9 = _arr[_i];
            null !== this[_t9] && (e[_t9] = this[_t9]);
          }

          return !1 !== this.in && (e.in = !0), {
            ref: e
          };
        }
      }, {
        key: "updateDisplay",
        value: function updateDisplay() {
          var e = null !== this.key ? this.key : "";
          if ("value" !== this.type) return void (this.display = "ref:".concat(this.type, ":").concat(e));
          if (!this.separator) return void (this.display = "ref:".concat(e));
          if (!this.ancestor) return void (this.display = "ref:".concat(this.separator).concat(e));
          if ("root" === this.ancestor) return void (this.display = "ref:root:".concat(e));
          if (1 === this.ancestor) return void (this.display = "ref:".concat(e || ".."));
          var t = new Array(this.ancestor + 1).fill(this.separator).join("");
          this.display = "ref:".concat(t).concat(e || "");
        }
      }]);

      return _class3;
    }(), l.Ref.prototype[a.symbols.ref] = !0, t.build = function (e) {
      return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
    }, l.context = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (e = e.trim(), r) {
        var _s4 = void 0 === r.global ? "$" : r.global;

        if (_s4 !== t && e.startsWith(_s4)) return {
          key: e.slice(_s4.length),
          type: "global"
        };

        var _n4 = void 0 === r.local ? "#" : r.local;

        if (_n4 !== t && e.startsWith(_n4)) return {
          key: e.slice(_n4.length),
          type: "local"
        };

        var _o3 = void 0 === r.root ? "/" : r.root;

        if (_o3 !== t && e.startsWith(_o3)) return {
          key: e.slice(_o3.length),
          type: "value",
          root: !0
        };
      }

      return {
        key: e,
        type: "value"
      };
    }, l.ancestor = function (e, t) {
      if (!t) return [1, 0];
      if (e[0] !== t) return [1, 0];
      if (e[1] !== t) return [0, 1];
      var r = 2;

      for (; e[r] === t;) {
        ++r;
      }

      return [r - 1, r];
    }, t.toSibling = 0, t.toParent = 1, t.Manager =
    /*#__PURE__*/
    function () {
      function _class4() {
        _classCallCheck(this, _class4);

        this.refs = [];
      }

      _createClass(_class4, [{
        key: "register",
        value: function register(e, s) {
          if (e) if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) {
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = e[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var _t10 = _step12.value;
                this.register(_t10, s);
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          } else if (a.isSchema(e)) {
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = e._refs.refs[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var _t11 = _step13.value;
                _t11.ancestor - s >= 0 && this.refs.push({
                  ancestor: _t11.ancestor - s,
                  root: _t11.root
                });
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }
          } else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
            ancestor: e.ancestor - s,
            root: e.root
          }), i = i || r(7), i.isTemplate(e) && this.register(e.refs(), s);
        }
      }, {
        key: "clone",
        value: function clone() {
          var e = new t.Manager();
          return e.refs = n(this.refs), e;
        }
      }, {
        key: "reset",
        value: function reset() {
          this.refs = [];
        }
      }, {
        key: "roots",
        value: function roots() {
          return this.refs.filter(function (e) {
            return !e.ancestor;
          }).map(function (e) {
            return e.root;
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this.refs.length;
        }
      }]);

      return _class4;
    }();
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = {};
    e.exports = function (e, t, r) {
      if (!1 === t || null == t) return e;
      "string" == typeof (r = r || {}) && (r = {
        separator: r
      });
      var o = Array.isArray(t);
      s(!o || !r.separator, "Separator option no valid for array-based chain");
      var a = o ? t : t.split(r.separator || ".");
      var i = e;

      for (var _e9 = 0; _e9 < a.length; ++_e9) {
        var _o4 = a[_e9];
        var l = r.iterables && n.iterables(i);

        if (Array.isArray(i) || "set" === l) {
          var _e10 = Number(_o4);

          Number.isInteger(_e10) && (_o4 = _e10 < 0 ? i.length + _e10 : _e10);
        }

        if (!i || "function" == typeof i && !1 === r.functions || !l && void 0 === i[_o4]) {
          s(!r.strict || _e9 + 1 === a.length, "Missing segment", _o4, "in reach path ", t), s("object" == typeof i || !0 === r.functions || "function" != typeof i, "Invalid segment", _o4, "in reach path ", t), i = r.default;
          break;
        }

        i = l ? "set" === l ? _toConsumableArray(i)[_o4] : i.get(_o4) : i[_o4];
      }

      return i;
    }, n.iterables = function (e) {
      return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(30),
        a = r(31),
        i = r(1),
        l = r(4),
        c = r(5),
        u = {
      symbol: Symbol("template"),
      opens: new Array(1e3).join("\0"),
      closes: new Array(1e3).join(""),
      dateFormat: {
        date: Date.prototype.toDateString,
        iso: Date.prototype.toISOString,
        string: Date.prototype.toString,
        time: Date.prototype.toTimeString,
        utc: Date.prototype.toUTCString
      }
    };
    e.exports = u.Template =
    /*#__PURE__*/
    function () {
      function _class5(e, t) {
        _classCallCheck(this, _class5);

        s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
      }

      _createClass(_class5, [{
        key: "_parse",
        value: function _parse() {
          if (!this.source.includes("{")) return;
          var e = u.encode(this.source),
              t = u.split(e);
          var r = !1;
          var s = [],
              n = t.shift();
          n && s.push(n);
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = t[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var _e11 = _step14.value;

              var _t12 = "{" !== _e11[0],
                  _n5 = _t12 ? "}" : "}}",
                  _o5 = _e11.indexOf(_n5);

              if (-1 === _o5 || "{" === _e11[1]) {
                s.push("{".concat(u.decode(_e11)));
                continue;
              }

              var _a2 = _e11.slice(_t12 ? 0 : 1, _o5),
                  _i2 = this._ref(u.decode(_a2), _t12);

              s.push(_i2), "string" != typeof _i2 && (r = !0);

              var _l = _e11.slice(_o5 + _n5.length);

              _l && s.push(u.decode(_l));
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }

          r ? this._template = s : this.rendered = s.join("");
        }
      }, {
        key: "describe",
        value: function describe() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (!this._settings && e.compact) return this.source;
          var t = {
            template: this.source
          };
          return this._settings && (t.options = this._settings), t;
        }
      }, {
        key: "isDynamic",
        value: function isDynamic() {
          return !!this._template;
        }
      }, {
        key: "refs",
        value: function refs() {
          if (!this._template) return;
          var e = [];
          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = this._template[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var _t13 = _step15.value;
              "string" != typeof _t13 && e.push.apply(e, _toConsumableArray(_t13.refs));
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }

          return e;
        }
      }, {
        key: "resolve",
        value: function resolve(e, t, r, s) {
          return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
        }
      }, {
        key: "_part",
        value: function _part(e) {
          var _e$ref;

          for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            t[_key2 - 1] = arguments[_key2];
          }

          return e.ref ? (_e$ref = e.ref).resolve.apply(_e$ref, t) : e.formula.evaluate(t);
        }
      }, {
        key: "render",
        value: function render(e, t, r, s) {
          var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          if (!this.isDynamic()) return this.rendered;
          var a = [];
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = this._template[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var _i3 = _step16.value;
              if ("string" == typeof _i3) a.push(_i3);else {
                var _l2 = this._part(_i3, e, t, r, s, n),
                    _c = u.stringify(_l2, r, n.errors);

                if (void 0 !== _c) {
                  var _e12 = _i3.raw || !1 === (n.errors && n.errors.escapeHtml) ? _c : o(_c),
                      _t14 = _i3.ref && "local" === _i3.ref.type && "label" === _i3.ref.key && r.errors.wrap.label;

                  a.push(u.wrap(_e12, _t14));
                }
              }
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }

          return a.join("");
        }
      }, {
        key: "_ref",
        value: function _ref(e, t) {
          var _this2 = this;

          var r = [],
              s = function s(e) {
            var t = c.create(e, _this2._settings);
            return r.push(t), function (e) {
              return t.resolve.apply(t, _toConsumableArray(e));
            };
          };

          try {
            var n = new a.Parser(e, {
              reference: s,
              functions: u.functions,
              constants: u.constants
            });
          } catch (t) {
            throw t.message = 'Invalid template variable "'.concat(e, '" fails due to: ').concat(t.message), t;
          }

          return n.single ? "reference" === n.single.type ? {
            ref: r[0],
            raw: t,
            refs: r
          } : u.stringify(n.single.value) : {
            formula: n,
            raw: t,
            refs: r
          };
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.source;
        }
      }], [{
        key: "date",
        value: function date(e, t) {
          return u.dateFormat[t.dateFormat].call(e);
        }
      }, {
        key: "build",
        value: function build(e) {
          return new u.Template(e.template, e.options);
        }
      }, {
        key: "isTemplate",
        value: function isTemplate(e) {
          return !!e && !!e[i.symbols.template];
        }
      }]);

      return _class5;
    }(), u.Template.prototype[i.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function (e) {
      return e.replace(/\\(\{+)/g, function (e, t) {
        return u.opens.slice(0, t.length);
      }).replace(/\\(\}+)/g, function (e, t) {
        return u.closes.slice(0, t.length);
      });
    }, u.decode = function (e) {
      return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
    }, u.split = function (e) {
      var t = [];
      var r = "";

      for (var _s5 = 0; _s5 < e.length; ++_s5) {
        var _n6 = e[_s5];

        if ("{" === _n6) {
          var _n7 = "";

          for (; _s5 + 1 < e.length && "{" === e[_s5 + 1];) {
            _n7 += "{", ++_s5;
          }

          t.push(r), r = _n7;
        } else r += _n6;
      }

      return t.push(r), t;
    }, u.wrap = function (e, t) {
      return t ? 1 === t.length ? "".concat(t).concat(e).concat(t) : "".concat(t[0]).concat(e).concat(t[1]) : e;
    }, u.stringify = function (e, t, r) {
      var s = typeof e;
      if (null === e) return "null";
      if ("string" === s) return e;
      if ("number" === s || "function" === s || "symbol" === s) return e.toString();
      if ("object" !== s) return JSON.stringify(e);
      if (e instanceof Date) return u.Template.date(e, t);

      if (e instanceof Map) {
        var _t15 = [];
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
          for (var _iterator17 = e.entries()[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
            var _step17$value = _slicedToArray(_step17.value, 2),
                _r10 = _step17$value[0],
                _s6 = _step17$value[1];

            _t15.push("".concat(_r10.toString(), " -> ").concat(_s6.toString()));
          }
        } catch (err) {
          _didIteratorError17 = true;
          _iteratorError17 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
              _iterator17.return();
            }
          } finally {
            if (_didIteratorError17) {
              throw _iteratorError17;
            }
          }
        }

        e = _t15;
      }

      if (!Array.isArray(e)) return e.toString();
      var n = "";
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = e[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var _s7 = _step18.value;
          n = n + (n.length ? ", " : "") + u.stringify(_s7, t, r);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      return u.wrap(n, t.errors.wrap.array);
    }, u.constants = {
      true: !0,
      false: !1,
      null: null,
      second: 1e3,
      minute: 6e4,
      hour: 36e5,
      day: 864e5
    }, u.functions = {
      if: function _if(e, t, r) {
        return e ? t : r;
      },
      msg: function msg(e) {
        var _this3 = _slicedToArray(this, 5),
            t = _this3[0],
            r = _this3[1],
            s = _this3[2],
            n = _this3[3],
            o = _this3[4],
            a = o.messages;

        if (!a) return "";
        var i = l.template(t, a[0], e, r, s) || l.template(t, a[1], e, r, s);
        return i ? i.render(t, r, s, n, o) : "";
      },
      number: function number(e) {
        return "number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null;
      }
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(1),
        o = r(5),
        a = {};
    t.schema = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      n.assertOptions(r, ["appendPath", "override"]);

      try {
        return a.schema(e, t, r);
      } catch (e) {
        throw r.appendPath && void 0 !== e.path && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
      }
    }, a.schema = function (e, t, r) {
      s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));

      var o = function o(t) {
        for (var _len3 = arguments.length, s = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          s[_key3 - 1] = arguments[_key3];
        }

        return !1 !== r.override ? t.valid.apply(t, [e.override].concat(s)) : t.valid.apply(t, s);
      };

      if (a.simple(t)) return o(e, t);
      if ("function" == typeof t) return e.custom(t);
      if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return o(e, t);
      if (n.isSchema(t)) return t;

      if (Array.isArray(t)) {
        var _iteratorNormalCompletion19 = true;
        var _didIteratorError19 = false;
        var _iteratorError19 = undefined;

        try {
          for (var _iterator19 = t[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
            var _e$alternatives;

            var _r11 = _step19.value;
            if (!a.simple(_r11)) return (_e$alternatives = e.alternatives()).try.apply(_e$alternatives, _toConsumableArray(t));
          }
        } catch (err) {
          _didIteratorError19 = true;
          _iteratorError19 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
              _iterator19.return();
            }
          } finally {
            if (_didIteratorError19) {
              throw _iteratorError19;
            }
          }
        }

        return o.apply(void 0, [e].concat(_toConsumableArray(t)));
      }

      return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? o(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
    }, t.ref = function (e, t) {
      return o.isRef(e) ? e : o.create(e, t);
    }, t.compile = function (e, r) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      n.assertOptions(o, ["legacy"]);
      var i = r && r[n.symbols.any];
      if (i) return s(o.legacy || i.version === n.version, "Cannot mix different versions of joi schemas:", i.version, n.version), r;
      if ("object" != typeof r || !o.legacy) return t.schema(e, r, {
        appendPath: !0
      });
      var l = a.walk(r);
      return l ? l.compile(l.root, r) : t.schema(e, r, {
        appendPath: !0
      });
    }, a.walk = function (e) {
      if ("object" != typeof e) return null;

      if (Array.isArray(e)) {
        var _iteratorNormalCompletion20 = true;
        var _didIteratorError20 = false;
        var _iteratorError20 = undefined;

        try {
          for (var _iterator20 = e[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
            var _t16 = _step20.value;

            var _e13 = a.walk(_t16);

            if (_e13) return _e13;
          }
        } catch (err) {
          _didIteratorError20 = true;
          _iteratorError20 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
              _iterator20.return();
            }
          } finally {
            if (_didIteratorError20) {
              throw _iteratorError20;
            }
          }
        }

        return null;
      }

      var t = e[n.symbols.any];
      if (t) return {
        root: e[t.root],
        compile: t.compile
      };
      s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");

      for (var _t17 in e) {
        var _r12 = a.walk(e[_t17]);

        if (_r12) return _r12;
      }

      return null;
    }, a.simple = function (e) {
      return null === e || ["boolean", "string", "number"].includes(typeof e);
    }, t.when = function (e, r, i) {
      if (void 0 === i && (s(r && "object" == typeof r, "Missing options"), i = r, r = o.create(".")), Array.isArray(i) && (i = {
        switch: i
      }), n.assertOptions(i, ["is", "not", "then", "otherwise", "switch", "break"]), n.isSchema(r)) return s(void 0 === i.is, '"is" can not be used with a schema condition'), s(void 0 === i.not, '"not" can not be used with a schema condition'), s(void 0 === i.switch, '"switch" can not be used with a schema condition'), a.condition(e, {
        is: r,
        then: i.then,
        otherwise: i.otherwise,
        break: i.break
      });

      if (s(o.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === i.not || void 0 === i.is, 'Cannot combine "is" with "not"'), void 0 === i.switch) {
        var _l3 = i;
        void 0 !== i.not && (_l3 = {
          is: i.not,
          then: i.otherwise,
          otherwise: i.then,
          break: i.break
        });
        var c = void 0 !== _l3.is ? e.$_compile(_l3.is) : e.$_root.invalid(null, !1, 0, "").required();
        return s(void 0 !== _l3.then || void 0 !== _l3.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === _l3.break || void 0 === _l3.then || void 0 === _l3.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === i.is || o.isRef(i.is) || n.isSchema(i.is) || (c = c.required()), a.condition(e, {
          ref: t.ref(r),
          is: c,
          then: _l3.then,
          otherwise: _l3.otherwise,
          break: _l3.break
        });
      }

      s(Array.isArray(i.switch), '"switch" must be an array'), s(void 0 === i.is, 'Cannot combine "switch" with "is"'), s(void 0 === i.not, 'Cannot combine "switch" with "not"'), s(void 0 === i.then, 'Cannot combine "switch" with "then"');
      var l = {
        ref: t.ref(r),
        switch: [],
        break: i.break
      };

      for (var _t18 = 0; _t18 < i.switch.length; ++_t18) {
        var _r13 = i.switch[_t18],
            _a3 = _t18 === i.switch.length - 1;

        n.assertOptions(_r13, _a3 ? ["is", "then", "otherwise"] : ["is", "then"]), s(void 0 !== _r13.is, 'Switch statement missing "is"'), s(void 0 !== _r13.then, 'Switch statement missing "then"');
        var _c2 = {
          is: e.$_compile(_r13.is),
          then: e.$_compile(_r13.then)
        };

        if (o.isRef(_r13.is) || n.isSchema(_r13.is) || (_c2.is = _c2.is.required()), _a3) {
          s(void 0 === i.otherwise || void 0 === _r13.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');

          var _t19 = void 0 !== i.otherwise ? i.otherwise : _r13.otherwise;

          void 0 !== _t19 && (s(void 0 === l.break, "Cannot specify both otherwise and break"), _c2.otherwise = e.$_compile(_t19));
        }

        l.switch.push(_c2);
      }

      return l;
    }, a.condition = function (e, t) {
      for (var _i4 = 0, _arr2 = ["then", "otherwise"]; _i4 < _arr2.length; _i4++) {
        var _r14 = _arr2[_i4];
        void 0 === t[_r14] ? delete t[_r14] : t[_r14] = e.$_compile(t[_r14]);
      }

      return t;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(7);
    t.compile = function (e, t) {
      if ("string" == typeof e) return s(!t, "Cannot set single message string"), new o(e);
      if (o.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
      s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};

      for (var _r15 in e) {
        var _n8 = e[_r15];

        if ("root" === _r15 || o.isTemplate(_n8)) {
          t[_r15] = _n8;
          continue;
        }

        if ("string" == typeof _n8) {
          t[_r15] = new o(_n8);
          continue;
        }

        s("object" == typeof _n8 && !Array.isArray(_n8), "Invalid message for", _r15);
        var a = _r15;

        for (_r15 in t[a] = t[a] || {}, _n8) {
          var _e14 = _n8[_r15];
          "root" === _r15 || o.isTemplate(_e14) ? t[a][_r15] = _e14 : (s("string" == typeof _e14, "Invalid message for", _r15, "in", a), t[a][_r15] = new o(_e14));
        }
      }

      return t;
    }, t.decompile = function (e) {
      var t = {};

      for (var _r16 in e) {
        var _s8 = e[_r16];

        if ("root" === _r16) {
          t[_r16] = _s8;
          continue;
        }

        if (o.isTemplate(_s8)) {
          t[_r16] = _s8.describe({
            compact: !0
          });
          continue;
        }

        var _n9 = _r16;

        for (_r16 in t[_n9] = {}, _s8) {
          var _e15 = _s8[_r16];
          "root" !== _r16 ? t[_n9][_r16] = _e15.describe({
            compact: !0
          }) : t[_n9][_r16] = _e15;
        }
      }

      return t;
    }, t.merge = function (e, r) {
      if (!e) return t.compile(r);
      if (!r) return e;
      if ("string" == typeof r) return new o(r);
      if (o.isTemplate(r)) return r;
      var a = n(e);

      for (var _e16 in r) {
        var _t20 = r[_e16];

        if ("root" === _e16 || o.isTemplate(_t20)) {
          a[_e16] = _t20;
          continue;
        }

        if ("string" == typeof _t20) {
          a[_e16] = new o(_t20);
          continue;
        }

        s("object" == typeof _t20 && !Array.isArray(_t20), "Invalid message for", _e16);
        var _n10 = _e16;

        for (_e16 in a[_n10] = a[_n10] || {}, _t20) {
          var _r17 = _t20[_e16];
          "root" === _e16 || o.isTemplate(_r17) ? a[_n10][_e16] = _r17 : (s("string" == typeof _r17, "Invalid message for", _e16, "in", _n10), a[_n10][_e16] = new o(_r17));
        }
      }

      return a;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(13),
        n = {
      mismatched: null
    };
    e.exports = function (e, t, r) {
      return r = Object.assign({
        prototype: !0
      }, r), !!n.isDeepEqual(e, t, r, []);
    }, n.isDeepEqual = function (e, t, r, o) {
      if (e === t) return 0 !== e || 1 / e == 1 / t;
      var a = typeof e;
      if (a !== typeof t) return !1;
      if (null === e || null === t) return !1;

      if ("function" === a) {
        if (!r.deepFunction || e.toString() !== t.toString()) return !1;
      } else if ("object" !== a) return e != e && t != t;

      var i = n.getSharedType(e, t, !!r.prototype);

      switch (i) {
        case s.buffer:
          return !1;

        case s.promise:
          return e === t;

        case s.regex:
          return e.toString() === t.toString();

        case n.mismatched:
          return !1;
      }

      for (var _r18 = o.length - 1; _r18 >= 0; --_r18) {
        if (o[_r18].isSame(e, t)) return !0;
      }

      o.push(new n.SeenEntry(e, t));

      try {
        return !!n.isDeepEqualObj(i, e, t, r, o);
      } finally {
        o.pop();
      }
    }, n.getSharedType = function (e, t, r) {
      if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
      var o = s.getInternalProto(e);
      return o !== s.getInternalProto(t) ? n.mismatched : o;
    }, n.valueOf = function (e) {
      var t = e.valueOf;
      if (void 0 === t) return e;

      try {
        return t.call(e);
      } catch (e) {
        return e;
      }
    }, n.hasOwnEnumerableProperty = function (e, t) {
      return Object.prototype.propertyIsEnumerable.call(e, t);
    }, n.isSetSimpleEqual = function (e, t) {
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = e[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var _r19 = _step21.value;
          if (!t.has(_r19)) return !1;
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      return !0;
    }, n.isDeepEqualObj = function (e, t, r, o, a) {
      var i = n.isDeepEqual,
          l = n.valueOf,
          c = n.hasOwnEnumerableProperty,
          u = Object.keys,
          f = Object.getOwnPropertySymbols;

      if (e === s.array) {
        if (!o.part) {
          if (t.length !== r.length) return !1;

          for (var _e17 = 0; _e17 < t.length; ++_e17) {
            if (!i(t[_e17], r[_e17], o, a)) return !1;
          }

          return !0;
        }

        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = t[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var _e18 = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = r[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var _t21 = _step23.value;
                if (i(_e18, _t21, o, a)) return !0;
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      } else if (e === s.set) {
        if (t.size !== r.size) return !1;

        if (!n.isSetSimpleEqual(t, r)) {
          var _e19 = new Set(r);

          var _iteratorNormalCompletion24 = true;
          var _didIteratorError24 = false;
          var _iteratorError24 = undefined;

          try {
            for (var _iterator24 = t[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
              var _r20 = _step24.value;
              if (_e19.delete(_r20)) continue;

              var _t22 = !1;

              var _iteratorNormalCompletion25 = true;
              var _didIteratorError25 = false;
              var _iteratorError25 = undefined;

              try {
                for (var _iterator25 = _e19[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                  var _s9 = _step25.value;

                  if (i(_r20, _s9, o, a)) {
                    _e19.delete(_s9), _t22 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError25 = true;
                _iteratorError25 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                    _iterator25.return();
                  }
                } finally {
                  if (_didIteratorError25) {
                    throw _iteratorError25;
                  }
                }
              }

              if (!_t22) return !1;
            }
          } catch (err) {
            _didIteratorError24 = true;
            _iteratorError24 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                _iterator24.return();
              }
            } finally {
              if (_didIteratorError24) {
                throw _iteratorError24;
              }
            }
          }
        }
      } else if (e === s.map) {
        if (t.size !== r.size) return !1;
        var _iteratorNormalCompletion26 = true;
        var _didIteratorError26 = false;
        var _iteratorError26 = undefined;

        try {
          for (var _iterator26 = t[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
            var _step26$value = _slicedToArray(_step26.value, 2),
                _e20 = _step26$value[0],
                _s10 = _step26$value[1];

            if (void 0 === _s10 && !r.has(_e20)) return !1;
            if (!i(_s10, r.get(_e20), o, a)) return !1;
          }
        } catch (err) {
          _didIteratorError26 = true;
          _iteratorError26 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
              _iterator26.return();
            }
          } finally {
            if (_didIteratorError26) {
              throw _iteratorError26;
            }
          }
        }
      } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;

      var m = l(t),
          h = l(r);
      if ((t !== m || r !== h) && !i(m, h, o, a)) return !1;
      var d = u(t);
      if (!o.part && d.length !== u(r).length && !o.skip) return !1;
      var p = 0;
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = d[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var _e23 = _step27.value;
          if (o.skip && o.skip.includes(_e23)) void 0 === r[_e23] && ++p;else {
            if (!c(r, _e23)) return !1;
            if (!i(t[_e23], r[_e23], o, a)) return !1;
          }
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      if (!o.part && d.length - p !== u(r).length) return !1;

      if (!1 !== o.symbols) {
        var _e21 = f(t),
            _s11 = new Set(f(r));

        var _iteratorNormalCompletion28 = true;
        var _didIteratorError28 = false;
        var _iteratorError28 = undefined;

        try {
          for (var _iterator28 = _e21[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
            var _n11 = _step28.value;
            if (!o.skip || !o.skip.includes(_n11)) if (c(t, _n11)) {
              if (!c(r, _n11)) return !1;
              if (!i(t[_n11], r[_n11], o, a)) return !1;
            } else if (c(r, _n11)) return !1;

            _s11.delete(_n11);
          }
        } catch (err) {
          _didIteratorError28 = true;
          _iteratorError28 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
              _iterator28.return();
            }
          } finally {
            if (_didIteratorError28) {
              throw _iteratorError28;
            }
          }
        }

        var _iteratorNormalCompletion29 = true;
        var _didIteratorError29 = false;
        var _iteratorError29 = undefined;

        try {
          for (var _iterator29 = _s11[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
            var _e22 = _step29.value;
            if (c(r, _e22)) return !1;
          }
        } catch (err) {
          _didIteratorError29 = true;
          _iteratorError29 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
              _iterator29.return();
            }
          } finally {
            if (_didIteratorError29) {
              throw _iteratorError29;
            }
          }
        }
      }

      return !0;
    }, n.SeenEntry =
    /*#__PURE__*/
    function () {
      function _class6(e, t) {
        _classCallCheck(this, _class6);

        this.obj = e, this.ref = t;
      }

      _createClass(_class6, [{
        key: "isSame",
        value: function isSame(e, t) {
          return this.obj === e && this.ref === t;
        }
      }]);

      return _class6;
    }();
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(15),
        a = r(1),
        i = r(8),
        l = r(4),
        c = r(17),
        u = r(18),
        f = r(5),
        m = r(7),
        h = r(19);
    var d;
    var p = {
      types: {
        alternatives: r(33),
        any: r(3),
        array: r(39),
        boolean: r(40),
        date: r(41),
        function: r(42),
        link: r(45),
        number: r(46),
        object: r(47),
        string: r(48),
        symbol: r(52)
      },
      aliases: {
        alt: "alternatives",
        bool: "boolean",
        func: "function"
      }
    };
    p.root = function () {
      var e = {
        _types: new Set(Object.keys(p.types))
      };
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        var _loop = function _loop() {
          var t = _step30.value;

          e[t] = function () {
            for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              e[_key4] = arguments[_key4];
            }

            return s(!e.length || ["alternatives", "link", "object"].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], e);
          };
        };

        for (var _iterator30 = e._types[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      var _loop2 = function _loop2() {
        var t = _arr3[_i5];

        e[t] = function () {
          var _this$any;

          return (_this$any = this.any())[t].apply(_this$any, arguments);
        };
      };

      for (var _i5 = 0, _arr3 = ["allow", "custom", "disallow", "equal", "exist", "forbidden", "invalid", "not", "only", "optional", "options", "prefs", "preferences", "required", "strip", "valid", "when"]; _i5 < _arr3.length; _i5++) {
        _loop2();
      }

      Object.assign(e, p.methods);

      for (var _t23 in p.aliases) {
        var _r21 = p.aliases[_t23];
        e[_t23] = e[_r21];
      }

      return e.x = e.expression, h.setup && h.setup(e), e;
    }, p.methods = {
      ValidationError: l.ValidationError,
      version: a.version,
      cache: o.provider,
      assert: function assert(e, t) {
        for (var _len5 = arguments.length, r = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
          r[_key5 - 2] = arguments[_key5];
        }

        p.assert(e, t, !0, r);
      },
      attempt: function attempt(e, t) {
        for (var _len6 = arguments.length, r = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
          r[_key6 - 2] = arguments[_key6];
        }

        return p.assert(e, t, !1, r);
      },
      build: function build(e) {
        return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
      },
      checkPreferences: function checkPreferences(e) {
        a.checkPreferences(e);
      },
      compile: function compile(e, t) {
        return i.compile(this, e, t);
      },
      defaults: function defaults(e) {
        s("function" == typeof e, "modifier must be a function");
        var t = Object.assign({}, this);
        var _iteratorNormalCompletion31 = true;
        var _didIteratorError31 = false;
        var _iteratorError31 = undefined;

        try {
          var _loop3 = function _loop3() {
            var r = _step31.value;
            var n = e(t[r]());
            s(a.isSchema(n), "modifier must return a valid schema object"), t[r] = function () {
              for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                e[_key7] = arguments[_key7];
              }

              return p.generate(this, n, e);
            };
          };

          for (var _iterator31 = t._types[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
            _loop3();
          }
        } catch (err) {
          _didIteratorError31 = true;
          _iteratorError31 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
              _iterator31.return();
            }
          } finally {
            if (_didIteratorError31) {
              throw _iteratorError31;
            }
          }
        }

        return t;
      },
      expression: function expression() {
        for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          e[_key8] = arguments[_key8];
        }

        return _construct(m, e);
      },
      extend: function extend() {
        var _this4 = this;

        for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          e[_key9] = arguments[_key9];
        }

        a.verifyFlat(e, "extend"), d = d || r(16), s(e.length, "You need to provide at least one extension"), this.assert(e, d.extensions);
        var t = Object.assign({}, this);
        t._types = new Set(t._types);

        for (var _i6 = 0, _e24 = e; _i6 < _e24.length; _i6++) {
          var _r22 = _e24[_i6];
          "function" == typeof _r22 && (_r22 = _r22(t)), this.assert(_r22, d.extension);

          var _e25 = p.expandExtension(_r22, t);

          var _iteratorNormalCompletion32 = true;
          var _didIteratorError32 = false;
          var _iteratorError32 = undefined;

          try {
            var _loop4 = function _loop4() {
              var r = _step32.value;
              s(void 0 === t[r.type] || t._types.has(r.type), "Cannot override name", r.type);

              var e = r.base || _this4.any(),
                  n = c.type(e, r);

              t._types.add(r.type), t[r.type] = function () {
                for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                  e[_key10] = arguments[_key10];
                }

                return p.generate(this, n, e);
              };
            };

            for (var _iterator32 = _e25[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
              _loop4();
            }
          } catch (err) {
            _didIteratorError32 = true;
            _iteratorError32 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
                _iterator32.return();
              }
            } finally {
              if (_didIteratorError32) {
                throw _iteratorError32;
              }
            }
          }
        }

        return t;
      },
      isError: l.ValidationError.isError,
      isExpression: m.isTemplate,
      isRef: f.isRef,
      isSchema: a.isSchema,
      in: function _in() {
        return f.in.apply(f, arguments);
      },
      override: a.symbols.override,
      ref: function ref() {
        return f.create.apply(f, arguments);
      },
      types: function types() {
        var e = {};
        var _iteratorNormalCompletion33 = true;
        var _didIteratorError33 = false;
        var _iteratorError33 = undefined;

        try {
          for (var _iterator33 = this._types[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
            var _t25 = _step33.value;
            e[_t25] = this[_t25]();
          }
        } catch (err) {
          _didIteratorError33 = true;
          _iteratorError33 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
              _iterator33.return();
            }
          } finally {
            if (_didIteratorError33) {
              throw _iteratorError33;
            }
          }
        }

        for (var _t24 in p.aliases) {
          e[_t24] = this[_t24]();
        }

        return e;
      }
    }, p.assert = function (e, t, r, s) {
      var o = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null,
          i = o ? s[1] : s[0],
          c = t.validate(e, a.preferences({
        errors: {
          stack: !0
        }
      }, i || {}));
      var u = c.error;
      if (!u) return c.value;
      if (o instanceof Error) throw o;
      var f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
      throw u instanceof l.ValidationError == !1 && (u = n(u)), u.message = o ? "".concat(o, " ").concat(f) : f, u;
    }, p.generate = function (e, t, r) {
      var _t$_definition;

      return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? (_t$_definition = t._definition).args.apply(_t$_definition, [t].concat(_toConsumableArray(r))) : t;
    }, p.expandExtension = function (e, t) {
      if ("string" == typeof e.type) return [e];
      var r = [];
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        for (var _iterator34 = t._types[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var _s12 = _step34.value;

          if (e.type.test(_s12)) {
            var _n12 = Object.assign({}, e);

            _n12.type = _s12, _n12.base = t[_s12](), r.push(_n12);
          }
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      return r;
    }, e.exports = p.root();
  }, function (e, t, r) {
    "use strict";

    var s = r(28);

    e.exports =
    /*#__PURE__*/
    function (_Error2) {
      _inherits(_class7, _Error2);

      function _class7(e) {
        var _this5;

        _classCallCheck(this, _class7);

        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(_class7).call(this, e.filter(function (e) {
          return "" !== e;
        }).map(function (e) {
          return "string" == typeof e ? e : e instanceof Error ? e.message : s(e);
        }).join(" ") || "Unknown error")), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_this5), t.assert);
        return _this5;
      }

      return _class7;
    }(_wrapNativeSuper(Error));
  }, function (e, t, r) {
    "use strict";

    var s = {};
    t = e.exports = {
      array: Array.prototype,
      buffer: !1,
      date: Date.prototype,
      error: Error.prototype,
      generic: Object.prototype,
      map: Map.prototype,
      promise: Promise.prototype,
      regex: RegExp.prototype,
      set: Set.prototype,
      weakMap: WeakMap.prototype,
      weakSet: WeakSet.prototype
    }, s.typeMap = new Map([["[object Error]", t.error], ["[object Map]", t.map], ["[object Promise]", t.promise], ["[object Set]", t.set], ["[object WeakMap]", t.weakMap], ["[object WeakSet]", t.weakSet]]), t.getInternalProto = function (e) {
      if (Array.isArray(e)) return t.array;
      if (e instanceof Date) return t.date;
      if (e instanceof RegExp) return t.regex;
      if (e instanceof Error) return t.error;
      var r = Object.prototype.toString.call(e);
      return s.typeMap.get(r) || t.generic;
    };
  }, function (e, t, r) {
    "use strict";

    t.keys = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return !1 !== t.symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(1),
        a = {
      max: 1e3,
      supported: new Set(["undefined", "boolean", "number", "string"])
    };
    t.provider = {
      provision: function provision(e) {
        return new a.Cache(e);
      }
    }, a.Cache =
    /*#__PURE__*/
    function () {
      function _class8() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class8);

        o.assertOptions(e, ["max"]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || a.max, this._map = new Map(), this._list = new a.List();
      }

      _createClass(_class8, [{
        key: "set",
        value: function set(e, t) {
          if (null !== e && !a.supported.has(typeof e)) return;

          var r = this._map.get(e);

          if (r) return r.value = t, void this._list.first(r);
          r = this._list.unshift({
            key: e,
            value: t
          }), this._map.set(e, r), this._compact();
        }
      }, {
        key: "get",
        value: function get(e) {
          var t = this._map.get(e);

          if (t) return this._list.first(t), n(t.value);
        }
      }, {
        key: "_compact",
        value: function _compact() {
          if (this._map.size > this._max) {
            var _e26 = this._list.pop();

            this._map.delete(_e26.key);
          }
        }
      }, {
        key: "length",
        get: function get() {
          return this._map.size;
        }
      }]);

      return _class8;
    }(), a.List =
    /*#__PURE__*/
    function () {
      function _class9() {
        _classCallCheck(this, _class9);

        this.tail = null, this.head = null;
      }

      _createClass(_class9, [{
        key: "unshift",
        value: function unshift(e) {
          return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
        }
      }, {
        key: "first",
        value: function first(e) {
          e !== this.head && (this._remove(e), this.unshift(e));
        }
      }, {
        key: "pop",
        value: function pop() {
          return this._remove(this.tail);
        }
      }, {
        key: "_remove",
        value: function _remove(e) {
          var t = e.next,
              r = e.prev;
          return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
        }
      }]);

      return _class9;
    }();
  }, function (e, t, r) {
    "use strict";

    var s = r(11),
        n = {};
    n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
      allowUnknown: s.boolean(),
      abortEarly: s.boolean(),
      cache: s.boolean(),
      context: s.object(),
      convert: s.boolean(),
      dateFormat: s.valid("date", "iso", "string", "time", "utc"),
      debug: s.boolean(),
      errors: {
        escapeHtml: s.boolean(),
        label: s.valid("path", "key", !1),
        language: [s.string(), s.object().ref()],
        render: s.boolean(),
        stack: s.boolean(),
        wrap: {
          label: n.wrap,
          array: n.wrap
        }
      },
      externals: s.boolean(),
      messages: s.object(),
      noDefaults: s.boolean(),
      nonEnumerables: s.boolean(),
      presence: s.valid("required", "optional", "forbidden"),
      skipFunctions: s.boolean(),
      stripUnknown: s.object({
        arrays: s.boolean(),
        objects: s.boolean()
      }).or("arrays", "objects").allow(!0, !1),
      warnings: s.boolean()
    }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
      alias: s.array().items(s.string().pattern(n.nameRx)).single(),
      args: s.array().items(s.string(), s.object({
        name: s.string().pattern(n.nameRx).required(),
        ref: s.boolean(),
        assert: s.alternatives([s.function(), s.object().schema()]).conditional("ref", {
          is: !0,
          then: s.required()
        }),
        normalize: s.function(),
        message: s.string().when("assert", {
          is: s.function(),
          then: s.required()
        })
      })),
      convert: s.boolean(),
      manifest: s.boolean(),
      method: s.function().allow(!1),
      multi: s.boolean(),
      validate: s.function()
    }), t.extension = s.object({
      type: s.alternatives([s.string(), s.object().regex()]).required(),
      args: s.function(),
      base: s.object().schema().when("type", {
        is: s.object().regex(),
        then: s.forbidden()
      }),
      coerce: [s.function().maxArity(3), s.object({
        method: s.function().maxArity(3).required(),
        from: s.array().items(s.string()).single()
      })],
      flags: s.object().pattern(n.nameRx, s.object({
        setter: s.string(),
        default: s.any()
      })),
      manifest: {
        build: s.function().arity(2)
      },
      messages: [s.object(), s.string()],
      modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
      overrides: s.object().pattern(n.nameRx, s.function()),
      prepare: s.function().maxArity(3),
      rebuild: s.function().arity(1),
      rules: s.object().pattern(n.nameRx, n.rule),
      terms: s.object().pattern(n.nameRx, s.object({
        init: s.array().allow(null).required(),
        manifest: s.object().pattern(/.+/, [s.valid("schema", "single"), s.object({
          mapped: s.object({
            from: s.string().required(),
            to: s.string().required()
          }).required()
        })])
      })),
      validate: s.function().maxArity(3)
    }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
      buffer: s.object({
        buffer: s.string()
      }),
      func: s.object({
        function: s.function().required(),
        options: {
          literal: !0
        }
      }),
      override: s.object({
        override: !0
      }),
      ref: s.object({
        ref: s.object({
          type: s.valid("value", "global", "local"),
          path: s.array().required(),
          separator: s.string().length(1).allow(!1),
          ancestor: s.number().min(0).integer().allow("root"),
          map: s.array().items(s.array().length(2)).min(1),
          adjust: s.function(),
          iterables: s.boolean(),
          in: s.boolean()
        }).required()
      }),
      regex: s.object({
        regex: s.string().min(3)
      }),
      special: s.object({
        special: s.valid("deep").required()
      }),
      template: s.object({
        template: s.string().required(),
        options: s.object()
      }),
      value: s.object({
        value: s.alternatives([s.object(), s.array()]).required()
      })
    }, n.desc.entity = s.alternatives([s.array().items(s.link("...")), s.boolean(), s.function(), s.number(), s.string(), n.desc.buffer, n.desc.func, n.desc.ref, n.desc.regex, n.desc.special, n.desc.template, n.desc.value, s.link("/")]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [s.string(), n.desc.template, s.object().pattern(/.+/, [s.string(), n.desc.template])]), t.description = s.object({
      type: s.string().required(),
      flags: s.object({
        cast: s.string(),
        default: s.any(),
        description: s.string(),
        empty: s.link("/"),
        failover: n.desc.entity,
        id: s.string(),
        label: s.string(),
        only: !0,
        presence: ["optional", "required", "forbidden"],
        result: ["raw", "strip"],
        strip: s.boolean(),
        unit: s.string()
      }).unknown(),
      preferences: {
        allowUnknown: s.boolean(),
        abortEarly: s.boolean(),
        cache: s.boolean(),
        convert: s.boolean(),
        dateFormat: ["date", "iso", "string", "time", "utc"],
        errors: {
          escapeHtml: s.boolean(),
          label: ["path", "key"],
          language: [s.string(), n.desc.ref],
          wrap: {
            label: n.wrap,
            array: n.wrap
          }
        },
        externals: s.boolean(),
        messages: n.desc.messages,
        noDefaults: s.boolean(),
        nonEnumerables: s.boolean(),
        presence: ["required", "optional", "forbidden"],
        skipFunctions: s.boolean(),
        stripUnknown: s.object({
          arrays: s.boolean(),
          objects: s.boolean()
        }).or("arrays", "objects").allow(!0, !1),
        warnings: s.boolean()
      },
      allow: n.desc.values,
      invalid: n.desc.values,
      rules: s.array().min(1).items({
        name: s.string().required(),
        args: s.object().min(1),
        keep: s.boolean(),
        message: [s.string(), n.desc.messages],
        warn: s.boolean()
      }),
      keys: s.object().pattern(/.*/, s.link("/")),
      link: n.desc.ref
    }).pattern(/^[a-z]\w*$/, s.any());
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(1),
        a = r(9),
        i = {};
    t.type = function (e, t) {
      var r = Object.getPrototypeOf(e),
          l = n(r),
          c = e._assign(Object.create(l)),
          u = Object.assign({}, t);

      delete u.base, l._definition = u;
      var f = r._definition || {};
      u.messages = a.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
      var m = Object.assign({}, f.terms);
      if (u.terms) for (var _e27 in u.terms) {
        var _t26 = u.terms[_e27];
        s(void 0 === c.$_terms[_e27], "Invalid term override for", u.type, _e27), c.$_terms[_e27] = _t26.init, m[_e27] = _t26;
      }
      u.terms = m, u.args || (u.args = f.args), u.prepare = i.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
        method: u.coerce
      }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
        method: u.coerce.method,
        from: [].concat(u.coerce.from)
      })), u.coerce = i.coerce(u.coerce, f.coerce), u.validate = i.validate(u.validate, f.validate);
      var h = Object.assign({}, f.rules);

      if (u.rules) {
        var _loop5 = function _loop5(_e28) {
          var t = u.rules[_e28];
          s("object" == typeof t, "Invalid rule definition for", u.type, _e28);
          var r = t.method;

          if (void 0 === r && (r = function r() {
            return this.$_addRule(_e28);
          }), r && (s(!l[_e28], "Rule conflict in", u.type, _e28), l[_e28] = r), s(!h[_e28], "Rule conflict in", u.type, _e28), h[_e28] = t, t.alias) {
            var _e29 = [].concat(t.alias);

            var _iteratorNormalCompletion35 = true;
            var _didIteratorError35 = false;
            var _iteratorError35 = undefined;

            try {
              for (var _iterator35 = _e29[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
                var _r23 = _step35.value;
                l[_r23] = t.method;
              }
            } catch (err) {
              _didIteratorError35 = true;
              _iteratorError35 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
                  _iterator35.return();
                }
              } finally {
                if (_didIteratorError35) {
                  throw _iteratorError35;
                }
              }
            }
          }

          t.args && (t.argsByName = new Map(), t.args = t.args.map(function (e) {
            return "string" == typeof e && (e = {
              name: e
            }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), o.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e;
          }));
        };

        for (var _e28 in u.rules) {
          _loop5(_e28);
        }
      }

      u.rules = h;
      var d = Object.assign({}, f.modifiers);

      if (u.modifiers) {
        var _loop6 = function _loop6(_e30) {
          s(!l[_e30], "Rule conflict in", u.type, _e30);
          var t = u.modifiers[_e30];
          s("function" == typeof t, "Invalid modifier definition for", u.type, _e30);

          var r = function r(t) {
            return this.rule(_defineProperty({}, _e30, t));
          };

          l[_e30] = r, d[_e30] = t;
        };

        for (var _e30 in u.modifiers) {
          _loop6(_e30);
        }
      }

      if (u.modifiers = d, u.overrides) {
        l._super = r, c.$_super = {};

        for (var _e31 in u.overrides) {
          s(r[_e31], "Cannot override missing", _e31), c.$_super[_e31] = r[_e31].bind(c);
        }

        Object.assign(l, u.overrides);
      }

      u.cast = Object.assign({}, f.cast, u.cast);
      var p = Object.assign({}, f.manifest, u.manifest);
      return p.build = i.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = i.rebuild(u.rebuild, f.rebuild), c;
    }, i.build = function (e, t) {
      return e && t ? function (r, s) {
        return t(e(r, s), s);
      } : e || t;
    }, i.coerce = function (e, t) {
      return e && t ? {
        from: e.from && t.from ? _toConsumableArray(new Set([].concat(_toConsumableArray(e.from), _toConsumableArray(t.from)))) : null,
        method: function method(r, s) {
          var n;

          if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
            if (n.errors || void 0 === n.value) return n;
            r = n.value;
          }

          if (!e.from || e.from.includes(typeof r)) {
            var _t27 = e.method(r, s);

            if (_t27) return _t27;
          }

          return n;
        }
      } : e || t;
    }, i.prepare = function (e, t) {
      return e && t ? function (r, s) {
        var n = e(r, s);

        if (n) {
          if (n.errors || void 0 === n.value) return n;
          r = n.value;
        }

        return t(r, s) || n;
      } : e || t;
    }, i.rebuild = function (e, t) {
      return e && t ? function (r) {
        t(r), e(r);
      } : e || t;
    }, i.validate = function (e, t) {
      return e && t ? function (r, s) {
        var n = t(r, s);

        if (n) {
          if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
          r = n.value;
        }

        return e(r, s) || n;
      } : e || t;
    };
  }, function (e, t) {}, function (e, t) {}, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(14),
        a = {};

    e.exports = a.merge = function (e, t, r) {
      if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;

      if (r = Object.assign({
        nullOverride: !0,
        mergeArrays: !0
      }, r), Array.isArray(t)) {
        s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);

        for (var _s13 = 0; _s13 < t.length; ++_s13) {
          e.push(n(t[_s13], {
            symbols: r.symbols
          }));
        }

        return e;
      }

      var i = o.keys(t, r);

      for (var _s14 = 0; _s14 < i.length; ++_s14) {
        var _o6 = i[_s14];
        if ("__proto__" === _o6 || !Object.prototype.propertyIsEnumerable.call(t, _o6)) continue;
        var l = t[_o6];

        if (l && "object" == typeof l) {
          if (e[_o6] === l) continue;
          !e[_o6] || "object" != typeof e[_o6] || Array.isArray(e[_o6]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[_o6] = n(l, {
            symbols: r.symbols
          }) : a.merge(e[_o6], l, r);
        } else null != l ? e[_o6] = l : r.nullOverride && (e[_o6] = l);
      }

      return e;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(10),
        o = r(1),
        a = {};
    e.exports = a.Values =
    /*#__PURE__*/
    function () {
      function _class10(e, t) {
        _classCallCheck(this, _class10);

        this._values = new Set(e), this._refs = new Set(t), this._lowercase = a.lowercases(e), this._override = !1;
      }

      _createClass(_class10, [{
        key: "add",
        value: function add(e, t) {
          o.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
        }
      }, {
        key: "remove",
        value: function remove(e) {
          o.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
        }
      }, {
        key: "has",
        value: function has(e, t, r, s) {
          return !!this.get(e, t, r, s);
        }
      }, {
        key: "get",
        value: function get(e, t, r, s) {
          if (!this.length) return !1;
          if (this._values.has(e)) return {
            value: e
          };

          if ("string" == typeof e && e && s) {
            var _t28 = this._lowercase.get(e.toLowerCase());

            if (_t28) return {
              value: _t28
            };
          }

          if (!this._refs.size && "object" != typeof e) return !1;

          if ("object" == typeof e) {
            var _iteratorNormalCompletion36 = true;
            var _didIteratorError36 = false;
            var _iteratorError36 = undefined;

            try {
              for (var _iterator36 = this._values[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                var _t29 = _step36.value;
                if (n(_t29, e)) return {
                  value: _t29
                };
              }
            } catch (err) {
              _didIteratorError36 = true;
              _iteratorError36 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
                  _iterator36.return();
                }
              } finally {
                if (_didIteratorError36) {
                  throw _iteratorError36;
                }
              }
            }
          }

          if (t) {
            var _iteratorNormalCompletion37 = true;
            var _didIteratorError37 = false;
            var _iteratorError37 = undefined;

            try {
              for (var _iterator37 = this._refs[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                var _o7 = _step37.value;

                var _a4 = _o7.resolve(e, t, r, null, {
                  in: !0
                });

                if (void 0 === _a4) continue;
                var i = _o7.in && "object" == typeof _a4 ? Array.isArray(_a4) ? _a4 : Object.keys(_a4) : [_a4];
                var _iteratorNormalCompletion38 = true;
                var _didIteratorError38 = false;
                var _iteratorError38 = undefined;

                try {
                  for (var _iterator38 = i[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                    var _t30 = _step38.value;
                    if (typeof _t30 == typeof e) if (s && e && "string" == typeof e) {
                      if (_t30.toLowerCase() === e.toLowerCase()) return {
                        value: _t30,
                        ref: _o7
                      };
                    } else if (n(_t30, e)) return {
                      value: _t30,
                      ref: _o7
                    };
                  }
                } catch (err) {
                  _didIteratorError38 = true;
                  _iteratorError38 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
                      _iterator38.return();
                    }
                  } finally {
                    if (_didIteratorError38) {
                      throw _iteratorError38;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError37 = true;
              _iteratorError37 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
                  _iterator37.return();
                }
              } finally {
                if (_didIteratorError37) {
                  throw _iteratorError37;
                }
              }
            }
          }

          return !1;
        }
      }, {
        key: "override",
        value: function override() {
          this._override = !0;
        }
      }, {
        key: "values",
        value: function values(e) {
          if (e && e.display) {
            var _e32 = [];

            for (var _i7 = 0, _arr4 = [].concat(_toConsumableArray(this._values), _toConsumableArray(this._refs)); _i7 < _arr4.length; _i7++) {
              var _t31 = _arr4[_i7];
              void 0 !== _t31 && _e32.push(_t31);
            }

            return _e32;
          }

          return Array.from([].concat(_toConsumableArray(this._values), _toConsumableArray(this._refs)));
        }
      }, {
        key: "clone",
        value: function clone() {
          var e = new a.Values(this._values, this._refs);
          return e._override = this._override, e;
        }
      }, {
        key: "concat",
        value: function concat(e) {
          s(!e._override, "Cannot concat override set of values");
          var t = new a.Values([].concat(_toConsumableArray(this._values), _toConsumableArray(e._values)), [].concat(_toConsumableArray(this._refs), _toConsumableArray(e._refs)));
          return t._override = this._override, t;
        }
      }, {
        key: "describe",
        value: function describe() {
          var e = [];
          this._override && e.push({
            override: !0
          });
          var _iteratorNormalCompletion39 = true;
          var _didIteratorError39 = false;
          var _iteratorError39 = undefined;

          try {
            for (var _iterator39 = this._values.values()[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
              var _t32 = _step39.value;
              e.push(_t32 && "object" == typeof _t32 ? {
                value: _t32
              } : _t32);
            }
          } catch (err) {
            _didIteratorError39 = true;
            _iteratorError39 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
                _iterator39.return();
              }
            } finally {
              if (_didIteratorError39) {
                throw _iteratorError39;
              }
            }
          }

          var _iteratorNormalCompletion40 = true;
          var _didIteratorError40 = false;
          var _iteratorError40 = undefined;

          try {
            for (var _iterator40 = this._refs.values()[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
              var _t33 = _step40.value;
              e.push(_t33.describe());
            }
          } catch (err) {
            _didIteratorError40 = true;
            _iteratorError40 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
                _iterator40.return();
              }
            } finally {
              if (_didIteratorError40) {
                throw _iteratorError40;
              }
            }
          }

          return e;
        }
      }, {
        key: "length",
        get: function get() {
          return this._values.size + this._refs.size;
        }
      }], [{
        key: "merge",
        value: function merge(e, t, r) {
          if (e = e || new a.Values(), t) {
            if (t._override) return t.clone();

            for (var _i8 = 0, _arr5 = [].concat(_toConsumableArray(t._values), _toConsumableArray(t._refs)); _i8 < _arr5.length; _i8++) {
              var _r24 = _arr5[_i8];
              e.add(_r24);
            }
          }

          if (r) {
            for (var _i9 = 0, _arr6 = [].concat(_toConsumableArray(r._values), _toConsumableArray(r._refs)); _i9 < _arr6.length; _i9++) {
              var _t34 = _arr6[_i9];
              e.remove(_t34);
            }
          }

          return e.length ? e : null;
        }
      }]);

      return _class10;
    }(), a.Values.prototype[o.symbols.values] = !0, a.Values.prototype.slice = a.Values.prototype.clone, a.lowercases = function (e) {
      var t = new Map();

      if (e) {
        var _iteratorNormalCompletion41 = true;
        var _didIteratorError41 = false;
        var _iteratorError41 = undefined;

        try {
          for (var _iterator41 = e[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
            var _r25 = _step41.value;
            "string" == typeof _r25 && t.set(_r25.toLowerCase(), _r25);
          }
        } catch (err) {
          _didIteratorError41 = true;
          _iteratorError41 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
              _iterator41.return();
            }
          } finally {
            if (_didIteratorError41) {
              throw _iteratorError41;
            }
          }
        }
      }

      return t;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(43),
        n = r(0),
        o = r(2),
        a = r(44),
        i = r(3),
        l = r(1),
        c = r(8),
        u = r(4),
        f = r(5),
        m = r(7),
        h = {
      renameDefaults: {
        alias: !1,
        multiple: !1,
        override: !1
      }
    };
    e.exports = i.extend({
      type: "_keys",
      properties: {
        typeof: "object"
      },
      flags: {
        unknown: {
          default: !1
        }
      },
      terms: {
        dependencies: {
          init: null
        },
        keys: {
          init: null,
          manifest: {
            mapped: {
              from: "schema",
              to: "key"
            }
          }
        },
        patterns: {
          init: null
        },
        renames: {
          init: null
        }
      },
      args: function args(e, t) {
        return e.keys(t);
      },
      validate: function validate(e, _ref4) {
        var t = _ref4.schema,
            r = _ref4.error,
            s = _ref4.state,
            n = _ref4.prefs;
        if (!e || typeof e !== t.$_property("typeof") || Array.isArray(e)) return {
          value: e,
          errors: r("object.base", {
            type: t.$_property("typeof")
          })
        };
        if (!(t.$_terms.renames || t.$_terms.dependencies || t.$_terms.keys || t.$_terms.patterns || t.$_terms.externals)) return;
        e = h.clone(e, n);
        var o = [];
        if (t.$_terms.renames && !h.rename(t, e, s, n, o)) return {
          value: e,
          errors: o
        };
        if (!t.$_terms.keys && !t.$_terms.patterns && !t.$_terms.dependencies) return {
          value: e,
          errors: o
        };
        var a = new Set(Object.keys(e));

        if (t.$_terms.keys) {
          var _r26 = [e].concat(_toConsumableArray(s.ancestors));

          var _iteratorNormalCompletion42 = true;
          var _didIteratorError42 = false;
          var _iteratorError42 = undefined;

          try {
            for (var _iterator42 = t.$_terms.keys[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
              var _i10 = _step42.value;
              var _t35 = _i10.key,
                  _l4 = e[_t35];
              a.delete(_t35);

              var _c3 = s.localize([].concat(_toConsumableArray(s.path), [_t35]), _r26, _i10),
                  _u = _i10.schema.$_validate(_l4, _c3, n);

              if (_u.errors) {
                if (n.abortEarly) return {
                  value: e,
                  errors: _u.errors
                };
                o.push.apply(o, _toConsumableArray(_u.errors));
              } else "strip" === _i10.schema._flags.result || void 0 === _u.value && void 0 !== _l4 ? delete e[_t35] : void 0 !== _u.value && (e[_t35] = _u.value);
            }
          } catch (err) {
            _didIteratorError42 = true;
            _iteratorError42 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
                _iterator42.return();
              }
            } finally {
              if (_didIteratorError42) {
                throw _iteratorError42;
              }
            }
          }
        }

        if (a.size || t._flags._hasPatternMatch) {
          var _r27 = h.unknown(t, e, a, o, s, n);

          if (_r27) return _r27;
        }

        if (t.$_terms.dependencies) {
          var _iteratorNormalCompletion43 = true;
          var _didIteratorError43 = false;
          var _iteratorError43 = undefined;

          try {
            for (var _iterator43 = t.$_terms.dependencies[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
              var _r28 = _step43.value;
              if (_r28.key && void 0 === _r28.key.resolve(e, s, n, null, {
                shadow: !1
              })) continue;

              var _a5 = h.dependencies[_r28.rel](t, _r28, e, s, n);

              if (_a5) {
                var _r29 = t.$_createError(_a5.code, e, _a5.context, s, n);

                if (n.abortEarly) return {
                  value: e,
                  errors: _r29
                };
                o.push(_r29);
              }
            }
          } catch (err) {
            _didIteratorError43 = true;
            _iteratorError43 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
                _iterator43.return();
              }
            } finally {
              if (_didIteratorError43) {
                throw _iteratorError43;
              }
            }
          }
        }

        return {
          value: e,
          errors: o
        };
      },
      rules: {
        and: {
          method: function method() {
            for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
              e[_key11] = arguments[_key11];
            }

            return l.verifyFlat(e, "and"), h.dependency(this, "and", null, e);
          }
        },
        append: {
          method: function method(e) {
            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
          }
        },
        assert: {
          method: function method(e, t, r) {
            m.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
              appendPath: !0
            });
            var s = this.$_addRule({
              name: "assert",
              args: {
                subject: e,
                schema: t,
                message: r
              }
            });
            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
          },
          validate: function validate(e, _ref5, _ref6) {
            var t = _ref5.error,
                r = _ref5.prefs,
                s = _ref5.state;
            var n = _ref6.subject,
                o = _ref6.schema,
                a = _ref6.message;
            var i = n.resolve(e, s, r),
                l = f.isRef(n) ? n.absolute(s) : [];
            return o.$_match(i, s.localize(l, [e].concat(_toConsumableArray(s.ancestors)), o), r) ? e : t("object.assert", {
              subject: n,
              message: a
            });
          },
          args: ["subject", "schema", "message"],
          multi: !0
        },
        instance: {
          method: function method(e, t) {
            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
              name: "instance",
              args: {
                constructor: e,
                name: t
              }
            });
          },
          validate: function validate(e, t, _ref7) {
            var r = _ref7.constructor,
                s = _ref7.name;
            return e instanceof r ? e : t.error("object.instance", {
              type: s,
              value: e
            });
          },
          args: ["constructor", "name"]
        },
        keys: {
          method: function method(e) {
            var _this6 = this;

            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
            var t = this.clone();
            if (e) {
              if (Object.keys(e).length) {
                t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter(function (t) {
                  return !e.hasOwnProperty(t.key);
                }) : new h.Keys();

                var _loop7 = function _loop7(_r30) {
                  l.tryWithPath(function () {
                    return t.$_terms.keys.push({
                      key: _r30,
                      schema: _this6.$_compile(e[_r30])
                    });
                  }, _r30);
                };

                for (var _r30 in e) {
                  _loop7(_r30);
                }
              } else t.$_terms.keys = new h.Keys();
            } else t.$_terms.keys = null;
            return t.$_mutateRebuild();
          }
        },
        length: {
          method: function method(e) {
            return this.$_addRule({
              name: "length",
              args: {
                limit: e
              },
              operator: "="
            });
          },
          validate: function validate(e, t, _ref8, _ref9) {
            var r = _ref8.limit;
            var s = _ref9.name,
                n = _ref9.operator,
                o = _ref9.args;
            return l.compare(Object.keys(e).length, r, n) ? e : t.error("object." + s, {
              limit: o.limit,
              value: e
            });
          },
          args: [{
            name: "limit",
            ref: !0,
            assert: l.limit,
            message: "must be a positive integer"
          }]
        },
        max: {
          method: function method(e) {
            return this.$_addRule({
              name: "max",
              method: "length",
              args: {
                limit: e
              },
              operator: "<="
            });
          }
        },
        min: {
          method: function method(e) {
            return this.$_addRule({
              name: "min",
              method: "length",
              args: {
                limit: e
              },
              operator: ">="
            });
          }
        },
        nand: {
          method: function method() {
            for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
              e[_key12] = arguments[_key12];
            }

            return l.verifyFlat(e, "nand"), h.dependency(this, "nand", null, e);
          }
        },
        or: {
          method: function method() {
            for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
              e[_key13] = arguments[_key13];
            }

            return l.verifyFlat(e, "or"), h.dependency(this, "or", null, e);
          }
        },
        oxor: {
          method: function method() {
            for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
              e[_key14] = arguments[_key14];
            }

            return h.dependency(this, "oxor", null, e);
          }
        },
        pattern: {
          method: function method(e, t) {
            var _a6;

            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var s = e instanceof RegExp;
            s || (e = this.$_compile(e, {
              appendPath: !0
            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, ["fallthrough", "matches"]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
              appendPath: !0
            });
            var o = this.clone();
            o.$_terms.patterns = o.$_terms.patterns || [];
            var a = (_a6 = {}, _defineProperty(_a6, s ? "regex" : "schema", e), _defineProperty(_a6, "rule", t), _a6);
            return r.matches && (a.matches = this.$_compile(r.matches), "array" !== a.matches.type && (a.matches = a.matches.$_root.array().items(a.matches)), o.$_mutateRegister(a.matches), o.$_setFlag("_hasPatternMatch", !0, {
              clone: !1
            })), r.fallthrough && (a.fallthrough = !0), o.$_terms.patterns.push(a), o.$_mutateRegister(t), o;
          }
        },
        ref: {
          method: function method() {
            return this.$_addRule("ref");
          },
          validate: function validate(e, t) {
            return f.isRef(e) ? e : t.error("object.refType", {
              value: e
            });
          }
        },
        regex: {
          method: function method() {
            return this.$_addRule("regex");
          },
          validate: function validate(e, t) {
            return e instanceof RegExp ? e : t.error("object.regex", {
              value: e
            });
          }
        },
        rename: {
          method: function method(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof m, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, ["alias", "ignoreUndefined", "override", "multiple"]);
            var o = this.clone();
            o.$_terms.renames = o.$_terms.renames || [];
            var _iteratorNormalCompletion44 = true;
            var _didIteratorError44 = false;
            var _iteratorError44 = undefined;

            try {
              for (var _iterator44 = o.$_terms.renames[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
                var _t36 = _step44.value;
                n(_t36.from !== e, "Cannot rename the same key multiple times");
              }
            } catch (err) {
              _didIteratorError44 = true;
              _iteratorError44 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
                  _iterator44.return();
                }
              } finally {
                if (_didIteratorError44) {
                  throw _iteratorError44;
                }
              }
            }

            return t instanceof m && o.$_mutateRegister(t), o.$_terms.renames.push({
              from: e,
              to: t,
              options: s(h.renameDefaults, r)
            }), o;
          }
        },
        schema: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "any";
            return this.$_addRule({
              name: "schema",
              args: {
                type: e
              }
            });
          },
          validate: function validate(e, t, _ref10) {
            var r = _ref10.type;
            return !l.isSchema(e) || "any" !== r && e.type !== r ? t.error("object.schema", {
              type: r
            }) : e;
          }
        },
        unknown: {
          method: function method(e) {
            return this.$_setFlag("unknown", !1 !== e);
          }
        },
        with: {
          method: function method(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return h.dependency(this, "with", e, t, r);
          }
        },
        without: {
          method: function method(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return h.dependency(this, "without", e, t, r);
          }
        },
        xor: {
          method: function method() {
            for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
              e[_key15] = arguments[_key15];
            }

            return l.verifyFlat(e, "xor"), h.dependency(this, "xor", null, e);
          }
        }
      },
      overrides: {
        default: function _default(e, t) {
          return void 0 === e && (e = l.symbols.deepDefault), this.$_super.default(e, t);
        }
      },
      rebuild: function rebuild(e) {
        if (e.$_terms.keys) {
          (function () {
            var t = new a.Sorter();
            var _iteratorNormalCompletion45 = true;
            var _didIteratorError45 = false;
            var _iteratorError45 = undefined;

            try {
              var _loop8 = function _loop8() {
                var r = _step45.value;
                l.tryWithPath(function () {
                  return t.add(r, {
                    after: r.schema.$_rootReferences(),
                    group: r.key
                  });
                }, r.key);
              };

              for (var _iterator45 = e.$_terms.keys[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
                _loop8();
              }
            } catch (err) {
              _didIteratorError45 = true;
              _iteratorError45 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
                  _iterator45.return();
                }
              } finally {
                if (_didIteratorError45) {
                  throw _iteratorError45;
                }
              }
            }

            e.$_terms.keys = _construct(h.Keys, _toConsumableArray(t.nodes));
          })();
        }
      },
      manifest: {
        build: function build(e, t) {
          if (t.keys && (e = e.keys(t.keys)), t.dependencies) {
            var _iteratorNormalCompletion46 = true;
            var _didIteratorError46 = false;
            var _iteratorError46 = undefined;

            try {
              for (var _iterator46 = t.dependencies[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
                var _step46$value = _step46.value,
                    _r31 = _step46$value.rel,
                    _step46$value$key = _step46$value.key,
                    _s15 = _step46$value$key === void 0 ? null : _step46$value$key,
                    _n13 = _step46$value.peers,
                    _o8 = _step46$value.options;

                e = h.dependency(e, _r31, _s15, _n13, _o8);
              }
            } catch (err) {
              _didIteratorError46 = true;
              _iteratorError46 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
                  _iterator46.return();
                }
              } finally {
                if (_didIteratorError46) {
                  throw _iteratorError46;
                }
              }
            }
          }

          if (t.patterns) {
            var _iteratorNormalCompletion47 = true;
            var _didIteratorError47 = false;
            var _iteratorError47 = undefined;

            try {
              for (var _iterator47 = t.patterns[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
                var _step47$value = _step47.value,
                    _r32 = _step47$value.regex,
                    _s16 = _step47$value.schema,
                    _n14 = _step47$value.rule,
                    _o9 = _step47$value.fallthrough,
                    _a7 = _step47$value.matches;
                e = e.pattern(_r32 || _s16, _n14, {
                  fallthrough: _o9,
                  matches: _a7
                });
              }
            } catch (err) {
              _didIteratorError47 = true;
              _iteratorError47 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
                  _iterator47.return();
                }
              } finally {
                if (_didIteratorError47) {
                  throw _iteratorError47;
                }
              }
            }
          }

          if (t.renames) {
            var _iteratorNormalCompletion48 = true;
            var _didIteratorError48 = false;
            var _iteratorError48 = undefined;

            try {
              for (var _iterator48 = t.renames[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
                var _step48$value = _step48.value,
                    _r33 = _step48$value.from,
                    _s17 = _step48$value.to,
                    _n15 = _step48$value.options;
                e = e.rename(_r33, _s17, _n15);
              }
            } catch (err) {
              _didIteratorError48 = true;
              _iteratorError48 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
                  _iterator48.return();
                }
              } finally {
                if (_didIteratorError48) {
                  throw _iteratorError48;
                }
              }
            }
          }

          return e;
        }
      },
      messages: {
        "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
        "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
        "object.base": "{{#label}} must be of type {{#type}}",
        "object.instance": '{{#label}} must be an instance of "{{#type}}"',
        "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
        "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
        "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
        "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
        "object.nand": '"{{#mainWithLabel}}" must not exist simultaneously with {{#peersWithLabels}}',
        "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
        "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
        "object.refType": "{{#label}} must be a Joi reference",
        "object.regex": "{{#label}} must be a RegExp object",
        "object.rename.multiple": '{{#label}} cannot rename "{{#from}}" because multiple renames are disabled and another key was already renamed to "{{#to}}"',
        "object.rename.override": '{{#label}} cannot rename "{{#from}}" because override is disabled and target "{{#to}}" exists',
        "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
        "object.unknown": "{{#label}} is not allowed",
        "object.with": '"{{#mainWithLabel}}" missing required peer "{{#peerWithLabel}}"',
        "object.without": '"{{#mainWithLabel}}" conflict with forbidden peer "{{#peerWithLabel}}"',
        "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
      }
    }), h.clone = function (e, t) {
      if ("object" == typeof e) {
        if (t.nonEnumerables) return o(e, {
          shallow: !0
        });

        var _r34 = Object.create(Object.getPrototypeOf(e));

        return Object.assign(_r34, e), _r34;
      }

      var r = function r() {
        for (var _len16 = arguments.length, t = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          t[_key16] = arguments[_key16];
        }

        return e.apply(this, t);
      };

      return r.prototype = o(e.prototype), Object.defineProperty(r, "name", {
        value: e.name,
        writable: !1
      }), Object.defineProperty(r, "length", {
        value: e.length,
        writable: !1
      }), Object.assign(r, e), r;
    }, h.dependency = function (e, t, r, s, o) {
      n(null === r || "string" == typeof r, t, "key must be a strings"), o || (o = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(o, ["separator"]), s = [].concat(s);
      var a = l.default(o.separator, "."),
          i = [];
      var _iteratorNormalCompletion49 = true;
      var _didIteratorError49 = false;
      var _iteratorError49 = undefined;

      try {
        for (var _iterator49 = s[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
          var _e33 = _step49.value;
          n("string" == typeof _e33, t, "peers must be a string or a reference"), i.push(c.ref(_e33, {
            separator: a,
            ancestor: 0,
            prefix: !1
          }));
        }
      } catch (err) {
        _didIteratorError49 = true;
        _iteratorError49 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
            _iterator49.return();
          }
        } finally {
          if (_didIteratorError49) {
            throw _iteratorError49;
          }
        }
      }

      null !== r && (r = c.ref(r, {
        separator: a,
        ancestor: 0,
        prefix: !1
      }));
      var u = e.clone();
      return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new h.Dependency(t, r, i, s)), u;
    }, h.dependencies = {
      and: function and(e, t, r, s, n) {
        var o = [],
            a = [],
            i = t.peers.length;
        var _iteratorNormalCompletion50 = true;
        var _didIteratorError50 = false;
        var _iteratorError50 = undefined;

        try {
          for (var _iterator50 = t.peers[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
            var _e34 = _step50.value;
            void 0 === _e34.resolve(r, s, n, null, {
              shadow: !1
            }) ? o.push(_e34.key) : a.push(_e34.key);
          }
        } catch (err) {
          _didIteratorError50 = true;
          _iteratorError50 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
              _iterator50.return();
            }
          } finally {
            if (_didIteratorError50) {
              throw _iteratorError50;
            }
          }
        }

        if (o.length !== i && a.length !== i) return {
          code: "object.and",
          context: {
            present: a,
            presentWithLabels: h.keysToLabels(e, a),
            missing: o,
            missingWithLabels: h.keysToLabels(e, o)
          }
        };
      },
      nand: function nand(e, t, r, s, n) {
        var o = [];
        var _iteratorNormalCompletion51 = true;
        var _didIteratorError51 = false;
        var _iteratorError51 = undefined;

        try {
          for (var _iterator51 = t.peers[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
            var _e35 = _step51.value;
            void 0 !== _e35.resolve(r, s, n, null, {
              shadow: !1
            }) && o.push(_e35.key);
          }
        } catch (err) {
          _didIteratorError51 = true;
          _iteratorError51 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
              _iterator51.return();
            }
          } finally {
            if (_didIteratorError51) {
              throw _iteratorError51;
            }
          }
        }

        if (o.length !== t.peers.length) return;
        var a = t.paths[0],
            i = t.paths.slice(1);
        return {
          code: "object.nand",
          context: {
            main: a,
            mainWithLabel: h.keysToLabels(e, a),
            peers: i,
            peersWithLabels: h.keysToLabels(e, i)
          }
        };
      },
      or: function or(e, t, r, s, n) {
        var _iteratorNormalCompletion52 = true;
        var _didIteratorError52 = false;
        var _iteratorError52 = undefined;

        try {
          for (var _iterator52 = t.peers[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
            var _e36 = _step52.value;
            if (void 0 !== _e36.resolve(r, s, n, null, {
              shadow: !1
            })) return;
          }
        } catch (err) {
          _didIteratorError52 = true;
          _iteratorError52 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
              _iterator52.return();
            }
          } finally {
            if (_didIteratorError52) {
              throw _iteratorError52;
            }
          }
        }

        return {
          code: "object.missing",
          context: {
            peers: t.paths,
            peersWithLabels: h.keysToLabels(e, t.paths)
          }
        };
      },
      oxor: function oxor(e, t, r, s, n) {
        var o = [];
        var _iteratorNormalCompletion53 = true;
        var _didIteratorError53 = false;
        var _iteratorError53 = undefined;

        try {
          for (var _iterator53 = t.peers[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
            var _e37 = _step53.value;
            void 0 !== _e37.resolve(r, s, n, null, {
              shadow: !1
            }) && o.push(_e37.key);
          }
        } catch (err) {
          _didIteratorError53 = true;
          _iteratorError53 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
              _iterator53.return();
            }
          } finally {
            if (_didIteratorError53) {
              throw _iteratorError53;
            }
          }
        }

        if (!o.length || 1 === o.length) return;
        var a = {
          peers: t.paths,
          peersWithLabels: h.keysToLabels(e, t.paths)
        };
        return a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
          code: "object.oxor",
          context: a
        };
      },
      with: function _with(e, t, r, s, n) {
        var _iteratorNormalCompletion54 = true;
        var _didIteratorError54 = false;
        var _iteratorError54 = undefined;

        try {
          for (var _iterator54 = t.peers[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
            var _o10 = _step54.value;
            if (void 0 === _o10.resolve(r, s, n, null, {
              shadow: !1
            })) return {
              code: "object.with",
              context: {
                main: t.key.key,
                mainWithLabel: h.keysToLabels(e, t.key.key),
                peer: _o10.key,
                peerWithLabel: h.keysToLabels(e, _o10.key)
              }
            };
          }
        } catch (err) {
          _didIteratorError54 = true;
          _iteratorError54 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
              _iterator54.return();
            }
          } finally {
            if (_didIteratorError54) {
              throw _iteratorError54;
            }
          }
        }
      },
      without: function without(e, t, r, s, n) {
        var _iteratorNormalCompletion55 = true;
        var _didIteratorError55 = false;
        var _iteratorError55 = undefined;

        try {
          for (var _iterator55 = t.peers[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
            var _o11 = _step55.value;
            if (void 0 !== _o11.resolve(r, s, n, null, {
              shadow: !1
            })) return {
              code: "object.without",
              context: {
                main: t.key.key,
                mainWithLabel: h.keysToLabels(e, t.key.key),
                peer: _o11.key,
                peerWithLabel: h.keysToLabels(e, _o11.key)
              }
            };
          }
        } catch (err) {
          _didIteratorError55 = true;
          _iteratorError55 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
              _iterator55.return();
            }
          } finally {
            if (_didIteratorError55) {
              throw _iteratorError55;
            }
          }
        }
      },
      xor: function xor(e, t, r, s, n) {
        var o = [];
        var _iteratorNormalCompletion56 = true;
        var _didIteratorError56 = false;
        var _iteratorError56 = undefined;

        try {
          for (var _iterator56 = t.peers[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
            var _e38 = _step56.value;
            void 0 !== _e38.resolve(r, s, n, null, {
              shadow: !1
            }) && o.push(_e38.key);
          }
        } catch (err) {
          _didIteratorError56 = true;
          _iteratorError56 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
              _iterator56.return();
            }
          } finally {
            if (_didIteratorError56) {
              throw _iteratorError56;
            }
          }
        }

        if (1 === o.length) return;
        var a = {
          peers: t.paths,
          peersWithLabels: h.keysToLabels(e, t.paths)
        };
        return 0 === o.length ? {
          code: "object.missing",
          context: a
        } : (a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
          code: "object.xor",
          context: a
        });
      }
    }, h.keysToLabels = function (e, t) {
      return Array.isArray(t) ? t.map(function (t) {
        return e.$_mapLabels(t);
      }) : e.$_mapLabels(t);
    }, h.rename = function (e, t, r, s, n) {
      var o = {};
      var _iteratorNormalCompletion57 = true;
      var _didIteratorError57 = false;
      var _iteratorError57 = undefined;

      try {
        for (var _iterator57 = e.$_terms.renames[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
          var _a8 = _step57.value;

          var _i11 = [],
              _l5 = "string" != typeof _a8.from;

          if (_l5) for (var _e39 in t) {
            if (void 0 === t[_e39] && _a8.options.ignoreUndefined) continue;
            if (_e39 === _a8.to) continue;

            var _r35 = _a8.from.exec(_e39);

            _r35 && _i11.push({
              from: _e39,
              to: _a8.to,
              match: _r35
            });
          } else !Object.prototype.hasOwnProperty.call(t, _a8.from) || void 0 === t[_a8.from] && _a8.options.ignoreUndefined || _i11.push(_a8);

          for (var _i13 = 0, _i12 = _i11; _i13 < _i12.length; _i13++) {
            var _c4 = _i12[_i13];
            var _i14 = _c4.from;
            var _u2 = _c4.to;

            if (_u2 instanceof m && (_u2 = _u2.render(t, r, s, _c4.match)), _i14 !== _u2) {
              if (!_a8.options.multiple && o[_u2] && (n.push(e.$_createError("object.rename.multiple", t, {
                from: _i14,
                to: _u2,
                pattern: _l5
              }, r, s)), s.abortEarly)) return !1;
              if (Object.prototype.hasOwnProperty.call(t, _u2) && !_a8.options.override && !o[_u2] && (n.push(e.$_createError("object.rename.override", t, {
                from: _i14,
                to: _u2,
                pattern: _l5
              }, r, s)), s.abortEarly)) return !1;
              void 0 === t[_i14] ? delete t[_u2] : t[_u2] = t[_i14], o[_u2] = !0, _a8.options.alias || delete t[_i14];
            }
          }
        }
      } catch (err) {
        _didIteratorError57 = true;
        _iteratorError57 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion57 && _iterator57.return != null) {
            _iterator57.return();
          }
        } finally {
          if (_didIteratorError57) {
            throw _iteratorError57;
          }
        }
      }

      return !0;
    }, h.unknown = function (e, t, r, s, n, o) {
      if (e.$_terms.patterns) {
        var _a9 = !1;

        var _i15 = e.$_terms.patterns.map(function (e) {
          if (e.matches) return _a9 = !0, [];
        }),
            _l6 = [t].concat(_toConsumableArray(n.ancestors));

        var _iteratorNormalCompletion58 = true;
        var _didIteratorError58 = false;
        var _iteratorError58 = undefined;

        try {
          for (var _iterator58 = r[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
            var _a11 = _step58.value;

            var _c6 = t[_a11],
                _u3 = [].concat(_toConsumableArray(n.path), [_a11]);

            for (var _f2 = 0; _f2 < e.$_terms.patterns.length; ++_f2) {
              var _m2 = e.$_terms.patterns[_f2];

              if (_m2.regex) {
                var _e40 = _m2.regex.test(_a11);

                if (n.mainstay.tracer.debug(n, "rule", "pattern.".concat(_f2), _e40 ? "pass" : "error"), !_e40) continue;
              } else if (!_m2.schema.$_match(_a11, n.nest(_m2.schema, "pattern.".concat(_f2)), o)) continue;

              r.delete(_a11);

              var _h = n.localize(_u3, _l6, {
                schema: _m2.rule,
                key: _a11
              }),
                  d = _m2.rule.$_validate(_c6, _h, o);

              if (d.errors) {
                if (o.abortEarly) return {
                  value: t,
                  errors: d.errors
                };
                s.push.apply(s, _toConsumableArray(d.errors));
              }

              if (_m2.matches && _i15[_f2].push(_a11), t[_a11] = d.value, !_m2.fallthrough) break;
            }
          }
        } catch (err) {
          _didIteratorError58 = true;
          _iteratorError58 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion58 && _iterator58.return != null) {
              _iterator58.return();
            }
          } finally {
            if (_didIteratorError58) {
              throw _iteratorError58;
            }
          }
        }

        if (_a9) for (var _r36 = 0; _r36 < _i15.length; ++_r36) {
          var _a10 = _i15[_r36];
          if (!_a10) continue;

          var _c5 = e.$_terms.patterns[_r36].matches,
              _f = n.localize(n.path, _l6, _c5),
              _m = _c5.$_validate(_a10, _f, o);

          if (_m.errors) {
            var _r37 = u.details(_m.errors, {
              override: !1
            });

            _r37.matches = _a10;

            var _i16 = e.$_createError("object.pattern.match", t, _r37, n, o);

            if (o.abortEarly) return {
              value: t,
              errors: _i16
            };
            s.push(_i16);
          }
        }
      }

      if (!r.size || !e.$_terms.keys && !e.$_terms.patterns) return;

      if (o.stripUnknown && !e._flags.unknown || o.skipFunctions) {
        var _e41 = !!o.stripUnknown && (!0 === o.stripUnknown || !!o.stripUnknown.objects);

        var _iteratorNormalCompletion59 = true;
        var _didIteratorError59 = false;
        var _iteratorError59 = undefined;

        try {
          for (var _iterator59 = r[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
            var _s18 = _step59.value;
            _e41 ? (delete t[_s18], r.delete(_s18)) : "function" == typeof t[_s18] && r.delete(_s18);
          }
        } catch (err) {
          _didIteratorError59 = true;
          _iteratorError59 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion59 && _iterator59.return != null) {
              _iterator59.return();
            }
          } finally {
            if (_didIteratorError59) {
              throw _iteratorError59;
            }
          }
        }
      }

      if (!l.default(e._flags.unknown, o.allowUnknown)) {
        var _iteratorNormalCompletion60 = true;
        var _didIteratorError60 = false;
        var _iteratorError60 = undefined;

        try {
          for (var _iterator60 = r[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
            var _a12 = _step60.value;

            var _r38 = n.localize([].concat(_toConsumableArray(n.path), [_a12]), []),
                _i17 = e.$_createError("object.unknown", t[_a12], {
              child: _a12
            }, _r38, o, {
              flags: !1
            });

            if (o.abortEarly) return {
              value: t,
              errors: _i17
            };
            s.push(_i17);
          }
        } catch (err) {
          _didIteratorError60 = true;
          _iteratorError60 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion60 && _iterator60.return != null) {
              _iterator60.return();
            }
          } finally {
            if (_didIteratorError60) {
              throw _iteratorError60;
            }
          }
        }
      }
    }, h.Dependency =
    /*#__PURE__*/
    function () {
      function _class11(e, t, r, s) {
        _classCallCheck(this, _class11);

        this.rel = e, this.key = t, this.peers = r, this.paths = s;
      }

      _createClass(_class11, [{
        key: "describe",
        value: function describe() {
          var e = {
            rel: this.rel,
            peers: this.paths
          };
          return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
            separator: this.peers[0].separator
          }), e;
        }
      }]);

      return _class11;
    }(), h.Keys =
    /*#__PURE__*/
    function (_Array) {
      _inherits(_class12, _Array);

      function _class12() {
        _classCallCheck(this, _class12);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class12).apply(this, arguments));
      }

      _createClass(_class12, [{
        key: "concat",
        value: function concat(e) {
          var t = this.slice(),
              r = new Map();

          for (var _e42 = 0; _e42 < t.length; ++_e42) {
            r.set(t[_e42].key, _e42);
          }

          var _iteratorNormalCompletion61 = true;
          var _didIteratorError61 = false;
          var _iteratorError61 = undefined;

          try {
            for (var _iterator61 = e[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
              var _s19 = _step61.value;

              var _e43 = _s19.key,
                  _n16 = r.get(_e43);

              void 0 !== _n16 ? t[_n16] = {
                key: _e43,
                schema: t[_n16].schema.concat(_s19.schema)
              } : t.push(_s19);
            }
          } catch (err) {
            _didIteratorError61 = true;
            _iteratorError61 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion61 && _iterator61.return != null) {
                _iterator61.return();
              }
            } finally {
              if (_didIteratorError61) {
                throw _iteratorError61;
              }
            }
          }

          return t;
        }
      }]);

      return _class12;
    }(_wrapNativeSuper(Array));
  }, function (e, t, r) {
    "use strict";

    var s = r(24),
        n = r(25),
        o = {
      minDomainSegments: 2,
      nonAsciiRx: /[^\x00-\x7f]/,
      domainControlRx: /[\x00-\x20@\:\/]/,
      tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
      domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
      URL: s.URL || URL
    };
    t.analyze = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
      if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
      if (e.length > 256) return n.code("DOMAIN_TOO_LONG");

      if (!!o.nonAsciiRx.test(e)) {
        if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
        e = e.normalize("NFC");
      }

      if (o.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
      e = o.punycode(e);
      var r = t.minDomainSegments || o.minDomainSegments,
          s = e.split(".");
      if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
      var a = t.tlds;

      if (a) {
        var _e44 = s[s.length - 1].toLowerCase();

        if (a.deny && a.deny.has(_e44) || a.allow && !a.allow.has(_e44)) return n.code("DOMAIN_FORBIDDEN_TLDS");
      }

      for (var _e45 = 0; _e45 < s.length; ++_e45) {
        var _t37 = s[_e45];
        if (!_t37.length) return n.code("DOMAIN_EMPTY_SEGMENT");
        if (_t37.length > 63) return n.code("DOMAIN_LONG_SEGMENT");

        if (_e45 < s.length - 1) {
          if (!o.domainSegmentRx.test(_t37)) return n.code("DOMAIN_INVALID_CHARS");
        } else if (!o.tldSegmentRx.test(_t37)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
      }

      return null;
    }, t.isValid = function (e, r) {
      return !t.analyze(e, r);
    }, o.punycode = function (e) {
      try {
        return new o.URL("http://".concat(e)).host;
      } catch (t) {
        return e;
      }
    };
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    t.codes = {
      EMPTY_STRING: "Address must be a non-empty string",
      FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
      MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
      MISSING_AT_CHAR: "Address must contain one @ character",
      EMPTY_LOCAL: "Address local part cannot be empty",
      ADDRESS_TOO_LONG: "Address too long",
      LOCAL_TOO_LONG: "Address local part too long",
      EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
      INVALID_LOCAL_CHARS: "Address local part contains invalid character",
      DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
      DOMAIN_TOO_LONG: "Domain too long",
      DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
      DOMAIN_INVALID_CHARS: "Domain contains invalid character",
      DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
      DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
      DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
      DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
      DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
    }, t.code = function (e) {
      return {
        code: e,
        error: t.codes[e]
      };
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(27),
        o = {
      generate: function generate() {
        var e = {},
            t = "!\\$&'\\(\\)\\*\\+,;=",
            r = "\\w-\\.~%\\dA-Fa-f" + t + ":@",
            s = "[" + r + "]",
            n = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
        e.ipv4address = "(?:" + n + "\\.){3}" + n;
        var o = "[\\dA-Fa-f]{1,4}",
            a = "(?:" + o + ":" + o + "|" + e.ipv4address + ")",
            i = "(?:" + o + ":){6}" + a,
            l = "::(?:" + o + ":){5}" + a,
            c = "(?:" + o + ")?::(?:" + o + ":){4}" + a,
            u = "(?:(?:" + o + ":){0,1}" + o + ")?::(?:" + o + ":){3}" + a,
            f = "(?:(?:" + o + ":){0,2}" + o + ")?::(?:" + o + ":){2}" + a,
            m = "(?:(?:" + o + ":){0,3}" + o + ")?::" + o + ":" + a,
            h = "(?:(?:" + o + ":){0,4}" + o + ")?::" + a;
        e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + i + "|" + l + "|" + c + "|" + u + "|" + f + "|" + m + "|" + h + "|(?:(?:[\\dA-Fa-f]{1,4}:){0,5}[\\dA-Fa-f]{1,4})?::[\\dA-Fa-f]{1,4}|(?:(?:[\\dA-Fa-f]{1,4}:){0,6}[\\dA-Fa-f]{1,4})?::)", e.ipvFuture = "v[\\dA-Fa-f]+\\.[\\w-\\.~" + t + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);

        var d = "[\\w-\\.~%\\dA-Fa-f" + t + ":]*",
            p = "(?:" + ("\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]") + "|" + e.ipv4address + "|[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=]{1,255})",
            g = "(?:" + d + "@)?" + p + "(?::\\d*)?",
            y = "(?:" + d + "@)?(" + p + ")(?::\\d*)?",
            b = s + "*",
            v = s + "+",
            _ = "(?:\\/" + b + ")*",
            w = "\\/(?:" + v + _ + ")?",
            $ = v + _;

        return e.hierPart = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|" + $ + "|(?:\\/\\/\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*(?:\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*)*))", e.hierPartCapture = "(?:(?:\\/\\/" + y + _ + ")|" + w + "|" + $ + ")", e.relativeRef = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=@]+(?:\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*)*|)", e.query = "[" + r + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + r + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + r + "\\/\\?]*", e;
      }
    };
    o.rfc3986 = o.generate(), t.ip = {
      v4Cidr: o.rfc3986.ipv4Cidr,
      v6Cidr: o.rfc3986.ipv6Cidr,
      ipv4: o.rfc3986.ipv4address,
      ipv6: o.rfc3986.ipv6address,
      ipvfuture: o.rfc3986.ipvFuture
    }, o.createRegex = function (e) {
      var t = o.rfc3986,
          r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?";
      if (e.relativeOnly) return o.wrap(t.relativeRef + r);
      var a = "";

      if (e.scheme) {
        s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");

        var _r39 = [].concat(e.scheme);

        s(_r39.length >= 1, "scheme must have at least 1 scheme specified");
        var _o12 = [];

        for (var _e46 = 0; _e46 < _r39.length; ++_e46) {
          var _a13 = _r39[_e46];
          s(_a13 instanceof RegExp || "string" == typeof _a13, "scheme at position " + _e46 + " must be a RegExp or String"), _a13 instanceof RegExp ? _o12.push(_a13.source.toString()) : (s(t.schemeRegex.test(_a13), "scheme at position " + _e46 + " must be a valid scheme"), _o12.push(n(_a13)));
        }

        a = _o12.join("|");
      }

      var i = "(?:" + (a ? "(?:" + a + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")",
          l = e.allowRelative ? "(?:" + i + "|" + t.relativeRef + ")" : i;
      return o.wrap(l + r, a);
    }, o.wrap = function (e, t) {
      return {
        raw: e = "(?=.)(?!https?:/$)".concat(e),
        regex: new RegExp("^".concat(e, "$")),
        scheme: t
      };
    }, o.uriRegex = o.createRegex({}), t.regex = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? o.createRegex(e) : o.uriRegex;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {
      try {
        for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          e[_key17] = arguments[_key17];
        }

        return JSON.stringify.apply(null, e);
      } catch (e) {
        return "[Cannot display object: " + e.message + "]";
      }
    };
  }, function (e) {
    e.exports = JSON.parse('{"version":"17.1.0"}');
  }, function (e, t, r) {
    "use strict";

    var s = {};
    e.exports = function (e) {
      if (!e) return "";
      var t = "";

      for (var _r40 = 0; _r40 < e.length; ++_r40) {
        var n = e.charCodeAt(_r40);
        s.isSafe(n) ? t += e[_r40] : t += s.escapeHtmlChar(n);
      }

      return t;
    }, s.escapeHtmlChar = function (e) {
      var t = s.namedHtml[e];
      if (void 0 !== t) return t;
      if (e >= 256) return "&#" + e + ";";
      var r = e.toString(16).padStart(2, "0");
      return "&#x".concat(r, ";");
    }, s.isSafe = function (e) {
      return void 0 !== s.safeCharCodes[e];
    }, s.namedHtml = {
      38: "&amp;",
      60: "&lt;",
      62: "&gt;",
      34: "&quot;",
      160: "&nbsp;",
      162: "&cent;",
      163: "&pound;",
      164: "&curren;",
      169: "&copy;",
      174: "&reg;"
    }, s.safeCharCodes = function () {
      var e = {};

      for (var _t38 = 32; _t38 < 123; ++_t38) {
        (_t38 >= 97 || _t38 >= 65 && _t38 <= 90 || _t38 >= 48 && _t38 <= 57 || 32 === _t38 || 46 === _t38 || 44 === _t38 || 45 === _t38 || 58 === _t38 || 95 === _t38) && (e[_t38] = null);
      }

      return e;
    }();
  }, function (e, t, r) {
    "use strict";

    var s = {
      operators: ["!", "^", "*", "/", "%", "+", "-", "<", "<=", ">", ">=", "==", "!=", "&&", "||", "??"],
      operatorCharacters: ["!", "^", "*", "/", "%", "+", "-", "<", "=", ">", "&", "|", "?"],
      operatorsOrder: [["^"], ["*", "/", "%"], ["+", "-"], ["<", "<=", ">", ">="], ["==", "!="], ["&&"], ["||", "??"]],
      operatorsPrefix: ["!", "n"],
      literals: {
        '"': '"',
        "`": "`",
        "'": "'",
        "[": "]"
      },
      numberRx: /^(?:[0-9]*\.?[0-9]*){1}$/,
      tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
      symbol: Symbol("formula"),
      settings: Symbol("settings")
    };
    t.Parser =
    /*#__PURE__*/
    function () {
      function _class13(e) {
        var _Object$assign;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class13);

        if (!t[s.settings] && t.constants) for (var _e47 in t.constants) {
          var _r41 = t.constants[_e47];
          if (null !== _r41 && !["boolean", "number", "string"].includes(typeof _r41)) throw new Error("Formula constant ".concat(_e47, " contains invalid ").concat(typeof _r41, " value type"));
        }
        this.settings = t[s.settings] ? t : Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, s.settings, !0), _defineProperty(_Object$assign, "constants", {}), _defineProperty(_Object$assign, "functions", {}), _Object$assign), t), this.single = null, this._parts = null, this._parse(e);
      }

      _createClass(_class13, [{
        key: "_parse",
        value: function _parse(e) {
          var _this7 = this;

          var r = [],
              n = "",
              o = 0,
              a = !1;

          var i = function i(e) {
            if (o) throw new Error("Formula missing closing parenthesis");
            var i = r.length ? r[r.length - 1] : null;

            if (a || n || e) {
              if (i && "reference" === i.type && ")" === e) return i.type = "function", i.value = _this7._subFormula(n, i.value), void (n = "");

              if (")" === e) {
                var _e48 = new t.Parser(n, _this7.settings);

                r.push({
                  type: "segment",
                  value: _e48
                });
              } else if (a) {
                if ("]" === a) return r.push({
                  type: "reference",
                  value: n
                }), void (n = "");
                r.push({
                  type: "literal",
                  value: n
                });
              } else if (s.operatorCharacters.includes(n)) i && "operator" === i.type && s.operators.includes(i.value + n) ? i.value += n : r.push({
                type: "operator",
                value: n
              });else if (n.match(s.numberRx)) r.push({
                type: "constant",
                value: parseFloat(n)
              });else if (void 0 !== _this7.settings.constants[n]) r.push({
                type: "constant",
                value: _this7.settings.constants[n]
              });else {
                if (!n.match(s.tokenRx)) throw new Error("Formula contains invalid token: ".concat(n));
                r.push({
                  type: "reference",
                  value: n
                });
              }

              n = "";
            }
          };

          var _iteratorNormalCompletion62 = true;
          var _didIteratorError62 = false;
          var _iteratorError62 = undefined;

          try {
            for (var _iterator62 = e[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
              var _t39 = _step62.value;
              a ? _t39 === a ? (i(), a = !1) : n += _t39 : o ? "(" === _t39 ? (n += _t39, ++o) : ")" === _t39 ? (--o, o ? n += _t39 : i(_t39)) : n += _t39 : _t39 in s.literals ? a = s.literals[_t39] : "(" === _t39 ? (i(), ++o) : s.operatorCharacters.includes(_t39) ? (i(), n = _t39, i()) : " " !== _t39 ? n += _t39 : i();
            }
          } catch (err) {
            _didIteratorError62 = true;
            _iteratorError62 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion62 && _iterator62.return != null) {
                _iterator62.return();
              }
            } finally {
              if (_didIteratorError62) {
                throw _iteratorError62;
              }
            }
          }

          i(), r = r.map(function (e, t) {
            return "operator" !== e.type || "-" !== e.value || t && "operator" !== r[t - 1].type ? e : {
              type: "operator",
              value: "n"
            };
          });
          var l = !1;
          var _iteratorNormalCompletion63 = true;
          var _didIteratorError63 = false;
          var _iteratorError63 = undefined;

          try {
            for (var _iterator63 = r[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
              var _e49 = _step63.value;

              if ("operator" === _e49.type) {
                if (s.operatorsPrefix.includes(_e49.value)) continue;
                if (!l) throw new Error("Formula contains an operator in invalid position");
                if (!s.operators.includes(_e49.value)) throw new Error("Formula contains an unknown operator ".concat(_e49.value));
              } else if (l) throw new Error("Formula missing expected operator");

              l = !l;
            }
          } catch (err) {
            _didIteratorError63 = true;
            _iteratorError63 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion63 && _iterator63.return != null) {
                _iterator63.return();
              }
            } finally {
              if (_didIteratorError63) {
                throw _iteratorError63;
              }
            }
          }

          if (!l) throw new Error("Formula contains invalid trailing operator");
          1 === r.length && ["reference", "literal", "constant"].includes(r[0].type) && (this.single = {
            type: "reference" === r[0].type ? "reference" : "value",
            value: r[0].value
          }), this._parts = r.map(function (e) {
            if ("operator" === e.type) return s.operatorsPrefix.includes(e.value) ? e : e.value;
            if ("reference" !== e.type) return e.value;
            if (_this7.settings.tokenRx && !_this7.settings.tokenRx.test(e.value)) throw new Error("Formula contains invalid reference ".concat(e.value));
            return _this7.settings.reference ? _this7.settings.reference(e.value) : s.reference(e.value);
          });
        }
      }, {
        key: "_subFormula",
        value: function _subFormula(e, r) {
          var _this8 = this;

          var n = this.settings.functions[r];
          if ("function" != typeof n) throw new Error("Formula contains unknown function ".concat(r));
          var o = [];

          if (e) {
            var _t40 = "",
                _n17 = 0,
                a = !1;

            var i = function i() {
              if (!_t40) throw new Error("Formula contains function ".concat(r, " with invalid arguments ").concat(e));
              o.push(_t40), _t40 = "";
            };

            for (var _r42 = 0; _r42 < e.length; ++_r42) {
              var _o13 = e[_r42];
              a ? (_t40 += _o13, _o13 === a && (a = !1)) : _o13 in s.literals && !_n17 ? (_t40 += _o13, a = s.literals[_o13]) : "," !== _o13 || _n17 ? (_t40 += _o13, "(" === _o13 ? ++_n17 : ")" === _o13 && --_n17) : i();
            }

            i();
          }

          return o = o.map(function (e) {
            return new t.Parser(e, _this8.settings);
          }), function (e) {
            var t = [];
            var _iteratorNormalCompletion64 = true;
            var _didIteratorError64 = false;
            var _iteratorError64 = undefined;

            try {
              for (var _iterator64 = o[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
                var _r43 = _step64.value;
                t.push(_r43.evaluate(e));
              }
            } catch (err) {
              _didIteratorError64 = true;
              _iteratorError64 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion64 && _iterator64.return != null) {
                  _iterator64.return();
                }
              } finally {
                if (_didIteratorError64) {
                  throw _iteratorError64;
                }
              }
            }

            return n.call.apply(n, [e].concat(t));
          };
        }
      }, {
        key: "evaluate",
        value: function evaluate(e) {
          var t = this._parts.slice();

          for (var _r44 = t.length - 2; _r44 >= 0; --_r44) {
            var n = t[_r44];

            if (n && "operator" === n.type) {
              var o = t[_r44 + 1];
              t.splice(_r44 + 1, 1);
              var a = s.evaluate(o, e);
              t[_r44] = s.single(n.value, a);
            }
          }

          return s.operatorsOrder.forEach(function (r) {
            for (var _n18 = 1; _n18 < t.length - 1;) {
              if (r.includes(t[_n18])) {
                var _r45 = t[_n18],
                    _o14 = s.evaluate(t[_n18 - 1], e),
                    _a14 = s.evaluate(t[_n18 + 1], e);

                t.splice(_n18, 2);
                var i = s.calculate(_r45, _o14, _a14);
                t[_n18 - 1] = 0 === i ? 0 : i;
              } else _n18 += 2;
            }
          }), s.evaluate(t[0], e);
        }
      }]);

      return _class13;
    }(), t.Parser.prototype[s.symbol] = !0, s.reference = function (e) {
      return function (t) {
        return t && void 0 !== t[e] ? t[e] : null;
      };
    }, s.evaluate = function (e, t) {
      return null === e ? null : "function" == typeof e ? e(t) : e[s.symbol] ? e.evaluate(t) : e;
    }, s.single = function (e, t) {
      if ("!" === e) return !t;
      var r = -t;
      return 0 === r ? 0 : r;
    }, s.calculate = function (e, t, r) {
      if ("??" === e) return s.exists(t) ? t : r;

      if ("string" == typeof t || "string" == typeof r) {
        if ("+" === e) return (t = s.exists(t) ? t : "") + (r = s.exists(r) ? r : "");
      } else switch (e) {
        case "^":
          return Math.pow(t, r);

        case "*":
          return t * r;

        case "/":
          return t / r;

        case "%":
          return t % r;

        case "+":
          return t + r;

        case "-":
          return t - r;
      }

      switch (e) {
        case "<":
          return t < r;

        case "<=":
          return t <= r;

        case ">":
          return t > r;

        case ">=":
          return t >= r;

        case "==":
          return t === r;

        case "!=":
          return t !== r;

        case "&&":
          return t && r;

        case "||":
          return t || r;
      }

      return null;
    }, s.exists = function (e) {
      return null != e;
    };
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = r(1),
        a = r(8),
        i = r(4),
        l = r(5),
        c = {};
    e.exports = n.extend({
      type: "alternatives",
      flags: {
        match: {
          default: "any"
        }
      },
      terms: {
        matches: {
          init: [],
          register: l.toSibling
        }
      },
      args: function args(e) {
        for (var _len18 = arguments.length, t = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
          t[_key18 - 1] = arguments[_key18];
        }

        return 1 === t.length && Array.isArray(t[0]) ? e.try.apply(e, _toConsumableArray(t[0])) : e.try.apply(e, t);
      },
      validate: function validate(e, t) {
        var r = t.schema,
            s = t.error,
            n = t.state,
            o = t.prefs;

        if (r._flags.match) {
          var _t41,
              _a15 = 0;

          for (var _s20 = 0; _s20 < r.$_terms.matches.length; ++_s20) {
            var _i18 = r.$_terms.matches[_s20],
                _l7 = n.nest(_i18.schema, "match.".concat(_s20));

            _l7.snapshot();

            var _c7 = _i18.schema.$_validate(e, _l7, o);

            _c7.errors ? _l7.restore() : (++_a15, _t41 = _c7.value);
          }

          return _a15 ? "one" === r._flags.match ? 1 === _a15 ? {
            value: _t41
          } : {
            errors: s("alternatives.one")
          } : _a15 === r.$_terms.matches.length ? {
            value: e
          } : {
            errors: s("alternatives.all")
          } : {
            errors: s("alternatives.any")
          };
        }

        var a = [];

        for (var _t42 = 0; _t42 < r.$_terms.matches.length; ++_t42) {
          var _s21 = r.$_terms.matches[_t42];

          if (_s21.schema) {
            var _r46 = n.nest(_s21.schema, "match.".concat(_t42));

            _r46.snapshot();

            var _i20 = _s21.schema.$_validate(e, _r46, o);

            if (!_i20.errors) return _i20;
            _r46.restore(), a.push({
              schema: _s21.schema,
              reports: _i20.errors
            });
            continue;
          }

          var _i19 = _s21.ref ? _s21.ref.resolve(e, n, o) : e,
              _l8 = _s21.is ? [_s21] : _s21.switch;

          for (var _r47 = 0; _r47 < _l8.length; ++_r47) {
            var _a16 = _l8[_r47],
                _c8 = _a16.is,
                u = _a16.then,
                f = _a16.otherwise,
                m = "match.".concat(_t42).concat(_s21.switch ? "." + _r47 : "");

            if (_c8.$_match(_i19, n.nest(_c8, "".concat(m, ".is")), o)) {
              if (u) return u.$_validate(e, n.nest(u, "".concat(m, ".then")), o);
            } else if (f) return f.$_validate(e, n.nest(f, "".concat(m, ".otherwise")), o);
          }
        }

        return c.errors(a, t);
      },
      rules: {
        conditional: {
          method: function method(e, t) {
            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
            var r = this.clone(),
                n = a.when(r, e, t),
                o = n.is ? [n] : n.switch;
            var _iteratorNormalCompletion65 = true;
            var _didIteratorError65 = false;
            var _iteratorError65 = undefined;

            try {
              for (var _iterator65 = o[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
                var _e50 = _step65.value;

                if (_e50.then && _e50.otherwise) {
                  r.$_setFlag("_endedSwitch", !0, {
                    clone: !1
                  });
                  break;
                }
              }
            } catch (err) {
              _didIteratorError65 = true;
              _iteratorError65 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion65 && _iterator65.return != null) {
                  _iterator65.return();
                }
              } finally {
                if (_didIteratorError65) {
                  throw _iteratorError65;
                }
              }
            }

            return r.$_terms.matches.push(n), r.$_mutateRebuild();
          }
        },
        match: {
          method: function method(e) {
            if (s(["any", "one", "all"].includes(e), "Invalid alternatives match mode", e), "any" !== e) {
              var _iteratorNormalCompletion66 = true;
              var _didIteratorError66 = false;
              var _iteratorError66 = undefined;

              try {
                for (var _iterator66 = this.$_terms.matches[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
                  var _t43 = _step66.value;
                  s(_t43.schema, "Cannot combine match mode", e, "with conditional rules");
                }
              } catch (err) {
                _didIteratorError66 = true;
                _iteratorError66 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion66 && _iterator66.return != null) {
                    _iterator66.return();
                  }
                } finally {
                  if (_didIteratorError66) {
                    throw _iteratorError66;
                  }
                }
              }
            }

            return this.$_setFlag("match", e);
          }
        },
        try: {
          method: function method() {
            for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
              e[_key19] = arguments[_key19];
            }

            s(e.length, "Missing alternative schemas"), o.verifyFlat(e, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
            var t = this.clone();

            for (var _i21 = 0, _e51 = e; _i21 < _e51.length; _i21++) {
              var _r48 = _e51[_i21];
              t.$_terms.matches.push({
                schema: t.$_compile(_r48)
              });
            }

            return t.$_mutateRebuild();
          }
        }
      },
      overrides: {
        label: function label(e) {
          return this.$_super.label(e).$_modify({
            each: function each(t, r) {
              return "is" !== r.path[0] ? t.label(e) : void 0;
            },
            ref: !1
          });
        }
      },
      rebuild: function rebuild(e) {
        e.$_modify({
          each: function each(t) {
            o.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
              clone: !1
            });
          }
        });
      },
      manifest: {
        build: function build(e, t) {
          if (t.matches) {
            var _iteratorNormalCompletion67 = true;
            var _didIteratorError67 = false;
            var _iteratorError67 = undefined;

            try {
              for (var _iterator67 = t.matches[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
                var _r49 = _step67.value;
                var _t44 = _r49.schema,
                    _s22 = _r49.ref,
                    _n19 = _r49.is,
                    _o15 = _r49.not,
                    _a17 = _r49.then,
                    _i22 = _r49.otherwise;
                e = _t44 ? e.try(_t44) : _s22 ? e.conditional(_s22, {
                  is: _n19,
                  then: _a17,
                  not: _o15,
                  otherwise: _i22,
                  switch: _r49.switch
                }) : e.conditional(_n19, {
                  then: _a17,
                  otherwise: _i22
                });
              }
            } catch (err) {
              _didIteratorError67 = true;
              _iteratorError67 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion67 && _iterator67.return != null) {
                  _iterator67.return();
                }
              } finally {
                if (_didIteratorError67) {
                  throw _iteratorError67;
                }
              }
            }
          }

          return e;
        }
      },
      messages: {
        "alternatives.all": "{{#label}} does not match all of the required types",
        "alternatives.any": "{{#label}} does not match any of the allowed types",
        "alternatives.match": "{{#label}} does not match any of the allowed types",
        "alternatives.one": "{{#label}} matches more than one allowed type",
        "alternatives.types": "{{#label}} must be one of {{#types}}"
      }
    }), c.errors = function (e, _ref11) {
      var t = _ref11.error,
          r = _ref11.state;
      if (!e.length) return {
        errors: t("alternatives.any")
      };
      if (1 === e.length) return {
        errors: e[0].reports
      };
      var s = new Set(),
          n = [];
      var _iteratorNormalCompletion68 = true;
      var _didIteratorError68 = false;
      var _iteratorError68 = undefined;

      try {
        for (var _iterator68 = e[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
          var _step68$value = _step68.value,
              _o16 = _step68$value.reports,
              _a18 = _step68$value.schema;
          if (_o16.length > 1) return c.unmatched(e, t);
          var _l9 = _o16[0];
          if (_l9 instanceof i.Report == !1) return c.unmatched(e, t);

          if (_l9.state.path.length !== r.path.length) {
            n.push({
              type: _a18.type,
              report: _l9
            });
            continue;
          }

          if ("any.only" === _l9.code) {
            var _iteratorNormalCompletion69 = true;
            var _didIteratorError69 = false;
            var _iteratorError69 = undefined;

            try {
              for (var _iterator69 = _l9.local.valids[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
                var _e52 = _step69.value;
                s.add(_e52);
              }
            } catch (err) {
              _didIteratorError69 = true;
              _iteratorError69 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion69 && _iterator69.return != null) {
                  _iterator69.return();
                }
              } finally {
                if (_didIteratorError69) {
                  throw _iteratorError69;
                }
              }
            }

            continue;
          }

          var _l9$code$split = _l9.code.split("."),
              _l9$code$split2 = _slicedToArray(_l9$code$split, 2),
              u = _l9$code$split2[0],
              f = _l9$code$split2[1];

          "base" === f ? s.add(u) : n.push({
            type: _a18.type,
            report: _l9
          });
        }
      } catch (err) {
        _didIteratorError68 = true;
        _iteratorError68 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion68 && _iterator68.return != null) {
            _iterator68.return();
          }
        } finally {
          if (_didIteratorError68) {
            throw _iteratorError68;
          }
        }
      }

      return n.length ? 1 === n.length ? {
        errors: n[0].report
      } : c.unmatched(e, t) : {
        errors: t("alternatives.types", {
          types: _toConsumableArray(s)
        })
      };
    }, c.unmatched = function (e, t) {
      var r = [];
      var _iteratorNormalCompletion70 = true;
      var _didIteratorError70 = false;
      var _iteratorError70 = undefined;

      try {
        for (var _iterator70 = e[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
          var _t45 = _step70.value;
          r.push.apply(r, _toConsumableArray(_t45.reports));
        }
      } catch (err) {
        _didIteratorError70 = true;
        _iteratorError70 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion70 && _iterator70.return != null) {
            _iterator70.return();
          }
        } finally {
          if (_didIteratorError70) {
            throw _iteratorError70;
          }
        }
      }

      return {
        errors: t("alternatives.match", i.details(r, {
          override: !1
        }))
      };
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(10),
        a = r(20),
        i = r(15),
        l = r(1),
        c = r(8),
        u = r(4),
        f = r(17),
        m = r(18),
        h = r(9),
        d = r(35),
        p = r(5),
        g = r(19),
        y = r(36),
        b = r(21),
        v = {
      Base:
      /*#__PURE__*/
      function () {
        function Base(e) {
          _classCallCheck(this, Base);

          this.type = e, this.$_root = null, this._definition = {}, this._ids = new d.Ids(), this._preferences = null, this._refs = new p.Manager(), this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map(), this.$_terms = {}, this.$_temp = {
            ruleset: null,
            whens: {}
          };
        }

        _createClass(Base, [{
          key: "describe",
          value: function describe() {
            return s("function" == typeof m.describe, "Manifest functionality disabled"), m.describe(this);
          }
        }, {
          key: "allow",
          value: function allow() {
            for (var _len20 = arguments.length, e = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
              e[_key20] = arguments[_key20];
            }

            return l.verifyFlat(e, "allow"), this._values(e, "_valids");
          }
        }, {
          key: "alter",
          value: function alter(e) {
            s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
            var t = this.clone();
            t.$_terms.alterations = t.$_terms.alterations || [];

            for (var _r50 in e) {
              var _n20 = e[_r50];
              s("function" == typeof _n20, "Alteration adjuster for", _r50, "must be a function"), t.$_terms.alterations.push({
                target: _r50,
                adjuster: _n20
              });
            }

            return t.$_temp.ruleset = !1, t;
          }
        }, {
          key: "cast",
          value: function cast(e) {
            return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
          }
        }, {
          key: "default",
          value: function _default(e, t) {
            return this._default("default", e, t);
          }
        }, {
          key: "description",
          value: function description(e) {
            return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
          }
        }, {
          key: "empty",
          value: function empty(e) {
            var t = this.clone();
            return void 0 !== e && (e = t.$_compile(e, {
              override: !1
            })), t.$_setFlag("empty", e, {
              clone: !1
            });
          }
        }, {
          key: "error",
          value: function error(e) {
            return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
          }
        }, {
          key: "example",
          value: function example(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return s(void 0 !== e, "Missing example"), l.assertOptions(t, ["override"]), this._inner("examples", e, {
              single: !0,
              override: t.override
            });
          }
        }, {
          key: "external",
          value: function external(e, t) {
            return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
              method: e,
              description: t
            }, {
              single: !0
            });
          }
        }, {
          key: "failover",
          value: function failover(e, t) {
            return this._default("failover", e, t);
          }
        }, {
          key: "forbidden",
          value: function forbidden() {
            return this.presence("forbidden");
          }
        }, {
          key: "id",
          value: function id(e) {
            return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
          }
        }, {
          key: "invalid",
          value: function invalid() {
            for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
              e[_key21] = arguments[_key21];
            }

            return this._values(e, "_invalids");
          }
        }, {
          key: "label",
          value: function label(e) {
            return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
          }
        }, {
          key: "meta",
          value: function meta(e) {
            return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
              single: !0
            });
          }
        }, {
          key: "note",
          value: function note() {
            for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
              e[_key22] = arguments[_key22];
            }

            s(e.length, "Missing notes");

            for (var _i23 = 0, _e53 = e; _i23 < _e53.length; _i23++) {
              var _t46 = _e53[_i23];
              s(_t46 && "string" == typeof _t46, "Notes must be non-empty strings");
            }

            return this._inner("notes", e);
          }
        }, {
          key: "only",
          value: function only() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
          }
        }, {
          key: "optional",
          value: function optional() {
            return this.presence("optional");
          }
        }, {
          key: "prefs",
          value: function prefs(e) {
            s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
            var t = this.clone();
            return t._preferences = l.preferences(t._preferences, e), t;
          }
        }, {
          key: "presence",
          value: function presence(e) {
            return s(["optional", "required", "forbidden"].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
          }
        }, {
          key: "raw",
          value: function raw() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return this.$_setFlag("result", e ? "raw" : void 0);
          }
        }, {
          key: "result",
          value: function result(e) {
            return s(["raw", "strip"].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
          }
        }, {
          key: "required",
          value: function required() {
            return this.presence("required");
          }
        }, {
          key: "strict",
          value: function strict(e) {
            var t = this.clone(),
                r = void 0 !== e && !e;
            return t._preferences = l.preferences(t._preferences, {
              convert: r
            }), t;
          }
        }, {
          key: "strip",
          value: function strip() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return this.$_setFlag("result", e ? "strip" : void 0);
          }
        }, {
          key: "tag",
          value: function tag() {
            for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
              e[_key23] = arguments[_key23];
            }

            s(e.length, "Missing tags");

            for (var _i24 = 0, _e54 = e; _i24 < _e54.length; _i24++) {
              var _t47 = _e54[_i24];
              s(_t47 && "string" == typeof _t47, "Tags must be non-empty strings");
            }

            return this._inner("tags", e);
          }
        }, {
          key: "unit",
          value: function unit(e) {
            return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
          }
        }, {
          key: "valid",
          value: function valid() {
            for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
              e[_key24] = arguments[_key24];
            }

            l.verifyFlat(e, "valid");
            var t = this.allow.apply(this, e);
            return t.$_setFlag("only", !!t._valids, {
              clone: !1
            }), t;
          }
        }, {
          key: "when",
          value: function when(e, t) {
            var r = this.clone();
            r.$_terms.whens || (r.$_terms.whens = []);
            var n = c.when(r, e, t);

            if (!["any", "link"].includes(r.type)) {
              var _e55 = n.is ? [n] : n.switch;

              var _iteratorNormalCompletion71 = true;
              var _didIteratorError71 = false;
              var _iteratorError71 = undefined;

              try {
                for (var _iterator71 = _e55[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
                  var _t48 = _step71.value;
                  s(!_t48.then || "any" === _t48.then.type || _t48.then.type === r.type, "Cannot combine", r.type, "with", _t48.then && _t48.then.type), s(!_t48.otherwise || "any" === _t48.otherwise.type || _t48.otherwise.type === r.type, "Cannot combine", r.type, "with", _t48.otherwise && _t48.otherwise.type);
                }
              } catch (err) {
                _didIteratorError71 = true;
                _iteratorError71 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion71 && _iterator71.return != null) {
                    _iterator71.return();
                  }
                } finally {
                  if (_didIteratorError71) {
                    throw _iteratorError71;
                  }
                }
              }
            }

            return r.$_terms.whens.push(n), r.$_mutateRebuild();
          }
        }, {
          key: "cache",
          value: function cache(e) {
            s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache");
            var t = this.clone();
            return t._cache = e || i.provider.provision(), t.$_temp.ruleset = !1, t;
          }
        }, {
          key: "clone",
          value: function clone() {
            var e = Object.create(Object.getPrototypeOf(this));
            return this._assign(e);
          }
        }, {
          key: "concat",
          value: function concat(e) {
            s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
            var t = this.clone();

            if ("any" === this.type && "any" !== e.type) {
              var _r51 = e.clone();

              for (var _i25 = 0, _Object$keys = Object.keys(t); _i25 < _Object$keys.length; _i25++) {
                var _e56 = _Object$keys[_i25];
                "type" !== _e56 && (_r51[_e56] = t[_e56]);
              }

              t = _r51;
            }

            t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
            var _iteratorNormalCompletion72 = true;
            var _didIteratorError72 = false;
            var _iteratorError72 = undefined;

            try {
              var _loop9 = function _loop9() {
                var r = _step72.value;
                t._singleRules.has(r) && (t._rules = t._rules.filter(function (e) {
                  return e.keep || e.name !== r;
                }), t._singleRules.delete(r));
              };

              for (var _iterator72 = e._singleRules.keys()[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
                _loop9();
              }
            } catch (err) {
              _didIteratorError72 = true;
              _iteratorError72 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion72 && _iterator72.return != null) {
                  _iterator72.return();
                }
              } finally {
                if (_didIteratorError72) {
                  throw _iteratorError72;
                }
              }
            }

            var _iteratorNormalCompletion73 = true;
            var _didIteratorError73 = false;
            var _iteratorError73 = undefined;

            try {
              for (var _iterator73 = e._rules[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
                var _r55 = _step73.value;
                e._definition.rules[_r55.method].multi || t._singleRules.set(_r55.name, _r55), t._rules.push(_r55);
              }
            } catch (err) {
              _didIteratorError73 = true;
              _iteratorError73 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion73 && _iterator73.return != null) {
                  _iterator73.return();
                }
              } finally {
                if (_didIteratorError73) {
                  throw _iteratorError73;
                }
              }
            }

            if (t._flags.empty && e._flags.empty) {
              t._flags.empty = t._flags.empty.concat(e._flags.empty);

              var _r52 = Object.assign({}, e._flags);

              delete _r52.empty, a(t._flags, _r52);
            } else if (e._flags.empty) {
              t._flags.empty = e._flags.empty;

              var _r53 = Object.assign({}, e._flags);

              delete _r53.empty, a(t._flags, _r53);
            } else a(t._flags, e._flags);

            for (var _r54 in e.$_terms) {
              var _s23 = e.$_terms[_r54];
              _s23 ? t.$_terms[_r54] ? t.$_terms[_r54] = t.$_terms[_r54].concat(_s23) : t.$_terms[_r54] = _s23.slice() : t.$_terms[_r54] || (t.$_terms[_r54] = _s23);
            }

            return this.$_root._tracer && this.$_root._tracer._combine(t, [this, e]), t.$_mutateRebuild();
          }
        }, {
          key: "extend",
          value: function extend(e) {
            return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
          }
        }, {
          key: "extract",
          value: function extract(e) {
            return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
          }
        }, {
          key: "fork",
          value: function fork(e, t) {
            s(!this._inRuleset(), "Cannot fork inside a ruleset");
            var r = this;
            var _iteratorNormalCompletion74 = true;
            var _didIteratorError74 = false;
            var _iteratorError74 = undefined;

            try {
              for (var _iterator74 = [].concat(e)[Symbol.iterator](), _step74; !(_iteratorNormalCompletion74 = (_step74 = _iterator74.next()).done); _iteratorNormalCompletion74 = true) {
                var _s24 = _step74.value;
                _s24 = Array.isArray(_s24) ? _s24 : _s24.split("."), r = r._ids.fork(_s24, t, r);
              }
            } catch (err) {
              _didIteratorError74 = true;
              _iteratorError74 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion74 && _iterator74.return != null) {
                  _iterator74.return();
                }
              } finally {
                if (_didIteratorError74) {
                  throw _iteratorError74;
                }
              }
            }

            return r.$_temp.ruleset = !1, r;
          }
        }, {
          key: "rule",
          value: function rule(e) {
            var t = this._definition;
            l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
            var r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
            s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
            var o = this.clone();

            for (var _a19 = r; _a19 < o._rules.length; ++_a19) {
              var _r56 = o._rules[_a19],
                  _i26 = n(_r56);

              for (var _n21 in e) {
                t.modifiers[_n21](_i26, e[_n21]), s(_i26.name === _r56.name, "Cannot change rule name");
              }

              o._rules[_a19] = _i26, o._singleRules.get(_i26.name) === _r56 && o._singleRules.set(_i26.name, _i26);
            }

            return o.$_temp.ruleset = !1, o.$_mutateRebuild();
          }
        }, {
          key: "tailor",
          value: function tailor(e) {
            e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
            var t = this;

            if (this.$_terms.alterations) {
              var _iteratorNormalCompletion75 = true;
              var _didIteratorError75 = false;
              var _iteratorError75 = undefined;

              try {
                for (var _iterator75 = this.$_terms.alterations[Symbol.iterator](), _step75; !(_iteratorNormalCompletion75 = (_step75 = _iterator75.next()).done); _iteratorNormalCompletion75 = true) {
                  var _step75$value = _step75.value,
                      _r57 = _step75$value.target,
                      _n22 = _step75$value.adjuster;
                  e.includes(_r57) && (t = _n22(t), s(l.isSchema(t), "Alteration adjuster for", _r57, "failed to return a schema object"));
                }
              } catch (err) {
                _didIteratorError75 = true;
                _iteratorError75 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion75 && _iterator75.return != null) {
                    _iterator75.return();
                  }
                } finally {
                  if (_didIteratorError75) {
                    throw _iteratorError75;
                  }
                }
              }
            }

            return t = t.$_modify({
              each: function each(t) {
                return t.tailor(e);
              },
              ref: !1
            }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
          }
        }, {
          key: "tracer",
          value: function tracer() {
            return g.location ? g.location(this) : this;
          }
        }, {
          key: "validate",
          value: function validate(e, t) {
            return y.entry(e, this, t);
          }
        }, {
          key: "validateAsync",
          value: function validateAsync(e, t) {
            return y.entryAsync(e, this, t);
          }
        }, {
          key: "$_addRule",
          value: function $_addRule(e) {
            "string" == typeof e && (e = {
              name: e
            }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");

            for (var _t49 in e) {
              s("_" !== _t49[0], "Cannot set private rule properties");
            }

            var t = Object.assign({}, e);
            t._resolve = [], t.method = t.method || t.name;
            var r = this._definition.rules[t.method],
                n = t.args;
            s(r, "Unknown rule", t.method);
            var o = this.clone();

            if (n) {
              s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);

              for (var _e57 in n) {
                var _a20 = n[_e57];

                if (void 0 !== _a20) {
                  if (r.argsByName) {
                    var _i27 = r.argsByName.get(_e57);

                    if (_i27.ref && l.isResolvable(_a20)) t._resolve.push(_e57), o.$_mutateRegister(_a20);else if (_i27.normalize && (_a20 = _i27.normalize(_a20), n[_e57] = _a20), _i27.assert) {
                      var _t50 = l.validateArg(_a20, _e57, _i27);

                      s(!_t50, _t50, "or reference");
                    }
                  }

                  n[_e57] = _a20;
                } else delete n[_e57];
              }
            }

            return r.multi || (o._ruleRemove(t.name, {
              clone: !1
            }), o._singleRules.set(t.name, t)), !1 === o.$_temp.ruleset && (o.$_temp.ruleset = null), r.priority ? o._rules.unshift(t) : o._rules.push(t), o;
          }
        }, {
          key: "$_compile",
          value: function $_compile(e, t) {
            return c.schema(this.$_root, e, t);
          }
        }, {
          key: "$_createError",
          value: function $_createError(e, t, r, s, n) {
            var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            var a = !1 !== o.flags ? this._flags : {},
                i = o.messages ? h.merge(this._definition.messages, o.messages) : this._definition.messages;
            return new u.Report(e, t, r, a, i, s, n);
          }
        }, {
          key: "$_getFlag",
          value: function $_getFlag(e) {
            return this._flags[e];
          }
        }, {
          key: "$_getRule",
          value: function $_getRule(e) {
            return this._singleRules.get(e);
          }
        }, {
          key: "$_mapLabels",
          value: function $_mapLabels(e) {
            return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
          }
        }, {
          key: "$_match",
          value: function $_match(e, t, r, s) {
            (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
            var n = !y.validate(e, this, t, r, s).errors;
            return t.restore(), n;
          }
        }, {
          key: "$_modify",
          value: function $_modify(e) {
            return l.assertOptions(e, ["each", "once", "ref", "schema"]), d.schema(this, e) || this;
          }
        }, {
          key: "$_mutateRebuild",
          value: function $_mutateRebuild() {
            var _this9 = this;

            s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset();
            return this.$_modify({
              each: function each(e, _ref12) {
                var t = _ref12.source,
                    r = _ref12.name,
                    s = _ref12.path,
                    n = _ref12.key;
                var o = _this9._definition[t][r] && _this9._definition[t][r].register;
                !1 !== o && _this9.$_mutateRegister(e, {
                  family: o,
                  key: n
                });
              }
            }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
          }
        }, {
          key: "$_mutateRegister",
          value: function $_mutateRegister(e) {
            var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                t = _ref13.family,
                r = _ref13.key;

            this._refs.register(e, t), this._ids.register(e, {
              key: r
            });
          }
        }, {
          key: "$_property",
          value: function $_property(e) {
            return this._definition.properties[e];
          }
        }, {
          key: "$_reach",
          value: function $_reach(e) {
            return this._ids.reach(e);
          }
        }, {
          key: "$_rootReferences",
          value: function $_rootReferences() {
            return this._refs.roots();
          }
        }, {
          key: "$_setFlag",
          value: function $_setFlag(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
            var n = this._definition.flags[e] || {};
            if (o(t, n.default) && (t = void 0), o(t, this._flags[e])) return this;
            var a = !1 !== r.clone ? this.clone() : this;
            return void 0 !== t ? (a._flags[e] = t, a.$_mutateRegister(t)) : delete a._flags[e], "_" !== e[0] && (a.$_temp.ruleset = !1), a;
          }
        }, {
          key: "$_validate",
          value: function $_validate(e, t, r) {
            return y.validate(e, this, t, r);
          }
        }, {
          key: "_assign",
          value: function _assign(e) {
            e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
              shallow: !0
            }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};

            for (var _t51 in this.$_terms) {
              e.$_terms[_t51] = this.$_terms[_t51] ? this.$_terms[_t51].slice() : null;
            }

            e.$_super = {};

            for (var _t52 in this.$_super) {
              e.$_super[_t52] = this._super[_t52].bind(e);
            }

            return e;
          }
        }, {
          key: "_default",
          value: function _default(e, t) {
            var _t53;

            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = (_t53 = {}, _defineProperty(_t53, l.symbols.literal, !0), _defineProperty(_t53, "literal", t), _t53)), this.$_setFlag(e, t);
          }
        }, {
          key: "_generate",
          value: function _generate(e, t, r) {
            if (!this.$_terms.whens) return {
              schema: this
            };
            var s = [],
                n = [];

            for (var _o17 = 0; _o17 < this.$_terms.whens.length; ++_o17) {
              var _a21 = this.$_terms.whens[_o17];

              if (_a21.concat) {
                s.push(_a21.concat), n.push("".concat(_o17, ".concat"));
                continue;
              }

              var _i28 = _a21.ref ? _a21.ref.resolve(e, t, r) : e,
                  _l10 = _a21.is ? [_a21] : _a21.switch,
                  _c9 = n.length;

              for (var _c10 = 0; _c10 < _l10.length; ++_c10) {
                var _l10$_c = _l10[_c10],
                    _u4 = _l10$_c.is,
                    _f3 = _l10$_c.then,
                    _m3 = _l10$_c.otherwise,
                    _h2 = "".concat(_o17).concat(_a21.switch ? "." + _c10 : "");

                if (_u4.$_match(_i28, t.nest(_u4, "".concat(_h2, ".is")), r)) {
                  if (_f3) {
                    var _o18 = t.localize([].concat(_toConsumableArray(t.path), ["".concat(_h2, ".then")]), t.ancestors, t.schemas),
                        _f3$_generate = _f3._generate(e, _o18, r),
                        _a22 = _f3$_generate.schema,
                        _i29 = _f3$_generate.id;

                    s.push(_a22), n.push("".concat(_h2, ".then").concat(_i29 ? "(".concat(_i29, ")") : ""));
                    break;
                  }
                } else if (_m3) {
                  var _o19 = t.localize([].concat(_toConsumableArray(t.path), ["".concat(_h2, ".otherwise")]), t.ancestors, t.schemas),
                      _m3$_generate = _m3._generate(e, _o19, r),
                      _a23 = _m3$_generate.schema,
                      _i30 = _m3$_generate.id;

                  s.push(_a23), n.push("".concat(_h2, ".otherwise").concat(_i30 ? "(".concat(_i30, ")") : ""));
                  break;
                }
              }

              if (_a21.break && n.length > _c9) break;
            }

            var o = n.join(", ");
            if (t.mainstay.tracer.debug(t, "rule", "when", o), !o) return {
              schema: this
            };
            if (!t.mainstay.tracer.active && this.$_temp.whens[o]) return {
              schema: this.$_temp.whens[o],
              id: o
            };
            var a = this;
            this._definition.generate && (a = this._definition.generate(this, e, t, r));

            for (var _i31 = 0, _s25 = s; _i31 < _s25.length; _i31++) {
              var _e58 = _s25[_i31];
              a = a.concat(_e58);
            }

            return this.$_root._tracer && this.$_root._tracer._combine(a, [this].concat(s)), this.$_temp.whens[o] = a, {
              schema: a,
              id: o
            };
          }
        }, {
          key: "_inner",
          value: function _inner(e, t) {
            var _n$$_terms$e;

            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            s(!this._inRuleset(), "Cannot set ".concat(e, " inside a ruleset"));
            var n = this.clone();
            return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : (_n$$_terms$e = n.$_terms[e]).push.apply(_n$$_terms$e, _toConsumableArray(t)), n.$_temp.ruleset = !1, n;
          }
        }, {
          key: "_inRuleset",
          value: function _inRuleset() {
            return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
          }
        }, {
          key: "_ruleRemove",
          value: function _ruleRemove(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!this._singleRules.has(e)) return this;
            var r = !1 !== t.clone ? this.clone() : this;

            r._singleRules.delete(e);

            var s = [];

            for (var _t54 = 0; _t54 < r._rules.length; ++_t54) {
              var _n23 = r._rules[_t54];
              _n23.name !== e || _n23.keep ? s.push(_n23) : r._inRuleset() && _t54 < r.$_temp.ruleset && --r.$_temp.ruleset;
            }

            return r._rules = s, r;
          }
        }, {
          key: "_values",
          value: function _values(e, t) {
            l.verifyFlat(e, t.slice(1, -1));
            var r = this.clone(),
                n = e[0] === l.symbols.override;
            if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b() : n && (r[t] = e.length ? new b() : null, r.$_mutateRebuild()), !r[t]) return r;
            n && r[t].override();
            var _iteratorNormalCompletion76 = true;
            var _didIteratorError76 = false;
            var _iteratorError76 = undefined;

            try {
              for (var _iterator76 = e[Symbol.iterator](), _step76; !(_iteratorNormalCompletion76 = (_step76 = _iterator76.next()).done); _iteratorNormalCompletion76 = true) {
                var _n24 = _step76.value;
                s(void 0 !== _n24, "Cannot call allow/valid/invalid with undefined"), s(_n24 !== l.symbols.override, "Override must be the first value");

                var _e59 = "_invalids" === t ? "_valids" : "_invalids";

                r[_e59] && (r[_e59].remove(_n24), r[_e59].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", _n24, "leaves schema rejecting all values due to previous valid rule"), r[_e59] = null)), r[t].add(_n24, r._refs);
              }
            } catch (err) {
              _didIteratorError76 = true;
              _iteratorError76 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion76 && _iterator76.return != null) {
                  _iterator76.return();
                }
              } finally {
                if (_didIteratorError76) {
                  throw _iteratorError76;
                }
              }
            }

            return r;
          }
        }, {
          key: "ruleset",
          get: function get() {
            s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
            var e = this.clone();
            return e.$_temp.ruleset = e._rules.length, e;
          }
        }, {
          key: "$",
          get: function get() {
            return this.ruleset;
          }
        }]);

        return Base;
      }()
    };
    v.Base.prototype[l.symbols.any] = {
      version: l.version,
      compile: c.compile,
      root: "$_root"
    }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base();
  }, function (e, t, r) {
    "use strict";

    function s(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        t && (s = s.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, s);
      }

      return r;
    }

    function n(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var o = r(0),
        a = r(1),
        i = r(5),
        l = {};
    t.Ids = l.Ids =
    /*#__PURE__*/
    function () {
      function _class14() {
        _classCallCheck(this, _class14);

        this._byId = new Map(), this._byKey = new Map(), this._schemaChain = !1;
      }

      _createClass(_class14, [{
        key: "clone",
        value: function clone() {
          var e = new l.Ids();
          return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
        }
      }, {
        key: "concat",
        value: function concat(e) {
          e._schemaChain && (this._schemaChain = !0);
          var _iteratorNormalCompletion77 = true;
          var _didIteratorError77 = false;
          var _iteratorError77 = undefined;

          try {
            for (var _iterator77 = e._byId.entries()[Symbol.iterator](), _step77; !(_iteratorNormalCompletion77 = (_step77 = _iterator77.next()).done); _iteratorNormalCompletion77 = true) {
              var _step77$value = _slicedToArray(_step77.value, 2),
                  _t55 = _step77$value[0],
                  _r58 = _step77$value[1];

              o(!this._byKey.has(_t55), "Schema id conflicts with existing key:", _t55), this._byId.set(_t55, _r58);
            }
          } catch (err) {
            _didIteratorError77 = true;
            _iteratorError77 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion77 && _iterator77.return != null) {
                _iterator77.return();
              }
            } finally {
              if (_didIteratorError77) {
                throw _iteratorError77;
              }
            }
          }

          var _iteratorNormalCompletion78 = true;
          var _didIteratorError78 = false;
          var _iteratorError78 = undefined;

          try {
            for (var _iterator78 = e._byKey.entries()[Symbol.iterator](), _step78; !(_iteratorNormalCompletion78 = (_step78 = _iterator78.next()).done); _iteratorNormalCompletion78 = true) {
              var _step78$value = _slicedToArray(_step78.value, 2),
                  _t56 = _step78$value[0],
                  _r59 = _step78$value[1];

              o(!this._byId.has(_t56), "Schema key conflicts with existing id:", _t56), this._byKey.set(_t56, _r59);
            }
          } catch (err) {
            _didIteratorError78 = true;
            _iteratorError78 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion78 && _iterator78.return != null) {
                _iterator78.return();
              }
            } finally {
              if (_didIteratorError78) {
                throw _iteratorError78;
              }
            }
          }
        }
      }, {
        key: "fork",
        value: function fork(e, t, r) {
          var s = this._collect(e);

          s.push({
            schema: r
          });
          var n = s.shift();
          var i = {
            id: n.id,
            schema: t(n.schema)
          };
          o(a.isSchema(i.schema), "adjuster function failed to return a joi schema type");
          var _iteratorNormalCompletion79 = true;
          var _didIteratorError79 = false;
          var _iteratorError79 = undefined;

          try {
            for (var _iterator79 = s[Symbol.iterator](), _step79; !(_iteratorNormalCompletion79 = (_step79 = _iterator79.next()).done); _iteratorNormalCompletion79 = true) {
              var _e60 = _step79.value;
              i = {
                id: _e60.id,
                schema: l.fork(_e60.schema, i.id, i.schema)
              };
            }
          } catch (err) {
            _didIteratorError79 = true;
            _iteratorError79 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion79 && _iterator79.return != null) {
                _iterator79.return();
              }
            } finally {
              if (_didIteratorError79) {
                throw _iteratorError79;
              }
            }
          }

          return i.schema;
        }
      }, {
        key: "labels",
        value: function labels(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var r = e[0],
              s = this._get(r);

          if (!s) return [].concat(_toConsumableArray(t), _toConsumableArray(e)).join(".");
          var n = e.slice(1);
          return t = [].concat(_toConsumableArray(t), [s.schema._flags.label || r]), n.length ? s.schema._ids.labels(n, t) : t.join(".");
        }
      }, {
        key: "reach",
        value: function reach(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var r = e[0],
              s = this._get(r);

          o(s, "Schema does not contain path", [].concat(_toConsumableArray(t), _toConsumableArray(e)).join("."));
          var n = e.slice(1);
          return n.length ? s.schema._ids.reach(n, [].concat(_toConsumableArray(t), [r])) : s.schema;
        }
      }, {
        key: "register",
        value: function register(e) {
          var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              t = _ref14.key;

          if (!e || !a.isSchema(e)) return;
          (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
          var r = e._flags.id;

          if (r) {
            var _t57 = this._byId.get(r);

            o(!_t57 || _t57.schema === e, "Cannot add different schemas with the same id:", r), o(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
              schema: e,
              id: r
            });
          }

          t && (o(!this._byKey.has(t), "Schema already contains key:", t), o(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
            schema: e,
            id: t
          }));
        }
      }, {
        key: "reset",
        value: function reset() {
          this._byId = new Map(), this._byKey = new Map(), this._schemaChain = !1;
        }
      }, {
        key: "_collect",
        value: function _collect(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

          var s = e[0],
              n = this._get(s);

          o(n, "Schema does not contain path", [].concat(_toConsumableArray(t), _toConsumableArray(e)).join(".")), r = [n].concat(_toConsumableArray(r));
          var a = e.slice(1);
          return a.length ? n.schema._ids._collect(a, [].concat(_toConsumableArray(t), [s]), r) : r;
        }
      }, {
        key: "_get",
        value: function _get(e) {
          return this._byId.get(e) || this._byKey.get(e);
        }
      }]);

      return _class14;
    }(), l.fork = function (e, r, s) {
      return t.schema(e, {
        each: function each(e, _ref15) {
          var t = _ref15.key;
          if (r === (e._flags.id || t)) return s;
        },
        ref: !1
      }).$_mutateRebuild();
    }, t.schema = function (e, t) {
      var r;

      for (var _s26 in e._flags) {
        if ("_" === _s26[0]) continue;

        var _n25 = l.scan(e._flags[_s26], {
          source: "flags",
          name: _s26
        }, t);

        void 0 !== _n25 && (r = r || e.clone(), r._flags[_s26] = _n25);
      }

      for (var _s27 = 0; _s27 < e._rules.length; ++_s27) {
        var _n26 = e._rules[_s27],
            _o20 = l.scan(_n26.args, {
          source: "rules",
          name: _n26.name
        }, t);

        if (void 0 !== _o20) {
          r = r || e.clone();

          var _t58 = Object.assign({}, _n26);

          _t58.args = _o20, r._rules[_s27] = _t58, r._singleRules.get(_n26.name) === _n26 && r._singleRules.set(_n26.name, _t58);
        }
      }

      for (var _s28 in e.$_terms) {
        if ("_" === _s28[0]) continue;

        var _n27 = l.scan(e.$_terms[_s28], {
          source: "terms",
          name: _s28
        }, t);

        void 0 !== _n27 && (r = r || e.clone(), r.$_terms[_s28] = _n27);
      }

      return r;
    }, l.scan = function (e, t, r, o, c) {
      var u = o || [];
      if (null === e || "object" != typeof e) return;
      var f;

      if (Array.isArray(e)) {
        for (var _s29 = 0; _s29 < e.length; ++_s29) {
          var _n28 = "terms" === t.source && "keys" === t.name && e[_s29].key,
              _o21 = l.scan(e[_s29], t, r, [_s29].concat(_toConsumableArray(u)), _n28);

          void 0 !== _o21 && (f = f || e.slice(), f[_s29] = _o21);
        }

        return f;
      }

      if (!1 !== r.schema && a.isSchema(e) || !1 !== r.ref && i.isRef(e)) {
        var _o22 = r.each(e, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(r), !0).forEach(function (t) {
              n(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({}, t, {
          path: u,
          key: c
        }));

        if (_o22 === e) return;
        return _o22;
      }

      for (var _s30 in e) {
        if ("_" === _s30[0]) continue;

        var _n29 = l.scan(e[_s30], t, r, [_s30].concat(_toConsumableArray(u)), c);

        void 0 !== _n29 && (f = f || Object.assign({}, e), f[_s30] = _n29);
      }

      return f;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(37),
        a = r(6),
        i = r(1),
        l = r(4),
        c = r(38),
        u = {
      result: Symbol("result")
    };
    t.entry = function (e, t, r) {
      var n = i.defaults;
      r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), n = i.preferences(i.defaults, r));
      var o = u.entry(e, t, n);
      s(!o.mainstay.externals.length, "Schema with external rules must use validateAsync()");
      var a = {
        value: o.value
      };
      return o.error && (a.error = o.error), o.mainstay.warnings.length && (a.warning = l.details(o.mainstay.warnings)), o.mainstay.debug && (a.debug = o.mainstay.debug), a;
    }, t.entryAsync =
    /*#__PURE__*/
    function () {
      var _ref16 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(e, t, r) {
        var s, n, o, _e61, _iteratorNormalCompletion80, _didIteratorError80, _iteratorError80, _iterator80, _step80, _step80$value, _t59, _r60, _s31, _n30, _o23, _i32, _r61, c;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                s = i.defaults;
                r && (s = i.preferences(i.defaults, r));
                n = u.entry(e, t, s), o = n.mainstay;

                if (!n.error) {
                  _context.next = 5;
                  break;
                }

                throw o.debug && (n.error.debug = o.debug), n.error;

              case 5:
                if (!o.externals.length) {
                  _context.next = 46;
                  break;
                }

                _e61 = n.value;
                _iteratorNormalCompletion80 = true;
                _didIteratorError80 = false;
                _iteratorError80 = undefined;
                _context.prev = 10;
                _iterator80 = o.externals[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion80 = (_step80 = _iterator80.next()).done) {
                  _context.next = 31;
                  break;
                }

                _step80$value = _step80.value, _t59 = _step80$value.method, _r60 = _step80$value.path, _s31 = _step80$value.label;
                _n30 = void 0, _o23 = void 0, _i32 = _e61;
                _r60.length && (_n30 = _r60[_r60.length - 1], _o23 = a(_e61, _r60.slice(0, -1)), _i32 = _o23[_n30]);
                _context.prev = 16;
                _context.next = 19;
                return _t59(_i32);

              case 19:
                _r61 = _context.sent;

                if (!(void 0 === _r61 || _r61 === _i32)) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("continue", 28);

              case 22:
                _o23 ? _o23[_n30] = _r61 : _e61 = _r61;
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](16);
                throw _context.t0.message += " (".concat(_s31, ")"), _context.t0;

              case 28:
                _iteratorNormalCompletion80 = true;
                _context.next = 12;
                break;

              case 31:
                _context.next = 37;
                break;

              case 33:
                _context.prev = 33;
                _context.t1 = _context["catch"](10);
                _didIteratorError80 = true;
                _iteratorError80 = _context.t1;

              case 37:
                _context.prev = 37;
                _context.prev = 38;

                if (!_iteratorNormalCompletion80 && _iterator80.return != null) {
                  _iterator80.return();
                }

              case 40:
                _context.prev = 40;

                if (!_didIteratorError80) {
                  _context.next = 43;
                  break;
                }

                throw _iteratorError80;

              case 43:
                return _context.finish(40);

              case 44:
                return _context.finish(37);

              case 45:
                n.value = _e61;

              case 46:
                if (!(!s.warnings && !s.debug)) {
                  _context.next = 48;
                  break;
                }

                return _context.abrupt("return", n.value);

              case 48:
                c = {
                  value: n.value
                };
                return _context.abrupt("return", (o.warnings.length && (c.warning = l.details(o.warnings)), o.debug && (c.debug = o.debug), c));

              case 50:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 33, 37, 45], [16, 25], [38,, 40, 44]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref16.apply(this, arguments);
      };
    }(), u.entry = function (e, r, s) {
      var _u$tracer = u.tracer(r, s),
          n = _u$tracer.tracer,
          o = _u$tracer.cleanup,
          a = {
        externals: [],
        warnings: [],
        tracer: n,
        debug: s.debug ? [] : null,
        links: r._ids._schemaChain ? new Map() : null
      },
          i = r._ids._schemaChain ? [{
        schema: r
      }] : null,
          f = new c([], [], {
        mainstay: a,
        schemas: i
      }),
          m = t.validate(e, r, f, s);

      o && r.$_root.untrace();
      var h = l.process(m.errors, e, s);
      return {
        value: m.value,
        error: h,
        mainstay: a
      };
    }, u.tracer = function (e, t) {
      return e.$_root._tracer ? {
        tracer: e.$_root._tracer._register(e)
      } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
        tracer: e.$_root.trace()._register(e),
        cleanup: !0
      }) : {
        tracer: u.ignore
      };
    }, t.validate = function (e, t, r, s) {
      var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
        var _s32 = t._cache.get(e);

        if (r.mainstay.tracer.debug(r, "validate", "cached", !!_s32), _s32) return _s32;
      }

      var o = function o(n, _o24, a) {
        return t.$_createError(n, e, _o24, a || r, s);
      },
          a = {
        original: e,
        prefs: s,
        schema: t,
        state: r,
        error: o,
        warn: function warn(e, t, s) {
          return r.mainstay.warnings.push(o(e, t, s));
        },
        message: function message(n, o) {
          return t.$_createError("custom", e, o, r, s, {
            messages: n
          });
        }
      };

      r.mainstay.tracer.entry(t, r);
      var l = t._definition;

      if (l.prepare && void 0 !== e && s.convert) {
        var _t60 = l.prepare(e, a);

        if (_t60) {
          if (r.mainstay.tracer.value(r, "prepare", e, _t60.value), _t60.errors) return u.finalize(_t60.value, [].concat(_t60.errors), a);
          e = _t60.value;
        }
      }

      if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
        var _t61 = l.coerce.method(e, a);

        if (_t61) {
          if (r.mainstay.tracer.value(r, "coerced", e, _t61.value), _t61.errors) return u.finalize(_t61.value, [].concat(_t61.errors), a);
          e = _t61.value;
        }
      }

      var c = t._flags.empty;
      c && c.$_match(u.trim(e, t), r.nest(c), i.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
      var f = n.presence || t._flags.presence || (t._flags._endedSwitch ? "ignore" : s.presence);

      if (void 0 === e) {
        if ("forbidden" === f) return u.finalize(e, null, a);
        if ("required" === f) return u.finalize(e, [t.$_createError("any.required", e, null, r, s)], a);

        if ("optional" === f) {
          if (t._flags.default !== i.symbols.deepDefault) return u.finalize(e, null, a);
          r.mainstay.tracer.value(r, "default", e, {}), e = {};
        }
      } else if ("forbidden" === f) return u.finalize(e, [t.$_createError("any.unknown", e, null, r, s)], a);

      var m = [];

      if (t._valids) {
        var _n31 = t._valids.get(e, r, s, t._flags.insensitive);

        if (_n31) return s.convert && (r.mainstay.tracer.value(r, "valids", e, _n31.value), e = _n31.value), r.mainstay.tracer.filter(t, r, "valid", _n31), u.finalize(e, null, a);

        if (t._flags.only) {
          var _n32 = t.$_createError("any.only", e, {
            valids: t._valids.values({
              display: !0
            })
          }, r, s);

          if (s.abortEarly) return u.finalize(e, [_n32], a);
          m.push(_n32);
        }
      }

      if (t._invalids) {
        var _n33 = t._invalids.get(e, r, s, t._flags.insensitive);

        if (_n33) {
          r.mainstay.tracer.filter(t, r, "invalid", _n33);

          var _o25 = t.$_createError("any.invalid", e, {
            invalids: t._invalids.values({
              display: !0
            })
          }, r, s);

          if (s.abortEarly) return u.finalize(e, [_o25], a);
          m.push(_o25);
        }
      }

      if (l.validate) {
        var _t62 = l.validate(e, a);

        if (_t62 && (r.mainstay.tracer.value(r, "base", e, _t62.value), e = _t62.value, _t62.errors)) {
          if (!Array.isArray(_t62.errors)) return m.push(_t62.errors), u.finalize(e, m, a);
          if (_t62.errors.length) return m.push.apply(m, _toConsumableArray(_t62.errors)), u.finalize(e, m, a);
        }
      }

      return t._rules.length ? u.rules(e, m, a) : u.finalize(e, m, a);
    }, u.rules = function (e, t, r) {
      var s = r.schema,
          n = r.state,
          o = r.prefs;
      var _iteratorNormalCompletion81 = true;
      var _didIteratorError81 = false;
      var _iteratorError81 = undefined;

      try {
        for (var _iterator81 = s._rules[Symbol.iterator](), _step81; !(_iteratorNormalCompletion81 = (_step81 = _iterator81.next()).done); _iteratorNormalCompletion81 = true) {
          var _a24 = _step81.value;
          var _l11 = s._definition.rules[_a24.method];

          if (_l11.convert && o.convert) {
            n.mainstay.tracer.log(s, n, "rule", _a24.name, "full");
            continue;
          }

          var _c11 = void 0,
              f = _a24.args;

          if (_a24._resolve.length) {
            f = Object.assign({}, f);
            var _iteratorNormalCompletion82 = true;
            var _didIteratorError82 = false;
            var _iteratorError82 = undefined;

            try {
              for (var _iterator82 = _a24._resolve[Symbol.iterator](), _step82; !(_iteratorNormalCompletion82 = (_step82 = _iterator82.next()).done); _iteratorNormalCompletion82 = true) {
                var _t63 = _step82.value;

                var _r62 = _l11.argsByName.get(_t63),
                    _a25 = f[_t63].resolve(e, n, o),
                    _u5 = _r62.normalize ? _r62.normalize(_a25) : _a25,
                    _m4 = i.validateArg(_u5, null, _r62);

                if (_m4) {
                  _c11 = s.$_createError("any.ref", _a25, {
                    arg: _t63,
                    ref: f[_t63],
                    reason: _m4
                  }, n, o);
                  break;
                }

                f[_t63] = _u5;
              }
            } catch (err) {
              _didIteratorError82 = true;
              _iteratorError82 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion82 && _iterator82.return != null) {
                  _iterator82.return();
                }
              } finally {
                if (_didIteratorError82) {
                  throw _iteratorError82;
                }
              }
            }
          }

          _c11 = _c11 || _l11.validate(e, r, f, _a24);
          var m = u.rule(_c11, _a24);

          if (m.errors) {
            if (n.mainstay.tracer.log(s, n, "rule", _a24.name, "error"), _a24.warn) {
              var _n$mainstay$warnings;

              (_n$mainstay$warnings = n.mainstay.warnings).push.apply(_n$mainstay$warnings, _toConsumableArray(m.errors));

              continue;
            }

            if (o.abortEarly) return u.finalize(e, m.errors, r);
            t.push.apply(t, _toConsumableArray(m.errors));
          } else n.mainstay.tracer.log(s, n, "rule", _a24.name, "pass"), n.mainstay.tracer.value(n, "rule", e, m.value, _a24.name), e = m.value;
        }
      } catch (err) {
        _didIteratorError81 = true;
        _iteratorError81 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion81 && _iterator81.return != null) {
            _iterator81.return();
          }
        } finally {
          if (_didIteratorError81) {
            throw _iteratorError81;
          }
        }
      }

      return u.finalize(e, t, r);
    }, u.rule = function (e, t) {
      return e instanceof l.Report ? (u.error(e, t), {
        errors: [e],
        value: null
      }) : Array.isArray(e) && (e[0] instanceof l.Report || e[0] instanceof Error) ? (e.forEach(function (e) {
        return u.error(e, t);
      }), {
        errors: e,
        value: null
      }) : {
        errors: null,
        value: e
      };
    }, u.error = function (e, t) {
      return t.message && e._setTemplate(t.message), e;
    }, u.finalize = function (e, t, r) {
      t = t || [];
      var n = r.schema,
          o = r.state,
          a = r.prefs;

      if (t.length) {
        var _s33 = u.default("failover", void 0, t, r);

        void 0 !== _s33 && (o.mainstay.tracer.value(o, "failover", e, _s33), e = _s33, t = []);
      }

      if (t.length && n._flags.error) if ("function" == typeof n._flags.error) {
        t = n._flags.error(t), Array.isArray(t) || (t = [t]);
        var _iteratorNormalCompletion83 = true;
        var _didIteratorError83 = false;
        var _iteratorError83 = undefined;

        try {
          for (var _iterator83 = t[Symbol.iterator](), _step83; !(_iteratorNormalCompletion83 = (_step83 = _iterator83.next()).done); _iteratorNormalCompletion83 = true) {
            var _e62 = _step83.value;
            s(_e62 instanceof Error || _e62 instanceof l.Report, "error() must return an Error object");
          }
        } catch (err) {
          _didIteratorError83 = true;
          _iteratorError83 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion83 && _iterator83.return != null) {
              _iterator83.return();
            }
          } finally {
            if (_didIteratorError83) {
              throw _iteratorError83;
            }
          }
        }
      } else t = [n._flags.error];

      if (void 0 === e) {
        var _s34 = u.default("default", e, t, r);

        o.mainstay.tracer.value(o, "default", e, _s34), e = _s34;
      }

      if (n._flags.cast && void 0 !== e) {
        var _t64 = n._definition.cast[n._flags.cast];

        if (_t64.from(e)) {
          var _s35 = _t64.to(e, r);

          o.mainstay.tracer.value(o, "cast", e, _s35, n._flags.cast), e = _s35;
        }
      }

      if (n.$_terms.externals && a.externals && !1 !== a._externals) {
        var _iteratorNormalCompletion84 = true;
        var _didIteratorError84 = false;
        var _iteratorError84 = undefined;

        try {
          for (var _iterator84 = n.$_terms.externals[Symbol.iterator](), _step84; !(_iteratorNormalCompletion84 = (_step84 = _iterator84.next()).done); _iteratorNormalCompletion84 = true) {
            var _e63 = _step84.value.method;
            o.mainstay.externals.push({
              method: _e63,
              path: o.path,
              label: l.label(n._flags, o, a)
            });
          }
        } catch (err) {
          _didIteratorError84 = true;
          _iteratorError84 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion84 && _iterator84.return != null) {
              _iterator84.return();
            }
          } finally {
            if (_didIteratorError84) {
              throw _iteratorError84;
            }
          }
        }
      }

      var i = {
        value: e,
        errors: t.length ? t : null
      };
      return n._flags.result && (i.value = "strip" === n._flags.result ? void 0 : r.original, o.mainstay.tracer.value(o, n._flags.result, e, i.value), o.shadow(e, n._flags.result)), n._cache && !1 !== a.cache && !n._refs.length && n._cache.set(r.original, i), i;
    }, u.prefs = function (e, t) {
      var r = t === i.defaults;
      return r && e._preferences[i.symbols.prefs] ? e._preferences[i.symbols.prefs] : (t = i.preferences(t, e._preferences), r && (e._preferences[i.symbols.prefs] = t), t);
    }, u.default = function (e, t, r, s) {
      var o = s.schema,
          a = s.state,
          l = s.prefs,
          c = o._flags[e];
      if (l.noDefaults || void 0 === c) return t;
      if (a.mainstay.tracer.log(o, a, "rule", e, "full"), !c) return c;

      if ("function" == typeof c) {
        var _t65 = c.length ? [n(a.ancestors[0]), s] : [];

        try {
          return c.apply(void 0, _t65);
        } catch (t) {
          return void r.push(o.$_createError("any.".concat(e), null, {
            error: t
          }, a, l));
        }
      }

      return "object" != typeof c ? c : c[i.symbols.literal] ? c.literal : i.isResolvable(c) ? c.resolve(t, a, l) : n(c);
    }, u.trim = function (e, t) {
      if ("string" != typeof e) return e;
      var r = t.$_getRule("trim");
      return r && r.args.enabled ? e.trim() : e;
    }, u.ignore = {
      active: !1,
      debug: o,
      entry: o,
      filter: o,
      log: o,
      resolve: o,
      value: o
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {};
  }, function (e, t, r) {
    "use strict";

    var s = r(2),
        n = r(6),
        o = r(1),
        a = {
      value: Symbol("value")
    };
    e.exports = a.State =
    /*#__PURE__*/
    function () {
      function _class15(e, t, r) {
        _classCallCheck(this, _class15);

        this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
      }

      _createClass(_class15, [{
        key: "localize",
        value: function localize(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var s = new a.State(e, t, this);
          return r && s.schemas && (s.schemas = [a.schemas(r)].concat(_toConsumableArray(s.schemas))), s;
        }
      }, {
        key: "nest",
        value: function nest(e, t) {
          var r = new a.State(this.path, this.ancestors, this);
          return r.schemas = r.schemas && [a.schemas(e)].concat(_toConsumableArray(r.schemas)), r.debug = t, r;
        }
      }, {
        key: "shadow",
        value: function shadow(e, t) {
          this.mainstay.shadow = this.mainstay.shadow || new a.Shadow(), this.mainstay.shadow.set(this.path, e, t);
        }
      }, {
        key: "snapshot",
        value: function snapshot() {
          this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path)));
        }
      }, {
        key: "restore",
        value: function restore() {
          this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0);
        }
      }]);

      return _class15;
    }(), a.schemas = function (e) {
      return o.isSchema(e) ? {
        schema: e
      } : e;
    }, a.Shadow =
    /*#__PURE__*/
    function () {
      function _class16() {
        _classCallCheck(this, _class16);

        this._values = null;
      }

      _createClass(_class16, [{
        key: "set",
        value: function set(e, t, r) {
          if (!e.length) return;
          if ("strip" === r && "number" == typeof e[e.length - 1]) return;
          this._values = this._values || new Map();
          var s = this._values;

          for (var _t66 = 0; _t66 < e.length; ++_t66) {
            var _r63 = e[_t66];

            var _n34 = s.get(_r63);

            _n34 || (_n34 = new Map(), s.set(_r63, _n34)), s = _n34;
          }

          s[a.value] = t;
        }
      }, {
        key: "get",
        value: function get(e) {
          var t = this.node(e);
          if (t) return t[a.value];
        }
      }, {
        key: "node",
        value: function node(e) {
          if (this._values) return n(this._values, e, {
            iterables: !0
          });
        }
      }, {
        key: "override",
        value: function override(e, t) {
          if (!this._values) return;
          var r = e.slice(0, -1),
              s = e[e.length - 1],
              o = n(this._values, r, {
            iterables: !0
          });
          t ? o.set(s, t) : o && o.delete(s);
        }
      }]);

      return _class16;
    }();
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(10),
        o = r(6),
        a = r(3),
        i = r(1),
        l = r(8),
        c = {};
    e.exports = a.extend({
      type: "array",
      flags: {
        single: {
          default: !1
        },
        sparse: {
          default: !1
        }
      },
      terms: {
        items: {
          init: [],
          manifest: "schema"
        },
        ordered: {
          init: [],
          manifest: "schema"
        },
        _exclusions: {
          init: []
        },
        _inclusions: {
          init: []
        },
        _requireds: {
          init: []
        }
      },
      coerce: {
        from: "object",
        method: function method(e, _ref17) {
          var t = _ref17.schema,
              r = _ref17.state,
              s = _ref17.prefs;
          if (!Array.isArray(e)) return;
          var n = t.$_getRule("sort");
          return n ? c.sort(t, e, n.args.options, r, s) : void 0;
        }
      },
      validate: function validate(e, _ref18) {
        var t = _ref18.schema,
            r = _ref18.error;

        if (!Array.isArray(e)) {
          if (t._flags.single) {
            var _t67 = [e];
            return _t67[i.symbols.arraySingle] = !0, {
              value: _t67
            };
          }

          return {
            errors: r("array.base")
          };
        }

        if (t.$_getRule("items") || t.$_terms.externals) return {
          value: e.slice()
        };
      },
      rules: {
        has: {
          method: function method(e) {
            e = this.$_compile(e, {
              appendPath: !0
            });
            var t = this.$_addRule({
              name: "has",
              args: {
                schema: e
              }
            });
            return t.$_mutateRegister(e), t;
          },
          validate: function validate(e, _ref19, _ref20) {
            var t = _ref19.state,
                r = _ref19.prefs,
                s = _ref19.error;
            var n = _ref20.schema;
            var o = [e].concat(_toConsumableArray(t.ancestors));

            for (var _s36 = 0; _s36 < e.length; ++_s36) {
              var _a26 = t.localize([].concat(_toConsumableArray(t.path), [_s36]), o, n);

              if (n.$_match(e[_s36], _a26, r)) return e;
            }

            var a = n._flags.label;
            return a ? s("array.hasKnown", {
              patternLabel: a
            }) : s("array.hasUnknown", null);
          },
          multi: !0
        },
        items: {
          method: function method() {
            var _this10 = this;

            for (var _len25 = arguments.length, e = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
              e[_key25] = arguments[_key25];
            }

            i.verifyFlat(e, "items");
            var t = this.$_addRule("items");

            var _loop10 = function _loop10(_r64) {
              var s = i.tryWithPath(function () {
                return _this10.$_compile(e[_r64]);
              }, _r64, {
                append: !0
              });
              t.$_terms.items.push(s);
            };

            for (var _r64 = 0; _r64 < e.length; ++_r64) {
              _loop10(_r64);
            }

            return t.$_mutateRebuild();
          },
          validate: function validate(e, _ref21) {
            var t = _ref21.schema,
                r = _ref21.error,
                s = _ref21.state,
                n = _ref21.prefs;

            var o = t.$_terms._requireds.slice(),
                a = t.$_terms.ordered.slice(),
                l = [].concat(_toConsumableArray(t.$_terms._inclusions), _toConsumableArray(o)),
                u = !e[i.symbols.arraySingle];

            delete e[i.symbols.arraySingle];
            var f = [];
            var m = e.length;

            for (var _i33 = 0; _i33 < m; ++_i33) {
              var h = e[_i33];
              var d = !1,
                  p = !1;
              var g = u ? _i33 : new Number(_i33),
                  y = [].concat(_toConsumableArray(s.path), [g]);

              if (!t._flags.sparse && void 0 === h) {
                if (f.push(r("array.sparse", {
                  key: g,
                  path: y,
                  pos: _i33,
                  value: void 0
                }, s.localize(y))), n.abortEarly) return f;
                a.shift();
                continue;
              }

              var b = [e].concat(_toConsumableArray(s.ancestors));
              var _iteratorNormalCompletion85 = true;
              var _didIteratorError85 = false;
              var _iteratorError85 = undefined;

              try {
                for (var _iterator85 = t.$_terms._exclusions[Symbol.iterator](), _step85; !(_iteratorNormalCompletion85 = (_step85 = _iterator85.next()).done); _iteratorNormalCompletion85 = true) {
                  var _e64 = _step85.value;

                  if (_e64.$_match(h, s.localize(y, b, _e64), n, {
                    presence: "ignore"
                  })) {
                    if (f.push(r("array.excludes", {
                      pos: _i33,
                      value: h
                    }, s.localize(y))), n.abortEarly) return f;
                    d = !0, a.shift();
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError85 = true;
                _iteratorError85 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion85 && _iterator85.return != null) {
                    _iterator85.return();
                  }
                } finally {
                  if (_didIteratorError85) {
                    throw _iteratorError85;
                  }
                }
              }

              if (d) continue;

              if (t.$_terms.ordered.length) {
                if (a.length) {
                  var _o26 = a.shift(),
                      _l12 = _o26.$_validate(h, s.localize(y, b, _o26), n);

                  if (_l12.errors) {
                    if (f.push.apply(f, _toConsumableArray(_l12.errors)), n.abortEarly) return f;
                  } else if ("strip" === _o26._flags.result) c.fastSplice(e, _i33), --_i33, --m;else {
                    if (!t._flags.sparse && void 0 === _l12.value) {
                      if (f.push(r("array.sparse", {
                        key: g,
                        path: y,
                        pos: _i33,
                        value: void 0
                      }, s.localize(y))), n.abortEarly) return f;
                      continue;
                    }

                    e[_i33] = _l12.value;
                  }

                  continue;
                }

                if (!t.$_terms.items.length) {
                  if (f.push(r("array.orderedLength", {
                    pos: _i33,
                    limit: t.$_terms.ordered.length
                  })), n.abortEarly) return f;
                  break;
                }
              }

              var v = [];
              var _ = o.length;

              for (var _a27 = 0; _a27 < _; ++_a27) {
                var _l13 = s.localize(y, b, o[_a27]);

                _l13.snapshot();

                var _u6 = o[_a27].$_validate(h, _l13, n);

                if (v[_a27] = _u6, !_u6.errors) {
                  if (e[_i33] = _u6.value, p = !0, c.fastSplice(o, _a27), --_a27, --_, !t._flags.sparse && void 0 === _u6.value && (f.push(r("array.sparse", {
                    key: g,
                    path: y,
                    pos: _i33,
                    value: void 0
                  }, s.localize(y))), n.abortEarly)) return f;
                  break;
                }

                _l13.restore();
              }

              if (p) continue;
              var w = n.stripUnknown && !!n.stripUnknown.arrays || !1;
              _ = l.length;
              var _iteratorNormalCompletion86 = true;
              var _didIteratorError86 = false;
              var _iteratorError86 = undefined;

              try {
                for (var _iterator86 = l[Symbol.iterator](), _step86; !(_iteratorNormalCompletion86 = (_step86 = _iterator86.next()).done); _iteratorNormalCompletion86 = true) {
                  var _a28 = _step86.value;

                  var _l14 = void 0;

                  var _u7 = o.indexOf(_a28);

                  if (-1 !== _u7) _l14 = v[_u7];else {
                    var _o27 = s.localize(y, b, _a28);

                    if (_o27.snapshot(), _l14 = _a28.$_validate(h, _o27, n), !_l14.errors) {
                      "strip" === _a28._flags.result ? (c.fastSplice(e, _i33), --_i33, --m) : t._flags.sparse || void 0 !== _l14.value ? e[_i33] = _l14.value : (f.push(r("array.sparse", {
                        key: g,
                        path: y,
                        pos: _i33,
                        value: void 0
                      }, s.localize(y))), d = !0), p = !0;
                      break;
                    }

                    _o27.restore();
                  }

                  if (1 === _) {
                    if (w) {
                      c.fastSplice(e, _i33), --_i33, --m, p = !0;
                      break;
                    }

                    if (f.push.apply(f, _toConsumableArray(_l14.errors)), n.abortEarly) return f;
                    d = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError86 = true;
                _iteratorError86 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion86 && _iterator86.return != null) {
                    _iterator86.return();
                  }
                } finally {
                  if (_didIteratorError86) {
                    throw _iteratorError86;
                  }
                }
              }

              if (!d && t.$_terms._inclusions.length && !p) {
                if (w) {
                  c.fastSplice(e, _i33), --_i33, --m;
                  continue;
                }

                if (f.push(r("array.includes", {
                  pos: _i33,
                  value: h
                }, s.localize(y))), n.abortEarly) return f;
              }
            }

            return o.length && c.fillMissedErrors(t, f, o, e, s, n), a.length && c.fillOrderedErrors(t, f, a, e, s, n), f.length ? f : e;
          },
          priority: !0,
          manifest: !1
        },
        length: {
          method: function method(e) {
            return this.$_addRule({
              name: "length",
              args: {
                limit: e
              },
              operator: "="
            });
          },
          validate: function validate(e, t, _ref22, _ref23) {
            var r = _ref22.limit;
            var s = _ref23.name,
                n = _ref23.operator,
                o = _ref23.args;
            return i.compare(e.length, r, n) ? e : t.error("array." + s, {
              limit: o.limit,
              value: e
            });
          },
          args: [{
            name: "limit",
            ref: !0,
            assert: i.limit,
            message: "must be a positive integer"
          }]
        },
        max: {
          method: function method(e) {
            return this.$_addRule({
              name: "max",
              method: "length",
              args: {
                limit: e
              },
              operator: "<="
            });
          }
        },
        min: {
          method: function method(e) {
            return this.$_addRule({
              name: "min",
              method: "length",
              args: {
                limit: e
              },
              operator: ">="
            });
          }
        },
        ordered: {
          method: function method() {
            var _this11 = this;

            for (var _len26 = arguments.length, e = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
              e[_key26] = arguments[_key26];
            }

            i.verifyFlat(e, "ordered");
            var t = this.$_addRule("items");

            var _loop11 = function _loop11(_r65) {
              var s = i.tryWithPath(function () {
                return _this11.$_compile(e[_r65]);
              }, _r65, {
                append: !0
              });
              c.validateSingle(s, t), t.$_mutateRegister(s), t.$_terms.ordered.push(s);
            };

            for (var _r65 = 0; _r65 < e.length; ++_r65) {
              _loop11(_r65);
            }

            return t.$_mutateRebuild();
          }
        },
        single: {
          method: function method(e) {
            var t = void 0 === e || !!e;
            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
          }
        },
        sort: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            i.assertOptions(e, ["by", "order"]);
            var t = {
              order: e.order || "ascending"
            };
            return e.by && (t.by = l.ref(e.by, {
              ancestor: 0
            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
              name: "sort",
              args: {
                options: t
              }
            });
          },
          validate: function validate(e, _ref24, _ref25) {
            var t = _ref24.error,
                r = _ref24.state,
                s = _ref24.prefs,
                n = _ref24.schema;
            var o = _ref25.options;

            var _c$sort = c.sort(n, e, o, r, s),
                a = _c$sort.value,
                i = _c$sort.errors;

            if (i) return i;

            for (var _r66 = 0; _r66 < e.length; ++_r66) {
              if (e[_r66] !== a[_r66]) return t("array.sort", {
                order: o.order,
                by: o.by ? o.by.key : "value"
              });
            }

            return e;
          },
          convert: !0
        },
        sparse: {
          method: function method(e) {
            var t = void 0 === e || !!e;
            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
              clone: !1
            });
          }
        },
        unique: {
          method: function method(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), i.assertOptions(t, ["ignoreUndefined", "separator"]);
            var r = {
              name: "unique",
              args: {
                options: t,
                comparator: e
              }
            };
            if (e) if ("string" == typeof e) {
              var _s37 = i.default(t.separator, ".");

              r.path = _s37 ? e.split(_s37) : [e];
            } else r.comparator = e;
            return this.$_addRule(r);
          },
          validate: function validate(e, _ref26, _ref27, _ref28) {
            var t = _ref26.state,
                r = _ref26.error,
                a = _ref26.schema;
            var i = _ref27.comparator,
                l = _ref27.options;
            var c = _ref28.comparator,
                u = _ref28.path;
            var f = {
              string: Object.create(null),
              number: Object.create(null),
              undefined: Object.create(null),
              boolean: Object.create(null),
              object: new Map(),
              function: new Map(),
              custom: new Map()
            },
                m = c || n,
                h = l.ignoreUndefined;

            for (var _n35 = 0; _n35 < e.length; ++_n35) {
              var _a29 = u ? o(e[_n35], u) : e[_n35],
                  _l15 = c ? f.custom : f[typeof _a29];

              if (s(_l15, "Failed to find unique map container for type", typeof _a29), _l15 instanceof Map) {
                var _s38 = _l15.entries();

                var _o28 = void 0;

                for (; !(_o28 = _s38.next()).done;) {
                  if (m(_o28.value[0], _a29)) {
                    var _s39 = t.localize([].concat(_toConsumableArray(t.path), [_n35]), [e].concat(_toConsumableArray(t.ancestors))),
                        _a30 = {
                      pos: _n35,
                      value: e[_n35],
                      dupePos: _o28.value[1],
                      dupeValue: e[_o28.value[1]]
                    };

                    return u && (_a30.path = i), r("array.unique", _a30, _s39);
                  }
                }

                _l15.set(_a29, _n35);
              } else {
                if ((!h || void 0 !== _a29) && void 0 !== _l15[_a29]) {
                  var _s40 = {
                    pos: _n35,
                    value: e[_n35],
                    dupePos: _l15[_a29],
                    dupeValue: e[_l15[_a29]]
                  };
                  return u && (_s40.path = i), r("array.unique", _s40, t.localize([].concat(_toConsumableArray(t.path), [_n35]), [e].concat(_toConsumableArray(t.ancestors))));
                }

                _l15[_a29] = _n35;
              }
            }

            return e;
          },
          args: ["comparator", "options"],
          multi: !0
        }
      },
      cast: {
        set: {
          from: Array.isArray,
          to: function to(e, t) {
            return new Set(e);
          }
        }
      },
      rebuild: function rebuild(e) {
        e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
        var _iteratorNormalCompletion87 = true;
        var _didIteratorError87 = false;
        var _iteratorError87 = undefined;

        try {
          for (var _iterator87 = e.$_terms.items[Symbol.iterator](), _step87; !(_iteratorNormalCompletion87 = (_step87 = _iterator87.next()).done); _iteratorNormalCompletion87 = true) {
            var _t68 = _step87.value;
            c.validateSingle(_t68, e), "required" === _t68._flags.presence ? e.$_terms._requireds.push(_t68) : "forbidden" === _t68._flags.presence ? e.$_terms._exclusions.push(_t68) : e.$_terms._inclusions.push(_t68);
          }
        } catch (err) {
          _didIteratorError87 = true;
          _iteratorError87 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion87 && _iterator87.return != null) {
              _iterator87.return();
            }
          } finally {
            if (_didIteratorError87) {
              throw _iteratorError87;
            }
          }
        }

        var _iteratorNormalCompletion88 = true;
        var _didIteratorError88 = false;
        var _iteratorError88 = undefined;

        try {
          for (var _iterator88 = e.$_terms.ordered[Symbol.iterator](), _step88; !(_iteratorNormalCompletion88 = (_step88 = _iterator88.next()).done); _iteratorNormalCompletion88 = true) {
            var _t69 = _step88.value;
            c.validateSingle(_t69, e);
          }
        } catch (err) {
          _didIteratorError88 = true;
          _iteratorError88 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion88 && _iterator88.return != null) {
              _iterator88.return();
            }
          } finally {
            if (_didIteratorError88) {
              throw _iteratorError88;
            }
          }
        }
      },
      manifest: {
        build: function build(e, t) {
          var _e65, _e66;

          return t.items && (e = (_e65 = e).items.apply(_e65, _toConsumableArray(t.items))), t.ordered && (e = (_e66 = e).ordered.apply(_e66, _toConsumableArray(t.ordered))), e;
        }
      },
      messages: {
        "array.base": "{{#label}} must be an array",
        "array.excludes": "{{#label}} contains an excluded value",
        "array.hasKnown": '{{#label}} does not contain at least one required match for type "{#patternLabel}"',
        "array.hasUnknown": "{{#label}} does not contain at least one required match",
        "array.includes": "{{#label}} does not match any of the allowed types",
        "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
        "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
        "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
        "array.length": "{{#label}} must contain {{#limit}} items",
        "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
        "array.min": "{{#label}} must contain at least {{#limit}} items",
        "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
        "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
        "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
        "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
        "array.sparse": "{{#label}} must not be a sparse array item",
        "array.unique": "{{#label}} contains a duplicate value"
      }
    }), c.fillMissedErrors = function (e, t, r, s, n, o) {
      var a = [];
      var i = 0;
      var _iteratorNormalCompletion89 = true;
      var _didIteratorError89 = false;
      var _iteratorError89 = undefined;

      try {
        for (var _iterator89 = r[Symbol.iterator](), _step89; !(_iteratorNormalCompletion89 = (_step89 = _iterator89.next()).done); _iteratorNormalCompletion89 = true) {
          var _e67 = _step89.value;
          var _t70 = _e67._flags.label;
          _t70 ? a.push(_t70) : ++i;
        }
      } catch (err) {
        _didIteratorError89 = true;
        _iteratorError89 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion89 && _iterator89.return != null) {
            _iterator89.return();
          }
        } finally {
          if (_didIteratorError89) {
            throw _iteratorError89;
          }
        }
      }

      a.length ? i ? t.push(e.$_createError("array.includesRequiredBoth", s, {
        knownMisses: a,
        unknownMisses: i
      }, n, o)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
        knownMisses: a
      }, n, o)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
        unknownMisses: i
      }, n, o));
    }, c.fillOrderedErrors = function (e, t, r, s, n, o) {
      var a = [];
      var _iteratorNormalCompletion90 = true;
      var _didIteratorError90 = false;
      var _iteratorError90 = undefined;

      try {
        for (var _iterator90 = r[Symbol.iterator](), _step90; !(_iteratorNormalCompletion90 = (_step90 = _iterator90.next()).done); _iteratorNormalCompletion90 = true) {
          var _e68 = _step90.value;
          "required" === _e68._flags.presence && a.push(_e68);
        }
      } catch (err) {
        _didIteratorError90 = true;
        _iteratorError90 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion90 && _iterator90.return != null) {
            _iterator90.return();
          }
        } finally {
          if (_didIteratorError90) {
            throw _iteratorError90;
          }
        }
      }

      a.length && c.fillMissedErrors(e, t, a, s, n, o);
    }, c.fastSplice = function (e, t) {
      var r = t;

      for (; r < e.length;) {
        e[r++] = e[r];
      }

      --e.length;
    }, c.validateSingle = function (e, t) {
      ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
        clone: !1
      }));
    }, c.sort = function (e, t, r, s, n) {
      var o = "ascending" === r.order ? 1 : -1,
          a = -1 * o,
          i = o,
          l = function l(_l16, u) {
        var f = c.compare(_l16, u, a, i);
        if (null !== f) return f;
        if (r.by && (_l16 = r.by.resolve(_l16, s, n), u = r.by.resolve(u, s, n)), f = c.compare(_l16, u, a, i), null !== f) return f;
        var m = typeof _l16;
        if (m !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
        if ("number" !== m && "string" !== m) throw e.$_createError("array.sort.unsupported", t, {
          type: m
        }, s, n);
        return "number" === m ? (_l16 - u) * o : _l16 < u ? a : i;
      };

      try {
        return {
          value: t.slice().sort(l)
        };
      } catch (e) {
        return {
          errors: e
        };
      }
    }, c.compare = function (e, t, r, s) {
      return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = r(1),
        a = r(21),
        i = {
      isBool: function isBool(e) {
        return "boolean" == typeof e;
      }
    };
    e.exports = n.extend({
      type: "boolean",
      flags: {
        sensitive: {
          default: !1
        }
      },
      terms: {
        falsy: {
          init: null,
          manifest: "values"
        },
        truthy: {
          init: null,
          manifest: "values"
        }
      },
      coerce: function coerce(e, _ref29) {
        var t = _ref29.schema;

        if ("boolean" != typeof e) {
          if ("string" == typeof e) {
            var _r67 = t._flags.sensitive ? e : e.toLowerCase();

            e = "true" === _r67 || "false" !== _r67 && e;
          }

          return "boolean" != typeof e && (e = t.$_terms.truthy && t.$_terms.truthy.has(e, null, null, !t._flags.sensitive) || (!t.$_terms.falsy || !t.$_terms.falsy.has(e, null, null, !t._flags.sensitive)) && e), {
            value: e
          };
        }
      },
      validate: function validate(e, _ref30) {
        var t = _ref30.error;
        if ("boolean" != typeof e) return {
          value: e,
          errors: t("boolean.base")
        };
      },
      rules: {
        truthy: {
          method: function method() {
            for (var _len27 = arguments.length, e = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
              e[_key27] = arguments[_key27];
            }

            o.verifyFlat(e, "truthy");
            var t = this.clone();
            t.$_terms.truthy = t.$_terms.truthy || new a();

            for (var _r68 = 0; _r68 < e.length; ++_r68) {
              var _n36 = e[_r68];
              s(void 0 !== _n36, "Cannot call truthy with undefined"), t.$_terms.truthy.add(_n36);
            }

            return t;
          }
        },
        falsy: {
          method: function method() {
            for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
              e[_key28] = arguments[_key28];
            }

            o.verifyFlat(e, "falsy");
            var t = this.clone();
            t.$_terms.falsy = t.$_terms.falsy || new a();

            for (var _r69 = 0; _r69 < e.length; ++_r69) {
              var _n37 = e[_r69];
              s(void 0 !== _n37, "Cannot call falsy with undefined"), t.$_terms.falsy.add(_n37);
            }

            return t;
          }
        },
        sensitive: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return this.$_setFlag("sensitive", e);
          }
        }
      },
      cast: {
        number: {
          from: i.isBool,
          to: function to(e, t) {
            return e ? 1 : 0;
          }
        },
        string: {
          from: i.isBool,
          to: function to(e, t) {
            return e ? "true" : "false";
          }
        }
      },
      manifest: {
        build: function build(e, t) {
          var _e69, _e70;

          return t.truthy && (e = (_e69 = e).truthy.apply(_e69, _toConsumableArray(t.truthy))), t.falsy && (e = (_e70 = e).falsy.apply(_e70, _toConsumableArray(t.falsy))), e;
        }
      },
      messages: {
        "boolean.base": "{{#label}} must be a boolean"
      }
    });
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = r(1),
        a = r(7),
        i = {
      isDate: function isDate(e) {
        return e instanceof Date;
      }
    };
    e.exports = n.extend({
      type: "date",
      coerce: {
        from: ["number", "string"],
        method: function method(e, _ref31) {
          var t = _ref31.schema;
          return {
            value: i.parse(e, t._flags.format) || e
          };
        }
      },
      validate: function validate(e, _ref32) {
        var t = _ref32.schema,
            r = _ref32.error,
            s = _ref32.prefs;
        if (e instanceof Date && !isNaN(e.getTime())) return;
        var n = t._flags.format;
        return s.convert && n && "string" == typeof e ? {
          value: e,
          errors: r("date.format", {
            format: n
          })
        } : {
          value: e,
          errors: r("date.base")
        };
      },
      rules: {
        compare: {
          method: !1,
          validate: function validate(e, t, _ref33, _ref34) {
            var r = _ref33.date;
            var s = _ref34.name,
                n = _ref34.operator,
                a = _ref34.args;
            var i = "now" === r ? Date.now() : r.getTime();
            return o.compare(e.getTime(), i, n) ? e : t.error("date." + s, {
              limit: a.date,
              value: e
            });
          },
          args: [{
            name: "date",
            ref: !0,
            normalize: function normalize(e) {
              return "now" === e ? e : i.parse(e);
            },
            assert: function assert(e) {
              return null !== e;
            },
            message: "must have a valid date format"
          }]
        },
        format: {
          method: function method(e) {
            return s(["iso", "javascript", "unix"].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
          }
        },
        greater: {
          method: function method(e) {
            return this.$_addRule({
              name: "greater",
              method: "compare",
              args: {
                date: e
              },
              operator: ">"
            });
          }
        },
        iso: {
          method: function method() {
            return this.format("iso");
          }
        },
        less: {
          method: function method(e) {
            return this.$_addRule({
              name: "less",
              method: "compare",
              args: {
                date: e
              },
              operator: "<"
            });
          }
        },
        max: {
          method: function method(e) {
            return this.$_addRule({
              name: "max",
              method: "compare",
              args: {
                date: e
              },
              operator: "<="
            });
          }
        },
        min: {
          method: function method(e) {
            return this.$_addRule({
              name: "min",
              method: "compare",
              args: {
                date: e
              },
              operator: ">="
            });
          }
        },
        timestamp: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "javascript";
            return s(["javascript", "unix"].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
          }
        }
      },
      cast: {
        number: {
          from: i.isDate,
          to: function to(e, t) {
            return e.getTime();
          }
        },
        string: {
          from: i.isDate,
          to: function to(e, _ref35) {
            var t = _ref35.prefs;
            return a.date(e, t);
          }
        }
      },
      messages: {
        "date.base": "{{#label}} must be a valid date",
        "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
        "date.greater": '{{#label}} must be greater than "{{#limit}}"',
        "date.less": '{{#label}} must be less than "{{#limit}}"',
        "date.max": '{{#label}} must be less than or equal to "{{#limit}}"',
        "date.min": '{{#label}} must be larger than or equal to "{{#limit}}"',
        "date.format.iso": "ISO 8601 date",
        "date.format.javascript": "timestamp or number of milliseconds",
        "date.format.unix": "timestamp or number of seconds"
      }
    }), i.parse = function (e, t) {
      if (e instanceof Date) return e;
      if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
      if (/^\s*$/.test(e)) return null;
      if ("iso" === t) return o.isIsoDate(e) ? i.date(e.toString()) : null;
      var r = e;

      if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
        if ("javascript" === t) return i.date(1 * e);
        if ("unix" === t) return i.date(1e3 * e);
        if ("string" == typeof r) return null;
      }

      return i.date(e);
    }, i.date = function (e) {
      var t = new Date(e);
      return isNaN(t.getTime()) ? null : t;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(22);
    e.exports = n.extend({
      type: "function",
      properties: {
        typeof: "function"
      },
      rules: {
        arity: {
          method: function method(e) {
            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
              name: "arity",
              args: {
                n: e
              }
            });
          },
          validate: function validate(e, t, _ref36) {
            var r = _ref36.n;
            return e.length === r ? e : t.error("function.arity", {
              n: r
            });
          }
        },
        class: {
          method: function method() {
            return this.$_addRule("class");
          },
          validate: function validate(e, t) {
            return /^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
              value: e
            });
          }
        },
        minArity: {
          method: function method(e) {
            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
              name: "minArity",
              args: {
                n: e
              }
            });
          },
          validate: function validate(e, t, _ref37) {
            var r = _ref37.n;
            return e.length >= r ? e : t.error("function.minArity", {
              n: r
            });
          }
        },
        maxArity: {
          method: function method(e) {
            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
              name: "maxArity",
              args: {
                n: e
              }
            });
          },
          validate: function validate(e, t, _ref38) {
            var r = _ref38.n;
            return e.length <= r ? e : t.error("function.maxArity", {
              n: r
            });
          }
        }
      },
      messages: {
        "function.arity": "{{#label}} must have an arity of {{#n}}",
        "function.class": "{{#label}} must be a class",
        "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
        "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
      }
    });
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(2),
        o = r(20),
        a = r(6),
        i = {};
    e.exports = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
      if (r.shallow) return i.applyToDefaultsWithShallow(e, t, r);
      var a = n(e);
      if (!0 === t) return a;
      var l = void 0 !== r.nullOverride && r.nullOverride;
      return o(a, t, {
        nullOverride: l,
        mergeArrays: !1
      });
    }, i.applyToDefaultsWithShallow = function (e, t, r) {
      var l = r.shallow;
      s(Array.isArray(l), "Invalid keys");
      var c = new Map(),
          u = !0 === t ? null : new Set();
      var _iteratorNormalCompletion91 = true;
      var _didIteratorError91 = false;
      var _iteratorError91 = undefined;

      try {
        for (var _iterator91 = l[Symbol.iterator](), _step91; !(_iteratorNormalCompletion91 = (_step91 = _iterator91.next()).done); _iteratorNormalCompletion91 = true) {
          var _r70 = _step91.value;
          _r70 = Array.isArray(_r70) ? _r70 : _r70.split(".");

          var _s41 = a(e, _r70);

          _s41 && "object" == typeof _s41 ? c.set(_s41, u && a(t, _r70) || _s41) : u && u.add(_r70);
        }
      } catch (err) {
        _didIteratorError91 = true;
        _iteratorError91 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion91 && _iterator91.return != null) {
            _iterator91.return();
          }
        } finally {
          if (_didIteratorError91) {
            throw _iteratorError91;
          }
        }
      }

      var f = n(e, {}, c);
      if (!u) return f;
      var _iteratorNormalCompletion92 = true;
      var _didIteratorError92 = false;
      var _iteratorError92 = undefined;

      try {
        for (var _iterator92 = u[Symbol.iterator](), _step92; !(_iteratorNormalCompletion92 = (_step92 = _iterator92.next()).done); _iteratorNormalCompletion92 = true) {
          var _e71 = _step92.value;
          i.reachCopy(f, t, _e71);
        }
      } catch (err) {
        _didIteratorError92 = true;
        _iteratorError92 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion92 && _iterator92.return != null) {
            _iterator92.return();
          }
        } finally {
          if (_didIteratorError92) {
            throw _iteratorError92;
          }
        }
      }

      return o(f, t, {
        mergeArrays: !1,
        nullOverride: !1
      });
    }, i.reachCopy = function (e, t, r) {
      var _iteratorNormalCompletion93 = true;
      var _didIteratorError93 = false;
      var _iteratorError93 = undefined;

      try {
        for (var _iterator93 = r[Symbol.iterator](), _step93; !(_iteratorNormalCompletion93 = (_step93 = _iterator93.next()).done); _iteratorNormalCompletion93 = true) {
          var _e73 = _step93.value;
          if (!(_e73 in t)) return;
          t = t[_e73];
        }
      } catch (err) {
        _didIteratorError93 = true;
        _iteratorError93 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion93 && _iterator93.return != null) {
            _iterator93.return();
          }
        } finally {
          if (_didIteratorError93) {
            throw _iteratorError93;
          }
        }
      }

      var s = t;
      var n = e;

      for (var _e72 = 0; _e72 < r.length - 1; ++_e72) {
        var _t71 = r[_e72];
        "object" != typeof n[_t71] && (n[_t71] = {}), n = n[_t71];
      }

      n[r[r.length - 1]] = s;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = {};
    t.Sorter =
    /*#__PURE__*/
    function () {
      function _class17() {
        _classCallCheck(this, _class17);

        this._items = [], this.nodes = [];
      }

      _createClass(_class17, [{
        key: "add",
        value: function add(e, t) {
          var r = [].concat((t = t || {}).before || []),
              n = [].concat(t.after || []),
              o = t.group || "?",
              a = t.sort || 0;
          s(!r.includes(o), "Item cannot come before itself: ".concat(o)), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(o), "Item cannot come after itself: ".concat(o)), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [e]);
          var _iteratorNormalCompletion94 = true;
          var _didIteratorError94 = false;
          var _iteratorError94 = undefined;

          try {
            for (var _iterator94 = e[Symbol.iterator](), _step94; !(_iteratorNormalCompletion94 = (_step94 = _iterator94.next()).done); _iteratorNormalCompletion94 = true) {
              var _t72 = _step94.value;
              var _e74 = {
                seq: this._items.length,
                sort: a,
                before: r,
                after: n,
                group: o,
                node: _t72
              };

              this._items.push(_e74);
            }
          } catch (err) {
            _didIteratorError94 = true;
            _iteratorError94 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion94 && _iterator94.return != null) {
                _iterator94.return();
              }
            } finally {
              if (_didIteratorError94) {
                throw _iteratorError94;
              }
            }
          }

          var i = this._sort();

          return s(i, "item", "?" !== o ? "added into group ".concat(o) : "", "created a dependencies error"), this.nodes;
        }
      }, {
        key: "merge",
        value: function merge(e) {
          Array.isArray(e) || (e = [e]);
          var _iteratorNormalCompletion95 = true;
          var _didIteratorError95 = false;
          var _iteratorError95 = undefined;

          try {
            for (var _iterator95 = e[Symbol.iterator](), _step95; !(_iteratorNormalCompletion95 = (_step95 = _iterator95.next()).done); _iteratorNormalCompletion95 = true) {
              var _t73 = _step95.value;

              if (_t73) {
                var _iteratorNormalCompletion96 = true;
                var _didIteratorError96 = false;
                var _iteratorError96 = undefined;

                try {
                  for (var _iterator96 = _t73._items[Symbol.iterator](), _step96; !(_iteratorNormalCompletion96 = (_step96 = _iterator96.next()).done); _iteratorNormalCompletion96 = true) {
                    var _e76 = _step96.value;

                    this._items.push(Object.assign({}, _e76));
                  }
                } catch (err) {
                  _didIteratorError96 = true;
                  _iteratorError96 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion96 && _iterator96.return != null) {
                      _iterator96.return();
                    }
                  } finally {
                    if (_didIteratorError96) {
                      throw _iteratorError96;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError95 = true;
            _iteratorError95 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion95 && _iterator95.return != null) {
                _iterator95.return();
              }
            } finally {
              if (_didIteratorError95) {
                throw _iteratorError95;
              }
            }
          }

          this._items.sort(n.mergeSort);

          for (var _e75 = 0; _e75 < this._items.length; ++_e75) {
            this._items[_e75].seq = _e75;
          }

          var t = this._sort();

          return s(t, "merge created a dependencies error"), this.nodes;
        }
      }, {
        key: "_sort",
        value: function _sort() {
          var e = {},
              t = Object.create(null),
              r = Object.create(null);
          var _iteratorNormalCompletion97 = true;
          var _didIteratorError97 = false;
          var _iteratorError97 = undefined;

          try {
            for (var _iterator97 = this._items[Symbol.iterator](), _step97; !(_iteratorNormalCompletion97 = (_step97 = _iterator97.next()).done); _iteratorNormalCompletion97 = true) {
              var _s44 = _step97.value;
              var _n40 = _s44.seq,
                  _o32 = _s44.group;
              r[_o32] = r[_o32] || [], r[_o32].push(_n40), e[_n40] = _s44.before;
              var _iteratorNormalCompletion101 = true;
              var _didIteratorError101 = false;
              var _iteratorError101 = undefined;

              try {
                for (var _iterator101 = _s44.after[Symbol.iterator](), _step101; !(_iteratorNormalCompletion101 = (_step101 = _iterator101.next()).done); _iteratorNormalCompletion101 = true) {
                  var _e80 = _step101.value;
                  t[_e80] = t[_e80] || [], t[_e80].push(_n40);
                }
              } catch (err) {
                _didIteratorError101 = true;
                _iteratorError101 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion101 && _iterator101.return != null) {
                    _iterator101.return();
                  }
                } finally {
                  if (_didIteratorError101) {
                    throw _iteratorError101;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError97 = true;
            _iteratorError97 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion97 && _iterator97.return != null) {
                _iterator97.return();
              }
            } finally {
              if (_didIteratorError97) {
                throw _iteratorError97;
              }
            }
          }

          for (var _t74 in e) {
            var _s42 = [];

            for (var _n38 in e[_t74]) {
              var _o29 = e[_t74][_n38];
              r[_o29] = r[_o29] || [], _s42.push.apply(_s42, _toConsumableArray(r[_o29]));
            }

            e[_t74] = _s42;
          }

          for (var _s43 in t) {
            if (r[_s43]) {
              var _iteratorNormalCompletion98 = true;
              var _didIteratorError98 = false;
              var _iteratorError98 = undefined;

              try {
                for (var _iterator98 = r[_s43][Symbol.iterator](), _step98; !(_iteratorNormalCompletion98 = (_step98 = _iterator98.next()).done); _iteratorNormalCompletion98 = true) {
                  var _e$_n;

                  var _n39 = _step98.value;

                  (_e$_n = e[_n39]).push.apply(_e$_n, _toConsumableArray(t[_s43]));
                }
              } catch (err) {
                _didIteratorError98 = true;
                _iteratorError98 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion98 && _iterator98.return != null) {
                    _iterator98.return();
                  }
                } finally {
                  if (_didIteratorError98) {
                    throw _iteratorError98;
                  }
                }
              }
            }
          }

          var s = {};

          for (var _t75 in e) {
            var _r71 = e[_t75];
            var _iteratorNormalCompletion99 = true;
            var _didIteratorError99 = false;
            var _iteratorError99 = undefined;

            try {
              for (var _iterator99 = _r71[Symbol.iterator](), _step99; !(_iteratorNormalCompletion99 = (_step99 = _iterator99.next()).done); _iteratorNormalCompletion99 = true) {
                var _e77 = _step99.value;
                s[_e77] = s[_e77] || [], s[_e77].push(_t75);
              }
            } catch (err) {
              _didIteratorError99 = true;
              _iteratorError99 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion99 && _iterator99.return != null) {
                  _iterator99.return();
                }
              } finally {
                if (_didIteratorError99) {
                  throw _iteratorError99;
                }
              }
            }
          }

          var n = {},
              o = [];

          for (var _e78 = 0; _e78 < this._items.length; ++_e78) {
            var _t76 = _e78;

            if (s[_e78]) {
              _t76 = null;

              for (var _e79 = 0; _e79 < this._items.length; ++_e79) {
                if (!0 === n[_e79]) continue;
                s[_e79] || (s[_e79] = []);
                var _r72 = s[_e79].length;
                var _o30 = 0;

                for (var _t77 = 0; _t77 < _r72; ++_t77) {
                  n[s[_e79][_t77]] && ++_o30;
                }

                if (_o30 === _r72) {
                  _t76 = _e79;
                  break;
                }
              }
            }

            null !== _t76 && (n[_t76] = !0, o.push(_t76));
          }

          if (o.length !== this._items.length) return !1;
          var a = {};
          var _iteratorNormalCompletion100 = true;
          var _didIteratorError100 = false;
          var _iteratorError100 = undefined;

          try {
            for (var _iterator100 = this._items[Symbol.iterator](), _step100; !(_iteratorNormalCompletion100 = (_step100 = _iterator100.next()).done); _iteratorNormalCompletion100 = true) {
              var _e81 = _step100.value;
              a[_e81.seq] = _e81;
            }
          } catch (err) {
            _didIteratorError100 = true;
            _iteratorError100 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion100 && _iterator100.return != null) {
                _iterator100.return();
              }
            } finally {
              if (_didIteratorError100) {
                throw _iteratorError100;
              }
            }
          }

          this._items = [], this.nodes = [];

          for (var _i34 = 0, _o31 = o; _i34 < _o31.length; _i34++) {
            var _e82 = _o31[_i34];
            var _t78 = a[_e82];
            this.nodes.push(_t78.node), this._items.push(_t78);
          }

          return !0;
        }
      }]);

      return _class17;
    }(), n.mergeSort = function (e, t) {
      return e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = r(1),
        a = r(8),
        i = r(4),
        l = {};
    e.exports = n.extend({
      type: "link",
      properties: {
        schemaChain: !0
      },
      terms: {
        link: {
          init: null,
          manifest: "single",
          register: !1
        }
      },
      args: function args(e, t) {
        return e.ref(t);
      },
      validate: function validate(e, _ref39) {
        var t = _ref39.schema,
            r = _ref39.state,
            n = _ref39.prefs;
        s(t.$_terms.link, "Uninitialized link schema");
        var o = l.generate(t, e, r, n),
            a = t.$_terms.link[0].ref;
        return o.$_validate(e, r.nest(o, "link:".concat(a.display, ":").concat(o.type)), n);
      },
      generate: function generate(e, t, r, s) {
        return l.generate(e, t, r, s);
      },
      rules: {
        ref: {
          method: function method(e) {
            s(!this.$_terms.link, "Cannot reinitialize schema"), e = a.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
            var t = this.clone();
            return t.$_terms.link = [{
              ref: e
            }], t;
          }
        },
        relative: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return this.$_setFlag("relative", e);
          }
        }
      },
      overrides: {
        concat: function concat(e) {
          s(this.$_terms.link, "Uninitialized link schema"), s(o.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
          var t = this.clone();
          return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
            concat: e
          }), t.$_mutateRebuild();
        }
      },
      manifest: {
        build: function build(e, t) {
          return s(t.link, "Invalid link description missing link"), e.ref(t.link);
        }
      }
    }), l.generate = function (e, t, r, s) {
      var n = r.mainstay.links.get(e);
      if (n) return n._generate(t, r, s).schema;

      var o = e.$_terms.link[0].ref,
          _l$perspective = l.perspective(o, r),
          a = _l$perspective.perspective,
          i = _l$perspective.path;

      l.assert(a, "which is outside of schema boundaries", o, e, r, s);

      try {
        n = i.length ? a.$_reach(i) : a;
      } catch (t) {
        l.assert(!1, "to non-existing schema", o, e, r, s);
      }

      return l.assert("link" !== n.type, "which is another link", o, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
    }, l.perspective = function (e, t) {
      if ("local" === e.type) {
        var _iteratorNormalCompletion102 = true;
        var _didIteratorError102 = false;
        var _iteratorError102 = undefined;

        try {
          for (var _iterator102 = t.schemas[Symbol.iterator](), _step102; !(_iteratorNormalCompletion102 = (_step102 = _iterator102.next()).done); _iteratorNormalCompletion102 = true) {
            var _step102$value = _step102.value,
                _r73 = _step102$value.schema,
                _s45 = _step102$value.key;
            if ((_r73._flags.id || _s45) === e.path[0]) return {
              perspective: _r73,
              path: e.path.slice(1)
            };

            if (_r73.$_terms.shared) {
              var _iteratorNormalCompletion103 = true;
              var _didIteratorError103 = false;
              var _iteratorError103 = undefined;

              try {
                for (var _iterator103 = _r73.$_terms.shared[Symbol.iterator](), _step103; !(_iteratorNormalCompletion103 = (_step103 = _iterator103.next()).done); _iteratorNormalCompletion103 = true) {
                  var _t79 = _step103.value;
                  if (_t79._flags.id === e.path[0]) return {
                    perspective: _t79,
                    path: e.path.slice(1)
                  };
                }
              } catch (err) {
                _didIteratorError103 = true;
                _iteratorError103 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion103 && _iterator103.return != null) {
                    _iterator103.return();
                  }
                } finally {
                  if (_didIteratorError103) {
                    throw _iteratorError103;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError102 = true;
          _iteratorError102 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion102 && _iterator102.return != null) {
              _iterator102.return();
            }
          } finally {
            if (_didIteratorError102) {
              throw _iteratorError102;
            }
          }
        }

        return {
          perspective: null,
          path: null
        };
      }

      return "root" === e.ancestor ? {
        perspective: t.schemas[t.schemas.length - 1].schema,
        path: e.path
      } : {
        perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
        path: e.path
      };
    }, l.assert = function (e, t, r, n, o, a) {
      e || s(!1, '"'.concat(i.label(n._flags, o, a), '" contains link reference "').concat(r.display, '" ').concat(t));
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = r(1),
        a = {
      numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
      precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
    };
    e.exports = n.extend({
      type: "number",
      flags: {
        unsafe: {
          default: !1
        }
      },
      coerce: {
        from: "string",
        method: function method(e, _ref40) {
          var t = _ref40.schema,
              r = _ref40.error;
          var s = e.match(a.numberRx);
          if (!s) return;
          e = e.trim();
          var n = {
            value: parseFloat(e)
          };
          if (0 === n.value && (n.value = 0), !t._flags.unsafe) if (e.match(/e/i)) {
            if (a.normalizeExponent("".concat(n.value / Math.pow(10, s[1]), "e").concat(s[1])) !== a.normalizeExponent(e)) return n.errors = r("number.unsafe"), n;
          } else {
            var _t80 = n.value.toString();

            if (_t80.match(/e/i)) return n;
            if (_t80 !== a.normalizeDecimal(e)) return n.errors = r("number.unsafe"), n;
          }
          return n;
        }
      },
      validate: function validate(e, _ref41) {
        var t = _ref41.schema,
            r = _ref41.error,
            s = _ref41.prefs;
        if (e === 1 / 0 || e === -1 / 0) return {
          value: e,
          errors: r("number.infinity")
        };
        if (!o.isNumber(e)) return {
          value: e,
          errors: r("number.base")
        };
        var n = {
          value: e
        };

        if (s.convert) {
          var _e83 = t.$_getRule("precision");

          if (_e83) {
            var _t81 = Math.pow(10, _e83.args.limit);

            n.value = Math.round(n.value * _t81) / _t81;
          }
        }

        return 0 === n.value && (n.value = 0), !t._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (n.errors = r("number.unsafe")), n;
      },
      rules: {
        compare: {
          method: !1,
          validate: function validate(e, t, _ref42, _ref43) {
            var r = _ref42.limit;
            var s = _ref43.name,
                n = _ref43.operator,
                a = _ref43.args;
            return o.compare(e, r, n) ? e : t.error("number." + s, {
              limit: a.limit,
              value: e
            });
          },
          args: [{
            name: "limit",
            ref: !0,
            assert: o.isNumber,
            message: "must be a number"
          }]
        },
        greater: {
          method: function method(e) {
            return this.$_addRule({
              name: "greater",
              method: "compare",
              args: {
                limit: e
              },
              operator: ">"
            });
          }
        },
        integer: {
          method: function method() {
            return this.$_addRule("integer");
          },
          validate: function validate(e, t) {
            return Math.trunc(e) - e == 0 ? e : t.error("number.integer");
          }
        },
        less: {
          method: function method(e) {
            return this.$_addRule({
              name: "less",
              method: "compare",
              args: {
                limit: e
              },
              operator: "<"
            });
          }
        },
        max: {
          method: function method(e) {
            return this.$_addRule({
              name: "max",
              method: "compare",
              args: {
                limit: e
              },
              operator: "<="
            });
          }
        },
        min: {
          method: function method(e) {
            return this.$_addRule({
              name: "min",
              method: "compare",
              args: {
                limit: e
              },
              operator: ">="
            });
          }
        },
        multiple: {
          method: function method(e) {
            return this.$_addRule({
              name: "multiple",
              args: {
                base: e
              }
            });
          },
          validate: function validate(e, t, _ref44, s) {
            var r = _ref44.base;
            return e % r == 0 ? e : t.error("number.multiple", {
              multiple: s.args.base,
              value: e
            });
          },
          args: [{
            name: "base",
            ref: !0,
            assert: function assert(e) {
              return "number" == typeof e && isFinite(e) && e > 0;
            },
            message: "must be a positive number"
          }],
          multi: !0
        },
        negative: {
          method: function method() {
            return this.sign("negative");
          }
        },
        port: {
          method: function method() {
            return this.$_addRule("port");
          },
          validate: function validate(e, t) {
            return Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port");
          }
        },
        positive: {
          method: function method() {
            return this.sign("positive");
          }
        },
        precision: {
          method: function method(e) {
            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
              name: "precision",
              args: {
                limit: e
              }
            });
          },
          validate: function validate(e, t, _ref45) {
            var r = _ref45.limit;
            var s = e.toString().match(a.precisionRx);
            return Math.max((s[1] ? s[1].length : 0) - (s[2] ? parseInt(s[2], 10) : 0), 0) <= r ? e : t.error("number.precision", {
              limit: r,
              value: e
            });
          },
          convert: !0
        },
        sign: {
          method: function method(e) {
            return s(["negative", "positive"].includes(e), "Invalid sign", e), this.$_addRule({
              name: "sign",
              args: {
                sign: e
              }
            });
          },
          validate: function validate(e, t, _ref46) {
            var r = _ref46.sign;
            return "negative" === r && e < 0 || "positive" === r && e > 0 ? e : t.error("number.".concat(r));
          }
        },
        unsafe: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
          }
        }
      },
      cast: {
        string: {
          from: function from(e) {
            return "number" == typeof e;
          },
          to: function to(e, t) {
            return e.toString();
          }
        }
      },
      messages: {
        "number.base": "{{#label}} must be a number",
        "number.greater": "{{#label}} must be greater than {{#limit}}",
        "number.infinity": "{{#label}} cannot be infinity",
        "number.integer": "{{#label}} must be an integer",
        "number.less": "{{#label}} must be less than {{#limit}}",
        "number.max": "{{#label}} must be less than or equal to {{#limit}}",
        "number.min": "{{#label}} must be larger than or equal to {{#limit}}",
        "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
        "number.negative": "{{#label}} must be a negative number",
        "number.port": "{{#label}} must be a valid port",
        "number.positive": "{{#label}} must be a positive number",
        "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
        "number.unsafe": "{{#label}} must be a safe number"
      }
    }), a.normalizeExponent = function (e) {
      return e.replace(/E/, "e").replace(/\.(\d*[1-9])?0+e/, ".$1e").replace(/\.e/, "e").replace(/e\+/, "e").replace(/^\+/, "").replace(/^(-?)0+([1-9])/, "$1$2");
    }, a.normalizeDecimal = function (e) {
      return (e = e.replace(/^\+/, "").replace(/\.0+$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([1-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(22);
    e.exports = s.extend({
      type: "object",
      cast: {
        map: {
          from: function from(e) {
            return e && "object" == typeof e;
          },
          to: function to(e, t) {
            return new Map(Object.entries(e));
          }
        }
      }
    });
  }, function (e, t, r) {
    "use strict";

    function s(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        t && (s = s.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, s);
      }

      return r;
    }

    function n(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? s(Object(r), !0).forEach(function (t) {
          o(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function o(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var a = r(0),
        i = r(23),
        l = r(49),
        c = r(50),
        u = r(27),
        f = r(51),
        m = r(26),
        h = r(3),
        d = r(1),
        p = {
      tlds: f instanceof Set && {
        tlds: {
          allow: f,
          deny: null
        }
      },
      base64Regex: {
        true: {
          true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
          false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
        },
        false: {
          true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
          false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
        }
      },
      dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
      hexRegex: /^[a-f0-9]+$/i,
      ipRegex: c.regex().regex,
      isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
      guidBrackets: {
        "{": "}",
        "[": "]",
        "(": ")",
        "": ""
      },
      guidVersions: {
        uuidv1: "1",
        uuidv2: "2",
        uuidv3: "3",
        uuidv4: "4",
        uuidv5: "5"
      },
      cidrPresences: ["required", "optional", "forbidden"],
      normalizationForms: ["NFC", "NFD", "NFKC", "NFKD"]
    };
    e.exports = h.extend({
      type: "string",
      flags: {
        insensitive: {
          default: !1
        },
        truncate: {
          default: !1
        }
      },
      terms: {
        replacements: {
          init: null
        }
      },
      coerce: {
        from: "string",
        method: function method(e, _ref47) {
          var t = _ref47.schema,
              r = _ref47.state,
              s = _ref47.prefs;
          var n = t.$_getRule("normalize");
          n && (e = e.normalize(n.args.form));
          var o = t.$_getRule("case");
          o && (e = "upper" === o.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
          var a = t.$_getRule("trim");

          if (a && a.args.enabled && (e = e.trim()), t.$_terms.replacements) {
            var _iteratorNormalCompletion104 = true;
            var _didIteratorError104 = false;
            var _iteratorError104 = undefined;

            try {
              for (var _iterator104 = t.$_terms.replacements[Symbol.iterator](), _step104; !(_iteratorNormalCompletion104 = (_step104 = _iterator104.next()).done); _iteratorNormalCompletion104 = true) {
                var _r74 = _step104.value;
                e = e.replace(_r74.pattern, _r74.replacement);
              }
            } catch (err) {
              _didIteratorError104 = true;
              _iteratorError104 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion104 && _iterator104.return != null) {
                  _iterator104.return();
                }
              } finally {
                if (_didIteratorError104) {
                  throw _iteratorError104;
                }
              }
            }
          }

          var i = t.$_getRule("hex");

          if (i && i.args.options.byteAligned && e.length % 2 != 0 && (e = "0".concat(e)), t.$_getRule("isoDate")) {
            var _t82 = p.isoDate(e);

            _t82 && (e = _t82);
          }

          if (t._flags.truncate) {
            var _n41 = t.$_getRule("max");

            if (_n41) {
              var _o33 = _n41.args.limit;
              if (d.isResolvable(_o33) && (_o33 = _o33.resolve(e, r, s), !d.limit(_o33))) return {
                value: e,
                errors: t.$_createError("any.ref", _o33, {
                  ref: _n41.args.limit,
                  arg: "limit",
                  reason: "must be a positive integer"
                }, r, s)
              };
              e = e.slice(0, _o33);
            }
          }

          return {
            value: e
          };
        }
      },
      validate: function validate(e, _ref48) {
        var t = _ref48.error;
        return "string" != typeof e ? {
          value: e,
          errors: t("string.base")
        } : "" === e ? {
          value: e,
          errors: t("string.empty")
        } : void 0;
      },
      rules: {
        alphanum: {
          method: function method() {
            return this.$_addRule("alphanum");
          },
          validate: function validate(e, t) {
            return /^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum");
          }
        },
        base64: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return d.assertOptions(e, ["paddingRequired", "urlSafe"]), e = n({
              urlSafe: !1,
              paddingRequired: !0
            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), a("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
              name: "base64",
              args: {
                options: e
              }
            });
          },
          validate: function validate(e, t, _ref49) {
            var r = _ref49.options;
            return p.base64Regex[r.paddingRequired][r.urlSafe].test(e) ? e : t.error("string.base64");
          }
        },
        case: {
          method: function method(e) {
            return a(["lower", "upper"].includes(e), "Invalid case:", e), this.$_addRule({
              name: "case",
              args: {
                direction: e
              }
            });
          },
          validate: function validate(e, t, _ref50) {
            var r = _ref50.direction;
            return "lower" === r && e === e.toLocaleLowerCase() || "upper" === r && e === e.toLocaleUpperCase() ? e : t.error("string.".concat(r, "case"));
          },
          convert: !0
        },
        creditCard: {
          method: function method() {
            return this.$_addRule("creditCard");
          },
          validate: function validate(e, t) {
            var r = e.length,
                s = 0,
                n = 1;

            for (; r--;) {
              var _t83 = e.charAt(r) * n;

              s += _t83 - 9 * (_t83 > 9), n ^= 3;
            }

            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
          }
        },
        dataUri: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return d.assertOptions(e, ["paddingRequired"]), e = n({
              paddingRequired: !0
            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
              name: "dataUri",
              args: {
                options: e
              }
            });
          },
          validate: function validate(e, t, _ref51) {
            var r = _ref51.options;
            var s = e.match(p.dataUriRegex);

            if (s) {
              if (!s[2]) return e;
              if ("base64" !== s[2]) return e;
              if (p.base64Regex[r.paddingRequired].false.test(s[3])) return e;
            }

            return t.error("string.dataUri");
          }
        },
        domain: {
          method: function method(e) {
            e && d.assertOptions(e, ["allowUnicode", "minDomainSegments", "tlds"]);
            var t = p.addressOptions(e);
            return this.$_addRule({
              name: "domain",
              args: {
                options: e
              },
              address: t
            });
          },
          validate: function validate(e, t, r, _ref52) {
            var s = _ref52.address;
            return i.isValid(e, s) ? e : t.error("string.domain");
          }
        },
        email: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            d.assertOptions(e, ["allowUnicode", "ignoreLength", "minDomainSegments", "multiple", "separator", "tlds"]), a(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
            var t = p.addressOptions(e),
                r = new RegExp("\\s*[".concat(e.separator ? u(e.separator) : ",", "]\\s*"));
            return this.$_addRule({
              name: "email",
              args: {
                options: e
              },
              regex: r,
              address: t
            });
          },
          validate: function validate(e, t, _ref53, _ref54) {
            var r = _ref53.options;
            var s = _ref54.regex,
                n = _ref54.address;
            var o = r.multiple ? e.split(s) : [e],
                a = [];
            var _iteratorNormalCompletion105 = true;
            var _didIteratorError105 = false;
            var _iteratorError105 = undefined;

            try {
              for (var _iterator105 = o[Symbol.iterator](), _step105; !(_iteratorNormalCompletion105 = (_step105 = _iterator105.next()).done); _iteratorNormalCompletion105 = true) {
                var _e84 = _step105.value;
                l.isValid(_e84, n) || a.push(_e84);
              }
            } catch (err) {
              _didIteratorError105 = true;
              _iteratorError105 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion105 && _iterator105.return != null) {
                  _iterator105.return();
                }
              } finally {
                if (_didIteratorError105) {
                  throw _iteratorError105;
                }
              }
            }

            return a.length ? t.error("string.email", {
              value: e,
              invalids: a
            }) : e;
          }
        },
        guid: {
          alias: "uuid",
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            d.assertOptions(e, ["version"]);
            var t = "";

            if (e.version) {
              var _r75 = [].concat(e.version);

              a(_r75.length >= 1, "version must have at least 1 valid version specified");

              var _s46 = new Set();

              for (var _e85 = 0; _e85 < _r75.length; ++_e85) {
                var _n42 = _r75[_e85];
                a("string" == typeof _n42, "version at position " + _e85 + " must be a string");

                var _o34 = p.guidVersions[_n42.toLowerCase()];

                a(_o34, "version at position " + _e85 + " must be one of " + Object.keys(p.guidVersions).join(", ")), a(!_s46.has(_o34), "version at position " + _e85 + " must not be a duplicate"), t += _o34, _s46.add(_o34);
              }
            }

            var r = new RegExp("^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[".concat(t || "0-9A-F", "][0-9A-F]{3}\\2?[").concat(t ? "89AB" : "0-9A-F", "][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$"), "i");
            return this.$_addRule({
              name: "guid",
              args: {
                options: e
              },
              regex: r
            });
          },
          validate: function validate(e, t, r, _ref55) {
            var s = _ref55.regex;
            var n = s.exec(e);
            return n ? p.guidBrackets[n[1]] !== n[n.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
          }
        },
        hex: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return d.assertOptions(e, ["byteAligned"]), e = n({
              byteAligned: !1
            }, e), a("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
              name: "hex",
              args: {
                options: e
              }
            });
          },
          validate: function validate(e, t, _ref56) {
            var r = _ref56.options;
            return p.hexRegex.test(e) ? r.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex");
          }
        },
        hostname: {
          method: function method() {
            return this.$_addRule("hostname");
          },
          validate: function validate(e, t) {
            return i.isValid(e, {
              minDomainSegments: 1
            }) || p.ipRegex.test(e) ? e : t.error("string.hostname");
          }
        },
        insensitive: {
          method: function method() {
            return this.$_setFlag("insensitive", !0);
          }
        },
        ip: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            d.assertOptions(e, ["cidr", "version"]);

            var _c$regex = c.regex(e),
                t = _c$regex.cidr,
                r = _c$regex.versions,
                s = _c$regex.regex,
                n = e.version ? r : void 0;

            return this.$_addRule({
              name: "ip",
              args: {
                options: {
                  cidr: t,
                  version: n
                }
              },
              regex: s
            });
          },
          validate: function validate(e, t, _ref57, _ref58) {
            var r = _ref57.options;
            var s = _ref58.regex;
            return s.test(e) ? e : r.version ? t.error("string.ipVersion", {
              value: e,
              cidr: r.cidr,
              version: r.version
            }) : t.error("string.ip", {
              value: e,
              cidr: r.cidr
            });
          }
        },
        isoDate: {
          method: function method() {
            return this.$_addRule("isoDate");
          },
          validate: function validate(e, _ref59) {
            var t = _ref59.error;
            return p.isoDate(e) ? e : t("string.isoDate");
          }
        },
        isoDuration: {
          method: function method() {
            return this.$_addRule("isoDuration");
          },
          validate: function validate(e, t) {
            return p.isoDurationRegex.test(e) ? e : t.error("string.isoDuration");
          }
        },
        length: {
          method: function method(e, t) {
            return p.length(this, "length", e, "=", t);
          },
          validate: function validate(e, t, _ref60, _ref61) {
            var r = _ref60.limit,
                s = _ref60.encoding;
            var n = _ref61.name,
                o = _ref61.operator,
                a = _ref61.args;
            var i = !s && e.length;
            return d.compare(i, r, o) ? e : t.error("string." + n, {
              limit: a.limit,
              value: e,
              encoding: s
            });
          },
          args: [{
            name: "limit",
            ref: !0,
            assert: d.limit,
            message: "must be a positive integer"
          }, "encoding"]
        },
        lowercase: {
          method: function method() {
            return this.case("lower");
          }
        },
        max: {
          method: function method(e, t) {
            return p.length(this, "max", e, "<=", t);
          },
          args: ["limit", "encoding"]
        },
        min: {
          method: function method(e, t) {
            return p.length(this, "min", e, ">=", t);
          },
          args: ["limit", "encoding"]
        },
        normalize: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "NFC";
            return a(p.normalizationForms.includes(e), "normalization form must be one of " + p.normalizationForms.join(", ")), this.$_addRule({
              name: "normalize",
              args: {
                form: e
              }
            });
          },
          validate: function validate(e, _ref62, _ref63) {
            var t = _ref62.error;
            var r = _ref63.form;
            return e === e.normalize(r) ? e : t("string.normalize", {
              value: e,
              form: r
            });
          },
          convert: !0
        },
        pattern: {
          alias: "regex",
          method: function method(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            a(e instanceof RegExp, "regex must be a RegExp"), a(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
              name: t
            }), d.assertOptions(t, ["invert", "name"]);
            var r = ["string.pattern", t.invert ? ".invert" : "", t.name ? ".name" : ".base"].join("");
            return this.$_addRule({
              name: "pattern",
              args: {
                regex: e,
                options: t
              },
              errorCode: r
            });
          },
          validate: function validate(e, t, _ref64, _ref65) {
            var r = _ref64.regex,
                s = _ref64.options;
            var n = _ref65.errorCode;
            return r.test(e) ^ s.invert ? e : t.error(n, {
              name: s.name,
              regex: r,
              value: e
            });
          },
          args: ["regex", "options"],
          multi: !0
        },
        replace: {
          method: function method(e, t) {
            "string" == typeof e && (e = new RegExp(u(e), "g")), a(e instanceof RegExp, "pattern must be a RegExp"), a("string" == typeof t, "replacement must be a String");
            var r = this.clone();
            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
              pattern: e,
              replacement: t
            }), r;
          }
        },
        token: {
          method: function method() {
            return this.$_addRule("token");
          },
          validate: function validate(e, t) {
            return /^\w+$/.test(e) ? e : t.error("string.token");
          }
        },
        trim: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
              name: "trim",
              args: {
                enabled: e
              }
            });
          },
          validate: function validate(e, t, _ref66) {
            var r = _ref66.enabled;
            return r && e !== e.trim() ? t.error("string.trim") : e;
          },
          convert: !0
        },
        truncate: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
          }
        },
        uppercase: {
          method: function method() {
            return this.case("upper");
          }
        },
        uri: {
          method: function method() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            d.assertOptions(e, ["allowRelative", "allowQuerySquareBrackets", "domain", "relativeOnly", "scheme"]), e.domain && d.assertOptions(e.domain, ["allowUnicode", "minDomainSegments", "tlds"]);

            var _m$regex = m.regex(e),
                t = _m$regex.regex,
                r = _m$regex.scheme,
                s = e.domain ? p.addressOptions(e.domain) : null;

            return this.$_addRule({
              name: "uri",
              args: {
                options: e
              },
              regex: t,
              domain: s,
              scheme: r
            });
          },
          validate: function validate(e, t, _ref67, _ref68) {
            var r = _ref67.options;
            var s = _ref68.regex,
                n = _ref68.domain,
                o = _ref68.scheme;
            if (["http:/", "https:/"].includes(e)) return t.error("string.uri");
            var a = s.exec(e);
            return a ? n && !i.isValid(a[1], n) ? t.error("string.domain", {
              value: a[1]
            }) : e : r.relativeOnly ? t.error("string.uriRelativeOnly") : r.scheme ? t.error("string.uriCustomScheme", {
              scheme: o,
              value: e
            }) : t.error("string.uri");
          }
        }
      },
      manifest: {
        build: function build(e, t) {
          if (t.replacements) {
            var _iteratorNormalCompletion106 = true;
            var _didIteratorError106 = false;
            var _iteratorError106 = undefined;

            try {
              for (var _iterator106 = t.replacements[Symbol.iterator](), _step106; !(_iteratorNormalCompletion106 = (_step106 = _iterator106.next()).done); _iteratorNormalCompletion106 = true) {
                var _step106$value = _step106.value,
                    _r76 = _step106$value.pattern,
                    _s47 = _step106$value.replacement;
                e = e.replace(_r76, _s47);
              }
            } catch (err) {
              _didIteratorError106 = true;
              _iteratorError106 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion106 && _iterator106.return != null) {
                  _iterator106.return();
                }
              } finally {
                if (_didIteratorError106) {
                  throw _iteratorError106;
                }
              }
            }
          }

          return e;
        }
      },
      messages: {
        "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
        "string.base": "{{#label}} must be a string",
        "string.base64": "{{#label}} must be a valid base64 string",
        "string.creditCard": "{{#label}} must be a credit card",
        "string.dataUri": "{{#label}} must be a valid dataUri string",
        "string.domain": "{{#label}} must contain a valid domain name",
        "string.email": "{{#label}} must be a valid email",
        "string.empty": "{{#label}} is not allowed to be empty",
        "string.guid": "{{#label}} must be a valid GUID",
        "string.hex": "{{#label}} must only contain hexadecimal characters",
        "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
        "string.hostname": "{{#label}} must be a valid hostname",
        "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
        "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
        "string.isoDate": "{{#label}} must be in iso format",
        "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
        "string.length": "{{#label}} length must be {{#limit}} characters long",
        "string.lowercase": "{{#label}} must only contain lowercase characters",
        "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
        "string.min": "{{#label}} length must be at least {{#limit}} characters long",
        "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
        "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
        "string.pattern.base": '{{#label}} with value "{[.]}" fails to match the required pattern: {{#regex}}',
        "string.pattern.name": '{{#label}} with value "{[.]}" fails to match the {{#name}} pattern',
        "string.pattern.invert.base": '{{#label}} with value "{[.]}" matches the inverted pattern: {{#regex}}',
        "string.pattern.invert.name": '{{#label}} with value "{[.]}" matches the inverted {{#name}} pattern',
        "string.trim": "{{#label}} must not have leading or trailing whitespace",
        "string.uri": "{{#label}} must be a valid uri",
        "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
        "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
        "string.uppercase": "{{#label}} must only contain uppercase characters"
      }
    }), p.addressOptions = function (e) {
      if (!e) return e;
      if (a(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), !1 === e.tlds) return e;
      if (!0 === e.tlds || void 0 === e.tlds) return a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds);
      a("object" == typeof e.tlds, "tlds must be true, false, or an object");
      var t = e.tlds.deny;
      if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
        tlds: {
          deny: new Set(t)
        }
      })), a(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), a(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), e;
      var r = e.tlds.allow;
      return r ? !0 === r ? (a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
        tlds: {
          allow: new Set(r)
        }
      })), a(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), e) : e;
    }, p.isoDate = function (e) {
      if (!d.isIsoDate(e)) return null;
      var t = new Date(e);
      return isNaN(t.getTime()) ? null : t.toISOString();
    }, p.length = function (e, t, r, s, n) {
      return a(!n || !1, "Invalid encoding:", n), e.$_addRule({
        name: t,
        method: "length",
        args: {
          limit: r,
          encoding: n
        },
        operator: s
      });
    };
  }, function (e, t, r) {
    "use strict";

    var s = r(24),
        n = r(23),
        o = r(25),
        a = {
      nonAsciiRx: /[^\x00-\x7f]/,
      encoder: new (s.TextEncoder || TextEncoder)()
    };
    t.analyze = function (e, t) {
      return a.email(e, t);
    }, t.isValid = function (e, t) {
      return !a.email(e, t);
    }, a.email = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
      if (!e) return o.code("EMPTY_STRING");
      var r = !a.nonAsciiRx.test(e);

      if (!r) {
        if (!1 === t.allowUnicode) return o.code("FORBIDDEN_UNICODE");
        e = e.normalize("NFC");
      }

      var s = e.split("@");
      if (2 !== s.length) return s.length > 2 ? o.code("MULTIPLE_AT_CHAR") : o.code("MISSING_AT_CHAR");

      var _s48 = _slicedToArray(s, 2),
          i = _s48[0],
          l = _s48[1];

      if (!i) return o.code("EMPTY_LOCAL");

      if (!t.ignoreLength) {
        if (e.length > 254) return o.code("ADDRESS_TOO_LONG");
        if (a.encoder.encode(i).length > 64) return o.code("LOCAL_TOO_LONG");
      }

      return a.local(i, r) || n.analyze(l, t);
    }, a.local = function (e, t) {
      var r = e.split(".");
      var _iteratorNormalCompletion107 = true;
      var _didIteratorError107 = false;
      var _iteratorError107 = undefined;

      try {
        for (var _iterator107 = r[Symbol.iterator](), _step107; !(_iteratorNormalCompletion107 = (_step107 = _iterator107.next()).done); _iteratorNormalCompletion107 = true) {
          var _e86 = _step107.value;
          if (!_e86.length) return o.code("EMPTY_LOCAL_SEGMENT");

          if (t) {
            if (!a.atextRx.test(_e86)) return o.code("INVALID_LOCAL_CHARS");
          } else {
            var _iteratorNormalCompletion108 = true;
            var _didIteratorError108 = false;
            var _iteratorError108 = undefined;

            try {
              for (var _iterator108 = _e86[Symbol.iterator](), _step108; !(_iteratorNormalCompletion108 = (_step108 = _iterator108.next()).done); _iteratorNormalCompletion108 = true) {
                var _t84 = _step108.value;
                if (a.atextRx.test(_t84)) continue;

                var _e87 = a.binary(_t84);

                if (!a.atomRx.test(_e87)) return o.code("INVALID_LOCAL_CHARS");
              }
            } catch (err) {
              _didIteratorError108 = true;
              _iteratorError108 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion108 && _iterator108.return != null) {
                  _iterator108.return();
                }
              } finally {
                if (_didIteratorError108) {
                  throw _iteratorError108;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError107 = true;
        _iteratorError107 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion107 && _iterator107.return != null) {
            _iterator107.return();
          }
        } finally {
          if (_didIteratorError107) {
            throw _iteratorError107;
          }
        }
      }
    }, a.binary = function (e) {
      return Array.from(a.encoder.encode(e)).map(function (e) {
        return String.fromCharCode(e);
      }).join("");
    }, a.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, a.atomRx = new RegExp(["(?:[\\xc2-\\xdf][\\x80-\\xbf])", "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})", "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"].join("|"));
  }, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(26);

    t.regex = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
      var t = e.cidr ? e.cidr.toLowerCase() : "optional";
      s(["required", "optional", "forbidden"].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
      var r = e.version || ["ipv4", "ipv6", "ipvfuture"];
      Array.isArray(r) || (r = [r]), s(r.length >= 1, "options.version must have at least 1 version specified");

      for (var _e88 = 0; _e88 < r.length; ++_e88) {
        s("string" == typeof r[_e88], "options.version must only contain strings"), r[_e88] = r[_e88].toLowerCase(), s(["ipv4", "ipv6", "ipvfuture"].includes(r[_e88]), "options.version contains unknown version " + r[_e88] + " - must be one of ipv4, ipv6, ipvfuture");
      }

      r = Array.from(new Set(r));
      var o = r.map(function (e) {
        if ("forbidden" === t) return n.ip[e];
        var r = "\\/".concat("ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr);
        return "required" === t ? "".concat(n.ip[e]).concat(r) : "".concat(n.ip[e], "(?:").concat(r, ")?");
      }),
          a = "(?:".concat(o.join("|"), ")"),
          i = new RegExp("^".concat(a, "$"));
      return {
        cidr: t,
        versions: r,
        regex: i,
        raw: a
      };
    };
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    var s = r(0),
        n = r(3),
        o = {};
    o.Map =
    /*#__PURE__*/
    function (_Map) {
      _inherits(_class18, _Map);

      function _class18() {
        _classCallCheck(this, _class18);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
      }

      _createClass(_class18, [{
        key: "slice",
        value: function slice() {
          return new o.Map(this);
        }
      }]);

      return _class18;
    }(_wrapNativeSuper(Map)), e.exports = n.extend({
      type: "symbol",
      terms: {
        map: {
          init: new o.Map()
        }
      },
      coerce: {
        method: function method(e, _ref69) {
          var t = _ref69.schema,
              r = _ref69.error;
          var s = t.$_terms.map.get(e);
          return s && (e = s), t._flags.only && "symbol" != typeof e ? {
            value: e,
            errors: r("symbol.map", {
              map: t.$_terms.map
            })
          } : {
            value: e
          };
        }
      },
      validate: function validate(e, _ref70) {
        var t = _ref70.error;
        if ("symbol" != typeof e) return {
          value: e,
          errors: t("symbol.base")
        };
      },
      rules: {
        map: {
          method: function method(e) {
            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
            var t = this.clone(),
                r = [];
            var _iteratorNormalCompletion109 = true;
            var _didIteratorError109 = false;
            var _iteratorError109 = undefined;

            try {
              for (var _iterator109 = e[Symbol.iterator](), _step109; !(_iteratorNormalCompletion109 = (_step109 = _iterator109.next()).done); _iteratorNormalCompletion109 = true) {
                var _n43 = _step109.value;
                s(_n43 && _n43[Symbol.iterator], "Entry must be an iterable");

                var _n44 = _slicedToArray(_n43, 2),
                    _e89 = _n44[0],
                    _o35 = _n44[1];

                s("object" != typeof _e89 && "function" != typeof _e89 && "symbol" != typeof _e89, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof _o35, "Value must be a Symbol"), t.$_terms.map.set(_e89, _o35), r.push(_o35);
              }
            } catch (err) {
              _didIteratorError109 = true;
              _iteratorError109 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion109 && _iterator109.return != null) {
                  _iterator109.return();
                }
              } finally {
                if (_didIteratorError109) {
                  throw _iteratorError109;
                }
              }
            }

            return t.valid.apply(t, r);
          }
        }
      },
      manifest: {
        build: function build(e, t) {
          return t.map && (e = e.map(t.map)), e;
        }
      },
      messages: {
        "symbol.base": "{{#label}} must be a symbol",
        "symbol.map": "{{#label}} must be one of {{#map}}"
      }
    });
  }]);
});